
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7qvmT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $caRYB = parcelRequire("caRYB");

var $bAT9l = parcelRequire("bAT9l");

var $2FFuS = parcelRequire("2FFuS");

var $aoDcQ = parcelRequire("aoDcQ");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $ag51I = parcelRequire("ag51I");


var $2eC70 = parcelRequire("2eC70");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $g0DaR = parcelRequire("g0DaR");

var $8dA1U = parcelRequire("8dA1U");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $f5Wgm = parcelRequire("f5Wgm");


var $87CZC = parcelRequire("87CZC");


var $8i27m = parcelRequire("8i27m");


var $ibqdE = parcelRequire("ibqdE");

/**
 * @generated SignedSource<<8d0925016cb505d7856227fcee0bc937>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $fa7a458b6cf5b633$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $fa7a458b6cf5b633$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $fa7a458b6cf5b633$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});


const $8067e644a2744f7c$export$1d3bc594360cbf99 = 0;
const $8067e644a2744f7c$export$b163e25988b267ba = 2;
const $8067e644a2744f7c$export$36062d4a94e50365 = 3;
const $8067e644a2744f7c$export$d7989e622f70691f = 5;
const $8067e644a2744f7c$export$dacdf058f0aa9bd4 = 4;
const $8067e644a2744f7c$var$shouldTriggerCommentScroll = (event, id)=>{
    if (!id) return false;
    const target = event.target;
    const isContainer = target === event.currentTarget;
    const isCommentBody = Boolean(target.closest(`[data-testid="comment-thread-${id}-parent"]`));
    const isCommentReplyBody = Boolean(target.closest(`[data-testid="comment-thread-${id}-reply-list"]`));
    const replyToggler = Boolean(target.closest('[data-testid="replies-toggler-container"]'));
    // Don't trigger if clicking on specific interactive elements
    const isInteractiveElement = Boolean(target.closest('button, a, input, textarea, [role="button"]'));
    const isEmojiElement = Boolean(target.closest('[data-testid="emoji-add-icon"], [data-emoji-short-name]'));
    const isGeneralReplyScroller = Boolean(target.closest('[data-testid="comments-panel-reply-scroller-container"]'));
    const isFooterCommentThreadLoaded = Boolean(document.getElementById(`footer-comment-thread-${id}-container`));
    // NOTE - handles scrolling in place of the general reply scroller when the footer comment thread is not yet in the DOM
    // This is a temporary solution until we update our data loading patterns. Once they're updated, this will always be false and can be removed.
    const scrollInPlaceOfGeneralReplyScroller = isGeneralReplyScroller && !isFooterCommentThreadLoaded && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    return (isContainer || isCommentBody || isCommentReplyBody || replyToggler || isGeneralReplyScroller) && (!isInteractiveElement || scrollInPlaceOfGeneralReplyScroller) && !isEmojiElement;
};
const $8067e644a2744f7c$export$8648ea63d9b37934 = (numberOfReplies, isStandaloneComment = false, isParentCommentClosedOrDangling = false)=>{
    if (isParentCommentClosedOrDangling && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) return $8067e644a2744f7c$export$1d3bc594360cbf99;
    if (isStandaloneComment && numberOfReplies <= $8067e644a2744f7c$export$d7989e622f70691f) return $8067e644a2744f7c$export$d7989e622f70691f;
    if ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) return numberOfReplies >= $8067e644a2744f7c$export$dacdf058f0aa9bd4 ? $8067e644a2744f7c$export$b163e25988b267ba : $8067e644a2744f7c$export$36062d4a94e50365;
    return $8067e644a2744f7c$export$b163e25988b267ba;
};
const $8067e644a2744f7c$export$4ce0bedef4e84bb7 = (isInlineComment)=>isInlineComment ? (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE) : (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE);
const $8067e644a2744f7c$export$cda46aad7dff898a = ({ parentComment: parentComment, pageMode: pageMode, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, scrollCommentsPanelToThread: scrollCommentsPanelToThread, eventEmitter: eventEmitter, event: event, handleSelectThread: handleSelectThread })=>{
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef : parentComment.id;
    const isResolved = !parentComment.isOpen;
    // Send a message via bridge api if applicable
    if (threadKey && handleSelectThread) handleSelectThread(threadKey);
    $8067e644a2744f7c$export$e80247d0f3d89e0({
        threadKey: threadKey,
        isResolved: isResolved,
        pageMode: pageMode,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        eventEmitter: eventEmitter,
        commentType: parentComment.type,
        scrollCommentsPanelToThread: scrollCommentsPanelToThread,
        shouldScrollCommentsPanel: true,
        event: event,
        id: parentComment.id
    });
};
const $8067e644a2744f7c$export$e80247d0f3d89e0 = ({ threadKey: threadKey, isResolved: isResolved, pageMode: pageMode, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, eventEmitter: eventEmitter, commentType: commentType, scrollCommentsPanelToThread: scrollCommentsPanelToThread, shouldScrollCommentsPanel: shouldScrollCommentsPanel = false, event: event, id: id, hasKeyPressed: hasKeyPressed })=>{
    // We only scroll the document for non-resolved inline comments or page comments
    if (threadKey && !isResolved) {
        if (event && !$8067e644a2744f7c$var$shouldTriggerCommentScroll(event, id)) setCurrentlySelectedThreadKey(threadKey);
        else setCurrentlySelectedThreadKey(threadKey, commentType);
        if (commentType === (0, $8i27m.CommentType).INLINE) {
            const commentElement = document.getElementById(threadKey);
            if (commentElement) {
                if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                    // Determine navigation context based on page mode
                    const navigationContext = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER;
                    (0, $9FoVw.handleInlineAnnotationNavigation)({
                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                        context: navigationContext,
                        block: 'center',
                        inline: 'nearest',
                        markElement: commentElement,
                        annotationId: threadKey
                    });
                } else if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) {
                    (event && $8067e644a2744f7c$var$shouldTriggerCommentScroll(event, id) || hasKeyPressed) && (0, $i49vP.checkElementExpandInEditor)(commentElement);
                    (0, $i49vP.scrollToElementInEditor)({
                        targetElement: commentElement,
                        viewingRoomOffset: -300
                    });
                    eventEmitter?.emit('setselectedannotation', threadKey);
                } else {
                    eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: threadKey
                    });
                    if (event && $8067e644a2744f7c$var$shouldTriggerCommentScroll(event, id) || hasKeyPressed) (0, $aHcFH.scrollCommentIntoView)({
                        commentElement: commentElement,
                        isFabricPage: true,
                        useInstantScroll: false,
                        commentThreadAnnotationId: threadKey,
                        isCommentsPanel: true,
                        scrollCommentsPanelToThread: scrollCommentsPanelToThread,
                        shouldScrollCommentsPanel: shouldScrollCommentsPanel
                    });
                }
            }
        } else if (commentType === (0, $8i27m.CommentType).GENERAL) (0, $9FoVw.handleFooterCommentsNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            inline: 'nearest',
            commentId: threadKey
        });
        // Handle case where a comment is never clicked but is still selected via KB shortcuts
        if (shouldScrollCommentsPanel && scrollCommentsPanelToThread) {
            if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                if (!(0, $9wGTI.fg)('confluence_comments_unified_navigation')) scrollCommentsPanelToThread({
                    annotationId: threadKey,
                    commentType: commentType,
                    hasKeyPressed: hasKeyPressed
                });
            }
        }
    }
};
// Build mutation options for creating replies, split by reply kind to keep the main flow concise
const $8067e644a2744f7c$var$buildInlineReplyOptions = ({ pageId: pageId, parentCommentId: parentCommentId, adf: adf, isEditor: isEditor, pageMode: pageMode, threadKey: threadKey, includeReactionsFlag: includeReactionsFlag })=>({
        variables: {
            input: {
                containerId: pageId,
                parentCommentId: parentCommentId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                createdFrom: (0, $g0DaR.getCommentCreationLocation)(isEditor, pageMode === (0, $cD1qu.PageMode).LIVE)
            },
            pageId: pageId,
            includeReactions: includeReactionsFlag
        },
        update: (0, $g0DaR.updateApolloCacheCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            annotationId: threadKey
        }, parentCommentId)
    });
const $8067e644a2744f7c$var$buildGeneralReplyOptions = ({ pageId: pageId, cloudId: cloudId, parentCommentId: parentCommentId, adf: adf, includeReactionsFlag: includeReactionsFlag, isReactionsEnabled: isReactionsEnabled })=>({
        variables: {
            pageId: pageId,
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $fa7a458b6cf5b633$export$2dffd0b5373a4389).WEB,
                containerId: pageId,
                parentCommentId: parentCommentId
            },
            includeReactions: includeReactionsFlag
        },
        update: (0, $87CZC.updateApolloCacheReplyCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            type: [
                (0, $f5Wgm.CommentType).FOOTER
            ]
        }, parentCommentId, isReactionsEnabled)
    });
const $8067e644a2744f7c$export$e898411b6bdaedf3 = ({ pageId: pageId, cloudId: cloudId, parentCommentId: parentCommentId, adf: adf, addCommentInCommentsDataManagerCacheFn: addCommentInCommentsDataManagerCacheFn, experienceTracker: experienceTracker, isInlineComment: isInlineComment })=>({
        variables: {
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $fa7a458b6cf5b633$export$2dffd0b5373a4389).WEB,
                containerId: pageId,
                parentCommentId: parentCommentId
            },
            pageId: pageId
        },
        update: (...params)=>{
            const [_dataProxy, mutationResult] = params;
            addCommentInCommentsDataManagerCacheFn?.({
                newComment: (0, $ag51I.addEmptyObjectRepliesArray)(mutationResult.data.createFooterComment),
                onError: (error)=>{
                    (0, $8dA1U.handleMutationFailure)({
                        experienceTracker: experienceTracker,
                        experienceName: $8067e644a2744f7c$export$4ce0bedef4e84bb7(isInlineComment),
                        error: error,
                        commentId: parentCommentId,
                        shouldReturnError: true
                    });
                }
            });
        }
    });
const $8067e644a2744f7c$var$buildFooterReplyOptions = ({ pageId: pageId, cloudId: cloudId, parentCommentId: parentCommentId, adf: adf, isReactionsEnabled: isReactionsEnabled })=>({
        variables: {
            pageId: pageId,
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $fa7a458b6cf5b633$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $fa7a458b6cf5b633$export$2dffd0b5373a4389).WEB,
                containerId: pageId,
                parentCommentId: parentCommentId
            }
        },
        update: (0, $87CZC.updateApolloCacheReplyCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            type: [
                (0, $f5Wgm.CommentType).FOOTER
            ]
        }, parentCommentId, isReactionsEnabled)
    });
const $8067e644a2744f7c$export$56ed0d504fa641dd = async ({ pageId: pageId, parentCommentId: parentCommentId, cloudId: cloudId, adf: adf, onSuccess: onSuccess, pageMode: pageMode, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, createAnalyticsEvent: createAnalyticsEvent, pageType: pageType, experienceTracker: experienceTracker, createInlineReplyFn: createInlineReplyFn, createGeneralReplyFn: createGeneralReplyFn, createObjectReplyFn: createObjectReplyFn, addCommentInCommentsDataManagerCacheFn: addCommentInCommentsDataManagerCacheFn, createFooterReplyFn: createFooterReplyFn, selectedAnnotation: selectedAnnotation, addReplyToCommentThread: addReplyToCommentThread, threadKey: threadKey, updateReadCommentsListState: updateReadCommentsListState, commentType: commentType, searchSessionId: searchSessionId, isReactionsEnabled: isReactionsEnabled, analyticsSource: analyticsSource, contentTypesCommentService: contentTypesCommentService, isFooterComment: isFooterComment, setReplyToCommentId: setReplyToCommentId, resetContentChanged: resetContentChanged, setReplyView: setReplyView })=>{
    const isInlineComment = commentType === (0, $8i27m.CommentType).INLINE;
    const isEditor = pageMode === (0, $cD1qu.PageMode).EDIT;
    let startExperienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE);
    if (!isInlineComment) startExperienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE);
    experienceTracker.start({
        name: startExperienceName,
        timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
        attributes: (0, $2eC70.getCommentsDataManagerExperimentAttributes)()
    });
    let createReplyPromise = undefined;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        // New path - improved logic + Comments Data Manager support
        if (isInlineComment) createReplyPromise = createInlineReplyFn?.($8067e644a2744f7c$var$buildInlineReplyOptions({
            pageId: pageId,
            parentCommentId: parentCommentId,
            adf: adf,
            isEditor: isEditor,
            pageMode: pageMode,
            threadKey: threadKey,
            includeReactionsFlag: false
        }), (error)=>{
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: $8067e644a2744f7c$export$4ce0bedef4e84bb7(isInlineComment),
                error: error,
                commentId: parentCommentId,
                shouldReturnError: true
            });
        });
        else if (createObjectReplyFn) // The createObjectReplyFn takes precedence over other non-inline (footer or general) reply
        // functions, if it was provided
        createReplyPromise = createObjectReplyFn($8067e644a2744f7c$export$e898411b6bdaedf3({
            pageId: pageId,
            cloudId: cloudId,
            parentCommentId: parentCommentId,
            adf: adf,
            addCommentInCommentsDataManagerCacheFn: addCommentInCommentsDataManagerCacheFn,
            experienceTracker: experienceTracker,
            isInlineComment: isInlineComment
        }));
        else if (isFooterComment) createReplyPromise = createFooterReplyFn?.($8067e644a2744f7c$var$buildFooterReplyOptions({
            pageId: pageId,
            cloudId: cloudId,
            parentCommentId: parentCommentId,
            adf: adf,
            isReactionsEnabled: isReactionsEnabled
        }));
        else createReplyPromise = createGeneralReplyFn?.($8067e644a2744f7c$var$buildGeneralReplyOptions({
            pageId: pageId,
            cloudId: cloudId,
            parentCommentId: parentCommentId,
            adf: adf,
            includeReactionsFlag: false,
            isReactionsEnabled: isReactionsEnabled
        }));
    } else // Legacy path - use old logic
    createReplyPromise = isInlineComment ? createInlineReplyFn && createInlineReplyFn($8067e644a2744f7c$var$buildInlineReplyOptions({
        pageId: pageId,
        parentCommentId: parentCommentId,
        adf: adf,
        isEditor: isEditor,
        pageMode: pageMode,
        threadKey: threadKey,
        includeReactionsFlag: false
    }), ()=>{}) : isFooterComment ? createFooterReplyFn && createFooterReplyFn($8067e644a2744f7c$var$buildFooterReplyOptions({
        pageId: pageId,
        cloudId: cloudId,
        parentCommentId: parentCommentId,
        adf: adf,
        isReactionsEnabled: isReactionsEnabled
    })) : createGeneralReplyFn && createGeneralReplyFn($8067e644a2744f7c$var$buildGeneralReplyOptions({
        pageId: pageId,
        cloudId: cloudId,
        parentCommentId: parentCommentId,
        adf: adf,
        includeReactionsFlag: false,
        isReactionsEnabled: isReactionsEnabled
    }));
    return createReplyPromise && createReplyPromise.then(({ data: data })=>{
        const replyResult = isInlineComment ? data.replyInlineComment : data.createFooterComment;
        const reply = {
            isUnread: false,
            type: isInlineComment ? (0, $8i27m.CommentType).INLINE : (0, $8i27m.CommentType).GENERAL,
            ...replyResult
        };
        updateReadCommentsListState((prev)=>new Set([
                ...prev,
                reply.id
            ]));
        addReplyToCommentThread(threadKey, reply, commentType);
        // Update content types comments if we are creating a reply on a different content type
        contentTypesCommentService?.onUpdateComment?.(threadKey);
        // Reset reply state after successful creation
        setReplyToCommentId({
            parentCommentId: undefined
        });
        resetContentChanged();
        setReplyView((0, $ibqdE.ViewReplyOptions).ALL);
        if (isInlineComment) (0, $g0DaR.handleCreateReplySuccess)({
            onSuccess: onSuccess,
            editCommentQueryId: editCommentQueryId,
            setCommentForEdit: setCommentForEdit,
            data: data,
            createAnalyticsEvent: createAnalyticsEvent,
            pageId: pageId,
            pageType: pageType,
            analyticsSource: analyticsSource,
            commentId: parentCommentId,
            pageMode: pageMode,
            selectedAnnotation: selectedAnnotation,
            getInlineNodeTypes: undefined,
            experienceTracker: experienceTracker,
            isEditor: isEditor
        });
        else (0, $87CZC.handleCreateReplySuccess)({
            onSuccess: onSuccess,
            editCommentQueryId: editCommentQueryId,
            setCommentForEdit: setCommentForEdit,
            data: data,
            createAnalyticsEvent: createAnalyticsEvent,
            pageId: pageId,
            pageType: pageType,
            analyticsSource: analyticsSource,
            commentId: parentCommentId,
            pageMode: pageMode,
            experienceTracker: experienceTracker,
            searchSessionId: searchSessionId,
            isFooterComment: isFooterComment
        });
    }).catch((error)=>{
        let failExperienceName;
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) failExperienceName = $8067e644a2744f7c$export$4ce0bedef4e84bb7(isInlineComment);
        else {
            failExperienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE);
            if (!isInlineComment) failExperienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE);
        }
        return (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: failExperienceName,
            error: error,
            commentId: parentCommentId,
            shouldReturnError: true
        });
    });
};
const $8067e644a2744f7c$export$1f10dc4c6b2440d5 = (comments, passThroughProps, CommentThreadComponent, transitionIndexWithinBatch)=>comments.map((parentComment, index)=>{
        const shouldRenderCommentTypeSeparator = index === transitionIndexWithinBatch;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CommentThreadComponent, {
            key: parentComment.id,
            parentComment: parentComment,
            shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator,
            ...passThroughProps
        });
    });
const $8067e644a2744f7c$export$d69a37e7380b7ce5 = (reply, hiddenReplies)=>{
    return hiddenReplies.some((hiddenReply)=>hiddenReply.id === reply.id && hiddenReply.isUnread);
};
const $8067e644a2744f7c$export$8f7e06942eb2440 = (numberOfReplies, isParentCommentResolvedOrDangling, isStandaloneComment = false)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) return (0, $ibqdE.ViewReplyOptions).DEFAULT;
    if (isParentCommentResolvedOrDangling) return (0, $ibqdE.ViewReplyOptions).HIDDEN;
    if (isStandaloneComment && (0, $9wGTI.fg)('confluence_comment_expand_all_standalone_replies') || numberOfReplies <= $8067e644a2744f7c$export$8648ea63d9b37934(numberOfReplies, isStandaloneComment)) return (0, $ibqdE.ViewReplyOptions).ALL;
    return (0, $ibqdE.ViewReplyOptions).LIMITED;
};
const $8067e644a2744f7c$export$f72e9aa74d51c544 = (replyToCommentUser)=>{
    if (!replyToCommentUser || !replyToCommentUser.displayName || !replyToCommentUser.accountId) return undefined;
    return (0, $caRYB.doc)((0, $2FFuS.paragraph)((0, $bAT9l.mention)({
        id: replyToCommentUser.accountId,
        text: `@${replyToCommentUser.displayName}`
    }), (0, $aoDcQ.text)(' ')));
};
module.exports["getDefaultNumVisibleReplies"] = $8067e644a2744f7c$export$8648ea63d9b37934;
module.exports["handleCommentThreadSelection"] = $8067e644a2744f7c$export$cda46aad7dff898a;
module.exports["handlePanelSelectionAndScroll"] = $8067e644a2744f7c$export$e80247d0f3d89e0;
module.exports["onSaveReply"] = $8067e644a2744f7c$export$56ed0d504fa641dd;
module.exports["getCommentThreadsToBatch"] = $8067e644a2744f7c$export$1f10dc4c6b2440d5;
module.exports["getDefaultReplyView"] = $8067e644a2744f7c$export$8f7e06942eb2440;
module.exports["getAdfForQuickReplyMention"] = $8067e644a2744f7c$export$f72e9aa74d51c544;

});

parcelRegister("g0DaR", function(module, exports) {

var $afGoD = parcelRequire("afGoD");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $9rE3H = parcelRequire("9rE3H");


var $eg9xl = parcelRequire("eg9xl");


var $irVI7 = parcelRequire("irVI7");


var $24amZ = parcelRequire("24amZ");


var $7W8i8 = parcelRequire("7W8i8");


var $56QzY = parcelRequire("56QzY");


var $9wGTI = parcelRequire("9wGTI");


var $en1dX = parcelRequire("en1dX");


var $2eC70 = parcelRequire("2eC70");


var $asNlu = parcelRequire("asNlu");

const $31423c43076595b5$var$logger = (0, $7W8i8.getLogger)('inline-comments-common');
const $31423c43076595b5$var$removeReplyFromCache = (parentComment, replyId)=>{
    if (parentComment) {
        // Remove the returned commentId from the cache and reset it
        const idxToRemove = parentComment.replies.findIndex((reply)=>reply?.id === replyId);
        if (idxToRemove !== -1) parentComment.replies.splice(idxToRemove, 1);
    }
};
const $31423c43076595b5$var$addReplyToCache = (parentComment, newData, isCommentsPanel)=>{
    if (!parentComment) return;
    const mutationResult = newData.replyInlineComment;
    // Ensure reactionsSummary exists to satisfy queries that select it
    if (!mutationResult?.reactionsSummary) mutationResult.reactionsSummary = $31423c43076595b5$export$21125dfd5f6a0f20;
    if (isCommentsPanel) parentComment.replies.push(mutationResult);
    else parentComment.replies.push(mutationResult);
};
const $31423c43076595b5$export$483f44f07b46ed25 = (actionType, queryVariables, parentCommentId, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        if ((0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) try {
            const commentsPanelVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: queryVariables.pageId
            });
            const commentsPanelResponse = cache.readQuery({
                query: (0, $eg9xl.ActiveCommentsQuery),
                variables: commentsPanelVariables
            });
            if (commentsPanelResponse) {
                const commentsPanelData = {
                    ...commentsPanelResponse
                };
                const commentsPanelParentComment = commentsPanelData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(commentsPanelParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(commentsPanelParentComment, result.data, true);
                }
                // Update the comments panel query
                cache.writeQuery({
                    query: (0, $eg9xl.ActiveCommentsQuery),
                    variables: commentsPanelVariables,
                    data: commentsPanelData
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const inlineQueryVariables = {
                ...queryVariables
            };
            const inlineCommentResponse = cache.readQuery({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: inlineQueryVariables
            });
            if (inlineCommentResponse) {
                const inlineCommentData = {
                    ...inlineCommentResponse
                };
                const inlineCommentsParentComment = inlineCommentData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (inlineCommentsParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(inlineCommentsParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(inlineCommentsParentComment, result.data);
                }
                // Update the inline comments
                cache.writeQuery({
                    query: (0, $3B9cR.InlineCommentQuery),
                    variables: inlineQueryVariables,
                    data: inlineCommentData
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating inline comments cache for ${actionType} reply - ${err}`;
        }
    };
const $31423c43076595b5$export$ad43a67c7ab9a6d6 = (actionType, queryVariables, parentCommentId, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        try {
            const standaloneCommentVariables = {
                pageId: queryVariables.pageId,
                contentStatus: queryVariables.contentStatus,
                inlineMarkerRefList: [
                    queryVariables.annotationId
                ]
            };
            const standaloneCommentResponse = cache.readQuery({
                query: (0, $1C8XP.ActiveInlineCommentsQuery),
                variables: standaloneCommentVariables
            });
            if (standaloneCommentResponse) {
                const standaloneCommentData = {
                    ...standaloneCommentResponse
                };
                const standaloneParentComment = standaloneCommentData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (standaloneParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(standaloneParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(standaloneParentComment, result.data, true);
                }
                // Update the comments panel query
                cache.writeQuery({
                    query: (0, $1C8XP.ActiveInlineCommentsQuery),
                    variables: standaloneCommentVariables,
                    data: standaloneCommentData
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
    };
const $31423c43076595b5$export$1859da3357bd460e = (isEditor, isLivePage)=>{
    if (isLivePage) return (0, $afGoD.CommentCreationLocation).LIVE;
    if (isEditor) return (0, $afGoD.CommentCreationLocation).EDITOR;
    return (0, $afGoD.CommentCreationLocation).RENDERER;
};
const $31423c43076595b5$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, selectedAnnotation: selectedAnnotation, getInlineNodeTypes: getInlineNodeTypes, experienceTracker: experienceTracker, isEditor: isEditor })=>{
    onSuccess();
    if (editCommentQueryId) setCommentForEdit('');
    const replyCommentInfo = data?.replyInlineComment;
    const markerRef = replyCommentInfo?.location?.inlineMarkerRef;
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            // The newly created comment ID
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                source: analyticsSource,
                commentType: (0, $en1dX.CommentType).INLINE,
                parentCommentId: commentId ?? null,
                // analytics event schema type expects string or null
                isReply: true,
                pageMode: pageMode,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                navdexPointType: (0, $56QzY.END),
                inlineNodeTypes: selectedAnnotation && getInlineNodeTypes ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                targetNodeType: (0, $asNlu.getTargetNodeType)(markerRef, isEditor)
            }
        }
    }).fire();
    experienceTracker.updateAttributes({
        name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE),
        attributes: {
            replyCommentId: replyCommentInfo?.id
        }
    });
    experienceTracker.succeed({
        name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
        attributes: {
            replyCommentId: replyCommentInfo?.id
        }
    });
};
const $31423c43076595b5$export$ca43168d5a4c3bfd = (allAnnotations, commentMarkerRef, previousOrderedActiveAnnotations, setOrderedActiveAnnotationIdList)=>{
    const indexInAnnotations = allAnnotations.indexOf(commentMarkerRef);
    if (indexInAnnotations === -1) throw new Error('Marker ref is not present in the annotations list');
    const insertIndex = previousOrderedActiveAnnotations.findIndex((annotation)=>allAnnotations.indexOf(annotation) > indexInAnnotations);
    const finalInsertIndex = insertIndex === -1 ? previousOrderedActiveAnnotations.length : insertIndex;
    const updatedOrderedActiveAnnotations = [
        ...previousOrderedActiveAnnotations.slice(0, finalInsertIndex),
        commentMarkerRef,
        ...previousOrderedActiveAnnotations.slice(finalInsertIndex)
    ];
    setOrderedActiveAnnotationIdList(updatedOrderedActiveAnnotations);
};
const $31423c43076595b5$export$cad0f7f0aeb719e7 = (inlineMarkerRef)=>{
    const tiny = `.inline-comment-marker[data-ref="${inlineMarkerRef}"]`;
    const fabricEditorAnnotation = `[id="${inlineMarkerRef}"][data-mark-annotation-type="inlineComment"]`;
    return Boolean(document.querySelector(`${tiny}, ${fabricEditorAnnotation}`));
};
const $31423c43076595b5$export$21125dfd5f6a0f20 = {
    ari: '',
    containerAri: '',
    reactionsCount: 0,
    reactionsSummaryForEmoji: [],
    __typename: 'ReactionsSummaryResponse'
};
const $31423c43076595b5$export$a5988be2401625e8 = (emojiId, actionType, objectId, pageId, selectedAnnotation, isArchived, cache)=>{
    try {
        const queryVariables = {
            pageId: pageId,
            inlineMarkerRefList: [
                selectedAnnotation.id
            ],
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        };
        const response = cache?.readQuery({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            variables: queryVariables
        });
        if (!response?.comments?.nodes?.[0]) return;
        const comment = response.comments.nodes[0];
        let cacheReactionsSummary;
        let reply;
        // If the comment matches the comment ID, use it's reactionsSummary
        if (comment.id === objectId) cacheReactionsSummary = comment.reactionsSummary ? {
            ...comment.reactionsSummary
        } : $31423c43076595b5$export$21125dfd5f6a0f20;
        else {
            // Otherwise, find the reply that matches
            reply = comment.replies.find((r)=>r?.id === objectId);
            if (reply) cacheReactionsSummary = reply.reactionsSummary ? {
                ...reply.reactionsSummary
            } : $31423c43076595b5$export$21125dfd5f6a0f20;
        }
        if (!cacheReactionsSummary) return;
        const reactionsAri = cacheReactionsSummary.ari || '';
        const reactionsContainerAri = cacheReactionsSummary.containerAri || '';
        let reactionsCount = cacheReactionsSummary.reactionsCount || 0;
        const updatedReactionsSummary = {
            ...cacheReactionsSummary
        };
        const updatedReactionsNodes = [
            ...cacheReactionsSummary.reactionsSummaryForEmoji || []
        ];
        if (actionType === 'add') {
            const reaction = updatedReactionsNodes.find((item)=>item?.emojiId === emojiId);
            // If reaction exists, update its attributes
            if (reaction && !reaction.reacted) {
                reaction.count++;
                reaction.reacted = true;
            } else {
                // Otherwise, create a new reaction
                const newReaction = {
                    emojiId: emojiId,
                    count: 1,
                    reacted: true,
                    id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`,
                    __typename: 'ReactionsSummaryForEmoji'
                };
                updatedReactionsNodes.push(newReaction);
            }
            ++reactionsCount;
        } else if (actionType === 'delete') {
            const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
            // If reaction exists, update its attributes
            if (reactionIdx !== -1) {
                const reaction = updatedReactionsNodes[reactionIdx];
                // If we have more than one reaction, remove our user from it and decrement the count
                if (reaction && reaction.count > 1) {
                    reaction.count--;
                    reaction.reacted = false;
                } else // Otherwise, remove the reaction entirely
                updatedReactionsNodes.splice(reactionIdx, 1);
                --reactionsCount;
            }
        }
        updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
        updatedReactionsSummary.reactionsCount = reactionsCount ?? 0;
        // Create a deep copy of the comment to ensure Apollo detects the change
        const updatedComment = {
            ...comment,
            replies: comment.replies.map((r)=>{
                if (r?.id === objectId) return {
                    ...r,
                    reactionsSummary: updatedReactionsSummary
                };
                return r;
            })
        };
        // Update the comment's reactionsSummary if it's the target comment
        if (comment.id === objectId) // @ts-ignore reactionsCount will always be defined, so the type comparison is wrong
        updatedComment.reactionsSummary = updatedReactionsSummary;
        const newData = {
            comments: {
                nodes: [
                    updatedComment
                ],
                __typename: 'PaginatedCommentList'
            }
        };
        cache?.writeQuery({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            variables: queryVariables,
            data: newData
        });
    } catch (err) {
        $31423c43076595b5$var$logger.error`An error occurred when updating reactions cache for ${actionType} - ${err}`;
    }
};
module.exports["defaultReactionsSummary"] = $31423c43076595b5$export$21125dfd5f6a0f20;
module.exports["updateApolloCacheCallback"] = $31423c43076595b5$export$483f44f07b46ed25;
module.exports["updateApolloCacheCallbackForGA"] = $31423c43076595b5$export$ad43a67c7ab9a6d6;
module.exports["getCommentCreationLocation"] = $31423c43076595b5$export$1859da3357bd460e;
module.exports["handleCreateReplySuccess"] = $31423c43076595b5$export$c94bffbead878776;
module.exports["insertReopenedCommentAnnotation"] = $31423c43076595b5$export$ca43168d5a4c3bfd;
module.exports["inlineCommentExists"] = $31423c43076595b5$export$cad0f7f0aeb719e7;
module.exports["updateReactionsCacheCallbackForGA"] = $31423c43076595b5$export$a5988be2401625e8;

});

parcelRegister("1C8XP", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $087454af48047e63$export$c9407390b0cf740d = (0, $eSUdr.default)`query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList pageId:$pageId contentStatus:$contentStatus){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}createdAt{value}createdAtNonLocalized replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`;
module.exports["ActiveInlineCommentsQuery"] = $087454af48047e63$export$c9407390b0cf740d;

});

parcelRegister("asNlu", function(module, exports) {

var $ag6aQ = parcelRequire("ag6aQ");

const $bbb444f37a1f1f7f$export$2f9714b3e1fdd309 = (annotationId, isEditor)=>{
    if (!annotationId) return 'unknown';
    const elementWithAnnotationWrapper = document.querySelector(`[id="${annotationId}"]`);
    if (!elementWithAnnotationWrapper) return 'unknown';
    const captionNode = elementWithAnnotationWrapper.closest('[data-media-caption]');
    if (captionNode) return 'caption';
    if (isEditor) {
        const mediaNode = elementWithAnnotationWrapper.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
        if (mediaNode) return 'media';
        // If no node is detected, return "text" as the default node type for now
        return 'text';
    } else {
        const targetNode = elementWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
        // If no node is detected, return "text" as the default node type for now
        return 'text';
    }
};
module.exports["getTargetNodeType"] = $bbb444f37a1f1f7f$export$2f9714b3e1fdd309;

});

parcelRegister("8dA1U", function(module, exports) {

var $21K7m = parcelRequire("21K7m");


var $e3kjM = parcelRequire("e3kjM");


var $7Sm4c = parcelRequire("7Sm4c");

const $8237d31e7e86c8c4$export$ae89b6b0e7b50e02 = {
    TASK_FAIL: 'taskFail',
    TASK_SUCCESS: 'taskSuccess',
    TASK_ABORT: 'taskAbort'
};



var $cD1qu = parcelRequire("cD1qu");


var $56QzY = parcelRequire("56QzY");


var $2eC70 = parcelRequire("2eC70");


var $en1dX = parcelRequire("en1dX");


var $isdzP = parcelRequire("isdzP");


var $kmHPt = parcelRequire("kmHPt");


var $asNlu = parcelRequire("asNlu");

const $ec302ec1fafac461$export$4c0ea2f40582e756 = ({ commentId: commentId, parentCommentMarkerRef: parentCommentMarkerRef, pageId: pageId, pageMode: pageMode, eventEmitter: eventEmitter, source: source, commentType: commentType, removeUnresolvedInlineComment: removeUnresolvedInlineComment, createAnalyticsEvent: createAnalyticsEvent, getInlineNodeTypes: getInlineNodeTypes, setEditorViewProps: setEditorViewProps })=>{
    // Update the unresolved inline comments count
    removeUnresolvedInlineComment && removeUnresolvedInlineComment(parentCommentMarkerRef);
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'resolved',
            actionSubject: 'comment',
            actionSubjectId: commentId,
            objectType: 'page',
            objectId: pageId,
            source: source,
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                source: source,
                commentType: commentType,
                pageMode: pageMode,
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                navdexPointType: (0, $56QzY.END),
                inlineNodeTypes: parentCommentMarkerRef && getInlineNodeTypes ? getInlineNodeTypes(parentCommentMarkerRef) : undefined,
                targetNodeType: (0, $asNlu.getTargetNodeType)(parentCommentMarkerRef, pageMode !== (0, $cD1qu.PageMode).VIEW)
            }
        }
    }).fire();
    // Emit the event to mark the annotation as resolved
    if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
        [parentCommentMarkerRef]: {
            id: parentCommentMarkerRef,
            annotationType: (0, $e3kjM.AnnotationTypes).INLINE_COMMENT,
            state: (0, $e3kjM.AnnotationMarkStates).RESOLVED
        }
    });
    else {
        eventEmitter?.emit('resolve', parentCommentMarkerRef);
        setEditorViewProps && setEditorViewProps(null);
    }
};
const $ec302ec1fafac461$export$6df9d2fc03993824 = ({ commentId: commentId, annotationId: annotationId, pageId: pageId, pageMode: pageMode, isReply: isReply, source: source, inlineNodeTypes: inlineNodeTypes, removeUnresolvedInlineComment: removeUnresolvedInlineComment, createAnalyticsEvent: createAnalyticsEvent, onSuccess: onSuccess })=>{
    if (!annotationId) throw new Error('No annotationId for delete');
    // Update the unresolved inline comments count
    removeUnresolvedInlineComment(annotationId);
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'deleted',
            actionSubject: 'comment',
            actionSubjectId: commentId,
            objectType: 'page',
            objectId: pageId,
            source: source,
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                commentType: (0, $en1dX.CommentType).INLINE,
                source: source,
                pageMode: pageMode,
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                inlineNodeTypes: inlineNodeTypes,
                isReply: isReply,
                targetNodeType: (0, $asNlu.getTargetNodeType)(annotationId, pageMode !== (0, $cD1qu.PageMode).VIEW)
            }
        }
    }).fire();
    // Call the function passed in to do success specific things for each iteration
    onSuccess(annotationId);
};
const $ec302ec1fafac461$export$f2f4dc3fd9171ad8 = ({ experienceTracker: experienceTracker, experienceName: experienceName, error: error, commentId: commentId, shouldReturnError: shouldReturnError = false, shouldAbortForExpectedError: shouldAbortForExpectedError = false, compoundExperienceName: compoundExperienceName })=>{
    // get a truncated graphql error message
    const { message: message } = (0, $isdzP.parseError)(error);
    const translatedError = (0, $isdzP.getTranslatedError)(message, commentId);
    if ((0, $isdzP.isUnexpectedError)(translatedError)) {
        experienceTracker.stopOnError({
            name: experienceName,
            error: error
        });
        /*
     * stopOnError will fail the experience unless it's a session or network error, then it will be aborted.
     * If the experience is failed and is a sub-experience, the compound experience will be failed automatically.
     * If the experience is aborted and is a sub-experience, we need to abort the compound experience.
     */ if (compoundExperienceName) {
            const experienceState = experienceTracker.getExperienceState(experienceName);
            if (experienceState?.stopState === (0, $8237d31e7e86c8c4$export$ae89b6b0e7b50e02).TASK_ABORT) experienceTracker.stopOnError({
                name: compoundExperienceName,
                error: error
            });
        }
    } else {
        // we currently display a generic message to the user whenever an error occurs
        // These errors will not be reported to splunk/signalfx through experience tracking as they are expected
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (shouldAbortForExpectedError) {
            // Ensure reason is always a string
            const reason = typeof translatedError.defaultMessage === 'string' ? translatedError.defaultMessage : message;
            experienceTracker.abort({
                name: experienceName,
                reason: reason
            });
            // If a compound experience is also running, we need to abort it
            if (compoundExperienceName) experienceTracker.abort({
                name: compoundExperienceName,
                reason: reason
            });
        }
    }
    if (shouldReturnError) // CommentEditor expects a translated error message otherwise it fails
    // TODO: CommentEditor should likely just receive the translated message
    // rather than expect the object needed for FormattedMessage
    return Promise.reject({
        error: translatedError
    });
};
module.exports["handleResolveSuccess"] = $ec302ec1fafac461$export$4c0ea2f40582e756;
module.exports["handleDeleteSuccess"] = $ec302ec1fafac461$export$6df9d2fc03993824;
module.exports["handleMutationFailure"] = $ec302ec1fafac461$export$f2f4dc3fd9171ad8;

});

parcelRegister("ibqdE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $3mVfX = parcelRequire("3mVfX");


var $8i27m = parcelRequire("8i27m");

const $5dbc03d9e41dd9c7$export$36062d4a94e50365 = 2;
var $5dbc03d9e41dd9c7$export$8a64eadc3c5e2e9a = /*#__PURE__*/ function(ViewReplyOptions) {
    ViewReplyOptions["ALL"] = "ALL";
    ViewReplyOptions["DEFAULT"] = "DEFAULT";
    ViewReplyOptions["HIDDEN"] = "HIDDEN";
    ViewReplyOptions["LIMITED"] = "LIMITED";
    return ViewReplyOptions;
}({});
const $5dbc03d9e41dd9c7$export$6c920326840ef051 = ({ allReplies: allReplies, commentType: commentType, isParentCommentOpen: isParentCommentOpen, currentReplyView: currentReplyView, latestReplies: latestReplies, latestReplyIds: latestReplyIds, parentCommentId: parentCommentId, setVisibleReplies: setVisibleReplies, shouldShowLatestReplies: shouldShowLatestReplies, numOfHiddenReplies: numOfHiddenReplies })=>{
    if (currentReplyView === "ALL") {
        if (commentType !== (0, $8i27m.CommentType).GENERAL) setVisibleReplies(allReplies);
        else {
            const topLevelReplies = allReplies.filter((reply)=>reply.parentId === parentCommentId);
            setVisibleReplies(topLevelReplies);
        }
        numOfHiddenReplies.current = 0;
    } else {
        numOfHiddenReplies.current = allReplies.length;
        if (!isParentCommentOpen) // If the parent comment is resolved, we hide all replies on the thread's initial load
        setVisibleReplies([]);
        else if (shouldShowLatestReplies && latestReplies && latestReplyIds && latestReplyIds.size > 0) {
            /*
			 * If the parent comment is open, we show the latest replies on the thread's initial load only.
			 * When replies are expaneded and collapsed, all replies are hidden.
			 */ setVisibleReplies(latestReplies);
            numOfHiddenReplies.current -= latestReplyIds.size;
        }
    }
};
const $5dbc03d9e41dd9c7$export$564e359a57aeb34a = ({ currentReplyView: currentReplyView, setVisibleReplies: setVisibleReplies, allReplies: allReplies, isParentCommentOpen: isParentCommentOpen, latestReplies: latestReplies, parentCommentId: parentCommentId, currentView: currentView, allowNestedReplies: allowNestedReplies = false })=>{
    if (!isParentCommentOpen && currentView !== (0, $3mVfX.ViewValues).RESOLVED) {
        setVisibleReplies([]);
        return;
    }
    switch(currentReplyView){
        case "ALL":
            if (allowNestedReplies) setVisibleReplies(allReplies);
            else {
                const topLevelReplies = $5dbc03d9e41dd9c7$export$e9719a1dca3c9c9(allReplies, parentCommentId);
                // Make all direct replies to the parent comment visible, excluding any nested replies.
                setVisibleReplies(topLevelReplies);
            }
            break;
        case "HIDDEN":
            setVisibleReplies([]);
            break;
        case "LIMITED":
            setVisibleReplies(latestReplies);
            break;
    }
};
const $5dbc03d9e41dd9c7$export$e9719a1dca3c9c9 = (replies, parentCommentId)=>replies.filter(({ parentId: parentId })=>parentId === parentCommentId);
const $5dbc03d9e41dd9c7$export$94e4f6e86c2cc22f = ({ replies: replies, latestReplyIds: latestReplyIds, currentReplyView: currentReplyView })=>{
    switch(currentReplyView){
        case "HIDDEN":
            return replies.length;
        case "LIMITED":
            return replies.length - latestReplyIds.size;
        default:
            return 0;
    }
};
const $5dbc03d9e41dd9c7$export$e5bfa4c04a9e4b5c = ({ replies: replies, shouldShowLatestReplies: shouldShowLatestReplies, isParentOpen: isParentOpen, latestReplyIds: latestReplyIds })=>replies.filter((reply)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) return !shouldShowLatestReplies || !latestReplyIds.has(reply.id);
        return !shouldShowLatestReplies || !isParentOpen ? true : !latestReplyIds.has(reply.id);
    });
const $5dbc03d9e41dd9c7$export$9445637fea268c7c = (repliesToFilter)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return [];
    const uniqueAccountsMap = new Map();
    // Start from the end of the list and move backwards
    for(let i = repliesToFilter.length - 1; i >= 0; i--){
        const reply = repliesToFilter[i];
        const { displayName: displayName, profilePicture: profilePicture } = reply.author;
        // Determine if the author has an accountId, anonymous users don't have accountId
        let uniqueKey;
        if ('accountId' in reply.author && reply.author.accountId) uniqueKey = reply.author.accountId;
        else // Fallback for anonymous users or if accountId is not present
        uniqueKey = `anonymous-${i}`;
        if (!uniqueAccountsMap.has(uniqueKey)) uniqueAccountsMap.set(uniqueKey, {
            displayName: displayName ?? '',
            profilePicturePath: profilePicture?.path
        });
    }
    return Array.from(uniqueAccountsMap.values());
};
module.exports["DEFAULT_NUM_VISIBLE_REPLIES"] = $5dbc03d9e41dd9c7$export$36062d4a94e50365;
module.exports["ViewReplyOptions"] = $5dbc03d9e41dd9c7$export$8a64eadc3c5e2e9a;
module.exports["legacyUpdateVisibleReplies"] = $5dbc03d9e41dd9c7$export$6c920326840ef051;
module.exports["updateVisibleReplies"] = $5dbc03d9e41dd9c7$export$564e359a57aeb34a;
module.exports["getCommentReplies"] = $5dbc03d9e41dd9c7$export$e9719a1dca3c9c9;
module.exports["getNumOfHiddenReplies"] = $5dbc03d9e41dd9c7$export$94e4f6e86c2cc22f;
module.exports["getDefaultHiddenReplies"] = $5dbc03d9e41dd9c7$export$e5bfa4c04a9e4b5c;
module.exports["getProfilePicturesOfHiddenReplies"] = $5dbc03d9e41dd9c7$export$9445637fea268c7c;

});

parcelRegister("1Sjzs", function(module, exports) {
/* WithCurvedBranchingStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

'use no memo';
const $182916127499e17b$var$replyBranchStyles = null;
const $182916127499e17b$export$855243800ee94bad = ({ showDefaultStyles: showDefaultStyles, children: children, customStyles: customStyles, onClick: onClick, testId: testId, disableLeftProp: disableLeftProp })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(()=>{
                const { height: height, left: left, ...rest } = customStyles || {};
                return rest;
            })(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles?.height && {
                '--customHeight': customStyles.height
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles?.left ? {
                '--customBeforeLeft': customStyles.left
            } : {
                '--customBeforeLeft': disableLeftProp ? '0px' : '-24px'
            }
        },
        onClick: onClick,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            showDefaultStyles && "_kqswh2mm _1n1j11qs _4k1c11qs _1kt9b3bt _1cs8stnw _qnec1gkm _1aukidpf _1mp41skh _kfgt1pfq _fik81mok"
        ])
    }, children);
};
module.exports["WithCurvedBranchingStyle"] = $182916127499e17b$export$855243800ee94bad;

});

parcelRegister("58Zuw", function(module, exports) {
/* RepliesToggler.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $2AytZ = parcelRequire("2AytZ");


var $ghftu = parcelRequire("ghftu");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $2Pg7f = parcelRequire("2Pg7f");


var $ccHMk = parcelRequire("ccHMk");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $1Sjzs = parcelRequire("1Sjzs");


var $3mVfX = parcelRequire("3mVfX");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");


var $ibqdE = parcelRequire("ibqdE");

/* RepliesTogglerButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $lFPm8 = parcelRequire("lFPm8");





var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");

const $fd1a9a414507ab5d$var$styles = {
    dot: "_2rko1rr0 _18s81b66 _4t3iftgi _1bsbftgi _bfhk1856",
    pressable: "_1yt4u2gc _2rko12b0 _1bsb1osq _syazazsu _bfhksm61 _uiztglyw _k48p1wq8 _d0altlke _irr31dpa _1di6fcek"
};
const $fd1a9a414507ab5d$var$SHOW_HIDDEN_REPLIES = 'show-hidden-replies';
const $fd1a9a414507ab5d$export$3b601073833f0b61 = ({ showHiddenReplies: showHiddenReplies, profilePicturesHiddenReplies: profilePicturesHiddenReplies, hasHiddenUnreadReplies: hasHiddenUnreadReplies, analyticsContext: analyticsContext, message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: showHiddenReplies,
        xcss: $fd1a9a414507ab5d$var$styles.pressable,
        analyticsContext: analyticsContext,
        testId: $fd1a9a414507ab5d$var$SHOW_HIDDEN_REPLIES,
        interactionName: $fd1a9a414507ab5d$var$SHOW_HIDDEN_REPLIES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFPm8))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        onMoreClick: ()=>{},
        data: profilePicturesHiddenReplies.map(({ displayName: displayName, profilePicturePath: profilePicturePath })=>({
                name: displayName,
                src: profilePicturePath
            })),
        maxCount: 3,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "replies-toggler-profile-pictures"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "medium"
    }, message)), hasHiddenUnreadReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $fd1a9a414507ab5d$var$styles.dot,
        testId: "unread-comment-replies-indicator"
    })));


const $98ec5da5f93a34eb$var$repliesTogglerStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    left: 0
};
const $98ec5da5f93a34eb$var$repliesTogglerBranchingStyle = null;
const $98ec5da5f93a34eb$var$replyBranchUnsetHeight = null;
const $98ec5da5f93a34eb$var$repliesTogglerBranchingStyleWithoutReply = null;
const $98ec5da5f93a34eb$var$replyWrapperWithSpacingStyles = {
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    left: 0
};
const $98ec5da5f93a34eb$var$unreadIndicatorStyle = (0, $ecnYn.xcss)({
    alignItems: 'center',
    gap: 'space.075'
});
const $98ec5da5f93a34eb$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    backgroundColor: 'color.background.neutral.subtle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderRadius: 'radius.small',
    userSelect: 'none',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
}); // This snippet is being used in CommentBody.tsx
const $98ec5da5f93a34eb$var$dotStyles = null;
const $98ec5da5f93a34eb$var$i18n = (0, $cgtv4.defineMessages)({
    hideRepliesText: {
        id: "comments-common.comment-thread.hide.replies",
        defaultMessage: "Hide replies"
    },
    hideReplyText: {
        id: "comments-common.comment-thread.hide.reply",
        defaultMessage: "Hide reply"
    },
    showMoreRepliesText: {
        id: "comments-common.comment-thread.show.more.replies",
        defaultMessage: "Show {numOfHiddenReplies, plural, one {# more reply} other {# more replies}}"
    },
    showMoreRepliesTextForStandalone: {
        id: "comments-common.comment-thread.show.more.replies.for.standalone",
        defaultMessage: "{numOfHiddenReplies, plural, one {# more reply} other {# more replies}}"
    },
    showReplyText: {
        id: "comments-common.comment-thread.show.reply",
        defaultMessage: "Show reply"
    }
});
const $98ec5da5f93a34eb$var$withLeftMargin = null;
const $98ec5da5f93a34eb$var$MAX_PROFILE_PICTURES_TO_SHOW = 3;
const $98ec5da5f93a34eb$var$getFormattedShowReplyMessage = ({ repliesLength: repliesLength, isStandaloneComment: isStandaloneComment, numOfHiddenReplies: numOfHiddenReplies, formatMessage: formatMessage })=>{
    if (repliesLength === 1) return formatMessage($98ec5da5f93a34eb$var$i18n.showReplyText);
    return formatMessage(isStandaloneComment ? $98ec5da5f93a34eb$var$i18n.showMoreRepliesTextForStandalone : $98ec5da5f93a34eb$var$i18n.showMoreRepliesText, {
        numOfHiddenReplies: numOfHiddenReplies
    });
};
const $98ec5da5f93a34eb$var$getAnalyticsContext = ({ analyticsSource: analyticsSource, commentType: commentType, replies: replies, hasHiddenUnreadReplies: hasHiddenUnreadReplies, currentNumOfHiddenReplies: currentNumOfHiddenReplies, shouldShowShowMoreRepliesToggle: shouldShowShowMoreRepliesToggle })=>({
        attributes: shouldShowShowMoreRepliesToggle ? {
            name: 'repliesToggler',
            source: analyticsSource,
            commentType: commentType,
            hasHiddenUnreadReplies: hasHiddenUnreadReplies,
            numOfHiddenReplies: currentNumOfHiddenReplies,
            numOfReplies: replies.length
        } : {
            attributes: {
                name: 'hideReplies',
                source: analyticsSource,
                commentType: commentType,
                numOfReplies: replies.length
            }
        }
    });
const $98ec5da5f93a34eb$export$fa25a7ffef408bc8 = ({ replies: replies, setVisibleReplies: setVisibleReplies, unreadReplyIds: unreadReplyIds, setReplyView: setReplyView, threadKey: threadKey, currentReplyView: currentReplyView, numOfHiddenReplies: numOfHiddenReplies, commentType: commentType, parentCommentId: parentCommentId, isParentOpen: isParentOpen, canAddComments: canAddComments, shouldShowLatestReplies: shouldShowLatestReplies, setShouldShowLatestReplies: setShouldShowLatestReplies, latestReplyIds: latestReplyIds, isStandaloneComment: isStandaloneComment = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, analyticsSource: analyticsSource })=>{
    const useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
    const useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
    const focusedCommentId = useFocusedCommentIdQueryParam();
    const replyToComment = useReplyToCommentQueryParam();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ commentsMarkedAsRead: commentsMarkedAsRead }, { setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    (0, $42omo.useEffect)(()=>{
        // used to expand all replies of standalone comment
        const targetCommentId = focusedCommentId || replyToComment;
        if (targetCommentId) {
            // to check if the queryParam is parentCommentId or not
            const isReplyToCommentInChain = replies?.map((reply)=>reply?.id)?.includes(targetCommentId);
            if (isReplyToCommentInChain) setReplyView((0, $ibqdE.ViewReplyOptions).ALL);
        }
    }, [
        focusedCommentId,
        replyToComment,
        setReplyView,
        replies
    ]); // Memoize hidden replies calculation since it's used in multiple places
    const hiddenReplies = (0, $42omo.useMemo)(()=>{
        // If all replies are hidden due to current view, return all replies
        if (currentReplyView === (0, $ibqdE.ViewReplyOptions).HIDDEN) return replies;
         // Otherwise, use the default hidden replies logic
        return (0, $ibqdE.getDefaultHiddenReplies)({
            replies: replies,
            shouldShowLatestReplies: shouldShowLatestReplies,
            isParentOpen: isParentOpen,
            latestReplyIds: latestReplyIds
        });
    }, [
        replies,
        shouldShowLatestReplies,
        isParentOpen,
        latestReplyIds,
        currentReplyView
    ]); // for the unread indicator, we only want to render it if there are any hidden unread
    const hasHiddenUnreadReplies = (0, $42omo.useMemo)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
            const hiddenReplyIds = new Set(hiddenReplies.map((reply)=>reply.id));
            return unreadReplyIds.some((replyId)=>hiddenReplyIds.has(replyId));
        } else {
            const unreadRepliesNotMarkedAsRead = unreadReplyIds.filter((replyId)=>{
                const markedReplies = commentsMarkedAsRead[commentType][threadKey]; // Check if the reply id is not in the markedReplies set
                return !markedReplies || !markedReplies.has(replyId);
            });
            return unreadRepliesNotMarkedAsRead.filter((replyId)=>!latestReplyIds.has(replyId)).length > 0;
        }
    }, [
        unreadReplyIds,
        latestReplyIds,
        commentsMarkedAsRead,
        threadKey,
        commentType,
        hiddenReplies
    ]);
    const currentNumOfHiddenReplies = (0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor') ? (0, $ibqdE.getNumOfHiddenReplies)({
        replies: replies,
        latestReplyIds: latestReplyIds,
        currentReplyView: currentReplyView
    }) : numOfHiddenReplies.current;
    const shouldShowShowMoreRepliesToggle = currentNumOfHiddenReplies > 0;
    const shouldShowProfilePictures = currentReplyView !== (0, $ibqdE.ViewReplyOptions).ALL && shouldShowShowMoreRepliesToggle;
    const shouldShowShortenedBranchStyles = !isParentOpen && shouldShowShowMoreRepliesToggle;
    const profilePicturesHiddenReplies = (0, $42omo.useRef)(shouldShowProfilePictures ? (0, $ibqdE.getProfilePicturesOfHiddenReplies)((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? hiddenReplies : (0, $ibqdE.getDefaultHiddenReplies)({
        replies: replies,
        shouldShowLatestReplies: shouldShowLatestReplies,
        isParentOpen: isParentOpen,
        latestReplyIds: latestReplyIds
    })) : []);
    const showHiddenReplies = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setReplyView((0, $ibqdE.ViewReplyOptions).ALL);
        (focusedCommentId || replyToComment) && removeCommentQueryParams();
        if (!(0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) {
            if (commentType === (0, $8i27m.CommentType).GENERAL && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                const topLevelReplyIds = new Set(replies.filter((reply)=>reply.parentId === parentCommentId).map((reply)=>reply.id));
                const visibleReplies = replies.filter((reply)=>topLevelReplyIds.has(reply.id));
                setVisibleReplies(visibleReplies);
            } else setVisibleReplies(replies);
            numOfHiddenReplies.current = 0;
        }
        profilePicturesHiddenReplies.current = [];
    }, [
        setReplyView,
        commentType,
        numOfHiddenReplies,
        replies,
        setVisibleReplies,
        parentCommentId,
        focusedCommentId,
        replyToComment,
        removeCommentQueryParams
    ]);
    const hideReplies = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation(); // remove the queryParams if it exists
        (focusedCommentId || replyToComment) && removeCommentQueryParams();
        if ((0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) setReplyView((0, $ibqdE.ViewReplyOptions).HIDDEN);
        else {
            setReplyView((0, $ibqdE.ViewReplyOptions).DEFAULT);
            setVisibleReplies([]);
            setShouldShowLatestReplies(false);
            numOfHiddenReplies.current = replies.length;
        }
        if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) // all unread replies will be marked as read
        setCommentsInThreadToBeMarkedAsRead({
            threadKey: threadKey,
            commentIds: unreadReplyIds,
            commentType: commentType
        });
         // all replies will be considered
        profilePicturesHiddenReplies.current = (0, $ibqdE.getProfilePicturesOfHiddenReplies)(replies);
    }, [
        threadKey,
        replies,
        setReplyView,
        setVisibleReplies,
        setCommentsInThreadToBeMarkedAsRead,
        unreadReplyIds,
        numOfHiddenReplies,
        commentType,
        setShouldShowLatestReplies,
        focusedCommentId,
        replyToComment,
        removeCommentQueryParams
    ]);
    if ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) {
        if (!shouldShowShowMoreRepliesToggle) return null;
    }
    const formattedShowReplyMessage = $98ec5da5f93a34eb$var$getFormattedShowReplyMessage({
        repliesLength: replies.length,
        isStandaloneComment: isStandaloneComment,
        numOfHiddenReplies: currentNumOfHiddenReplies,
        formatMessage: formatMessage
    });
    const analyticsContext = $98ec5da5f93a34eb$var$getAnalyticsContext({
        analyticsSource: analyticsSource,
        commentType: commentType,
        replies: replies,
        hasHiddenUnreadReplies: hasHiddenUnreadReplies,
        currentNumOfHiddenReplies: currentNumOfHiddenReplies,
        shouldShowShowMoreRepliesToggle: shouldShowShowMoreRepliesToggle
    });
    return (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "replies-toggler-container",
        onMouseEnter: ()=>onMouseEnter(parentCommentId),
        onMouseLeave: ()=>onMouseLeave()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd1a9a414507ab5d$export$3b601073833f0b61), {
        message: formattedShowReplyMessage,
        showHiddenReplies: showHiddenReplies,
        hasHiddenUnreadReplies: hasHiddenUnreadReplies,
        profilePicturesHiddenReplies: profilePicturesHiddenReplies.current,
        analyticsContext: analyticsContext
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // handles making sure we keep correct highlight state when mousing over this
    , {
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && onMouseEnter(parentCommentId),
        onMouseLeave: ()=>(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && onMouseLeave(),
        className: (0, $gMc0m.default)([
            replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && (canAddComments || currentNumOfHiddenReplies === 0) && "_kqswh2mm _1n1j11qs _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _kfgt1wqb",
            replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && shouldShowShortenedBranchStyles && "_kfgtgktf",
            replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && currentReplyView === (0, $ibqdE.ViewReplyOptions).HIDDEN && isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_kfgtn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        testId: "replies-toggler-container",
        showDefaultStyles: replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2'),
        disableLeftProp: true,
        customStyles: {
            ...$98ec5da5f93a34eb$var$repliesTogglerStyles,
            ...(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $98ec5da5f93a34eb$var$replyWrapperWithSpacingStyles : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18u0utpp"
        ])
    }, shouldShowShowMoreRepliesToggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: showHiddenReplies,
        testId: "show-hidden-replies",
        analyticsContext: analyticsContext,
        xcss: $98ec5da5f93a34eb$var$pressableStyles,
        interactionName: "show-hidden-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: isStandaloneComment ? 'space.150' : 'space.050'
    }, shouldShowProfilePictures && profilePicturesHiddenReplies.current.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: profilePicturesHiddenReplies.current.map((profilePicturesInfo)=>({
                name: profilePicturesInfo.displayName,
                src: profilePicturesInfo.profilePicturePath
            })),
        maxCount: $98ec5da5f93a34eb$var$MAX_PROFILE_PICTURES_TO_SHOW,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "replies-toggler-profile-pictures"
    }), !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        spacing: "compact",
        label: "show-more-replies-button",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $98ec5da5f93a34eb$var$unreadIndicatorStyle
    }, formattedShowReplyMessage, hasHiddenUnreadReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "unread-comment-replies-indicator",
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _18s81b66 _4t3iu2gc _1bsbu2gc _bfhk1856"
        ])
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: hideReplies,
        testId: "hide-replies",
        appearance: "subtle",
        analyticsContext: analyticsContext,
        interactionName: "hide-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        spacing: "compact",
        label: "hide-replies-button",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text",
        size: "medium",
        weight: "medium"
    }, replies.length === 1 ? formatMessage($98ec5da5f93a34eb$var$i18n.hideReplyText) : formatMessage($98ec5da5f93a34eb$var$i18n.hideRepliesText)))))));
};
module.exports["RepliesToggler"] = $98ec5da5f93a34eb$export$fa25a7ffef408bc8;

});

parcelRegister("lLpk8", function(module, exports) {
/* RepliesFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $jPqj0 = parcelRequire("jPqj0");


var $ibqdE = parcelRequire("ibqdE");













var $diR4K = parcelRequire("diR4K");


var $ep3mz = parcelRequire("ep3mz");


var $cZa7r = parcelRequire("cZa7r");


var $dANtQ = parcelRequire("dANtQ");

const $edfa6a6a83714cbc$var$messages = (0, $cgtv4.defineMessages)({
    reply: {
        id: "comments-common.comments.replies.footer.reply",
        defaultMessage: "Reply"
    }
});
const $edfa6a6a83714cbc$export$6310bd4b9bdb4fe0 = ({ handleReplyButtonClick: handleReplyButtonClick, isParentCommentOpen: isParentCommentOpen, isStandaloneComment: isStandaloneComment })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isOffline = (0, $cZa7r.useAnnotationsIsOffline)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    if (!canAddComments || !isParentCommentOpen || isStandaloneComment) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        isDisabled: isOffline,
        onClick: handleReplyButtonClick,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($diR4K)))
    }, formatMessage($edfa6a6a83714cbc$var$messages.reply));
};


const $56737fe079f60a2e$var$styles = {
    buttonsContainer: "_1bah1yb4 _19bv1ejb _ca0qu2gc",
    editorContainer: "_16jlkb7n"
};
const $56737fe079f60a2e$var$messages = (0, $cgtv4.defineMessages)({
    hideReplies: {
        id: "comments-common.comments.replies.footer.hideReplies",
        defaultMessage: "{numOfVisibleReplies, plural, one {Hide reply} other {Hide replies}}"
    }
});
const $56737fe079f60a2e$export$5b80eae1c1e011bf = ({ replyView: replyView, setReplyView: setReplyView, expandReplyEditor: expandReplyEditor, numOfVisibleReplies: numOfVisibleReplies, isParentCommentOpen: isParentCommentOpen, children: replyEditor, handleReplyButtonClick: handleReplyButtonClick, isStandaloneComment: isStandaloneComment = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isHideRepliesToggleVisible = !expandReplyEditor && !isStandaloneComment && replyView !== (0, $ibqdE.ViewReplyOptions).HIDDEN && numOfVisibleReplies > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        testId: "replies-footer",
        xcss: $56737fe079f60a2e$var$styles.buttonsContainer,
        alignItems: "center"
    }, expandReplyEditor ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edfa6a6a83714cbc$export$6310bd4b9bdb4fe0), {
        isParentCommentOpen: isParentCommentOpen,
        isStandaloneComment: isStandaloneComment,
        handleReplyButtonClick: handleReplyButtonClick
    }), isHideRepliesToggleVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jPqj0))),
        onClick: (event)=>{
            event.stopPropagation();
            setReplyView((0, $ibqdE.ViewReplyOptions).HIDDEN);
        }
    }, formatMessage($56737fe079f60a2e$var$messages.hideReplies, {
        numOfVisibleReplies: numOfVisibleReplies
    })), expandReplyEditor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "reply-editor-container",
        xcss: $56737fe079f60a2e$var$styles.editorContainer
    }, replyEditor));
};
module.exports["RepliesFooter"] = $56737fe079f60a2e$export$5b80eae1c1e011bf;

});

parcelRegister("8gR6k", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $3mVfX = parcelRequire("3mVfX");


var $ibqdE = parcelRequire("ibqdE");

const $020512e6fc7b9101$export$b1d0bdb48de923ea = ({ allReplies: allReplies, commentType: commentType, isParentCommentOpen: isParentCommentOpen, currentReplyView: currentReplyView, latestReplies: latestReplies, latestReplyIds: latestReplyIds, parentCommentId: parentCommentId, setVisibleReplies: setVisibleReplies, shouldShowLatestReplies: shouldShowLatestReplies, numOfHiddenReplies: numOfHiddenReplies, allowNestedReplies: allowNestedReplies = false })=>{
    // As long as the flag is present, we have to provide both
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) return;
        (0, $ibqdE.updateVisibleReplies)({
            parentCommentId: parentCommentId,
            currentReplyView: currentReplyView,
            setVisibleReplies: setVisibleReplies,
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            latestReplies: latestReplies,
            currentView: currentView,
            allowNestedReplies: allowNestedReplies
        });
    }, [
        allReplies,
        currentReplyView,
        isParentCommentOpen,
        latestReplies,
        numOfHiddenReplies,
        parentCommentId,
        setVisibleReplies,
        currentView,
        allowNestedReplies
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) return;
        (0, $ibqdE.legacyUpdateVisibleReplies)({
            allReplies: allReplies,
            commentType: commentType,
            isParentCommentOpen: isParentCommentOpen,
            currentReplyView: currentReplyView,
            latestReplies: latestReplies,
            latestReplyIds: latestReplyIds,
            parentCommentId: parentCommentId,
            setVisibleReplies: setVisibleReplies,
            shouldShowLatestReplies: shouldShowLatestReplies,
            numOfHiddenReplies: numOfHiddenReplies
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- there might be a better way to handle this without needing a useEffect
    }, [
        allReplies,
        latestReplies,
        latestReplyIds
    ]);
};
module.exports["useUpdateVisibleReplies"] = $020512e6fc7b9101$export$b1d0bdb48de923ea;

});

parcelRegister("auGhu", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $abN8T = parcelRequire("abN8T");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $7EEGh = parcelRequire("7EEGh");


var $lesF8 = parcelRequire("lesF8");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8Ss4E = parcelRequire("8Ss4E");


var $aJPUt = parcelRequire("aJPUt");


var $hXzKU = parcelRequire("hXzKU");


var $8i27m = parcelRequire("8i27m");


var $jbF1h = parcelRequire("jbF1h");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cZa7r = parcelRequire("cZa7r");


var $bQm3c = parcelRequire("bQm3c");


var $3B9cR = parcelRequire("3B9cR");


var $jkPJy = parcelRequire("jkPJy");


var $1C8XP = parcelRequire("1C8XP");


var $7W8i8 = parcelRequire("7W8i8");


var $56QzY = parcelRequire("56QzY");


var $87CZC = parcelRequire("87CZC");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $en1dX = parcelRequire("en1dX");


var $6hmtW = parcelRequire("6hmtW");

/**
 * @generated SignedSource<<1c1949292bb086f9ab42d5ae33ff66c8>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $d6487e78194ebc92$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});



var $1Sjzs = parcelRequire("1Sjzs");


var $isdzP = parcelRequire("isdzP");


var $daq5m = parcelRequire("daq5m");

const $2d789a7ecebf6a19$var$EditCommentUpdateInlineCommentMutation = (0, $eSUdr.default)`mutation EditCommentUpdateInlineCommentMutation($input:UpdateCommentInput!$includeVersionFields:Boolean=false){updateComment(input:$input){id body(representation:ATLAS_DOC_FORMAT)@include(if:$includeVersionFields){value}version@include(if:$includeVersionFields){number when by{displayName}}}}`;
const $2d789a7ecebf6a19$var$i18n = (0, $cgtv4.defineMessages)({
    cannotEditTitle: {
        id: "inline-comments-common.could.not.edit.title",
        defaultMessage: "Unable to edit comment"
    }
});
const $2d789a7ecebf6a19$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:edit-comment');
const $2d789a7ecebf6a19$var$editorContainerStyle = (0, $ecnYn.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.200'
});
const $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyle = (0, $ecnYn.xcss)({
    padding: 'unset',
    paddingTop: 'space.100'
});
const $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.200',
    marginTop: 'space.050',
    // If we're doing the border here, we need margin instead of padding so the border is flush with the editor
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $2d789a7ecebf6a19$var$editorBottomPaddingStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.100'
});
const $2d789a7ecebf6a19$var$panelEditorParentContainerStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginBottom: 'space.0',
    paddingBlock: 'space.0',
    paddingRight: 'space.0',
    paddingTop: 'space.0'
});
const $2d789a7ecebf6a19$var$panelEditorReplyContainerStyle = (0, $ecnYn.xcss)({
    margin: '0',
    padding: '0',
    paddingTop: 'space.100'
});
const $2d789a7ecebf6a19$var$adjustForBorderStyle = (0, $ecnYn.xcss)({
    // @ts-expect-error - Design requires -1px margin to account for left border which is outside the token system
    marginLeft: '-1px'
});
const $2d789a7ecebf6a19$var$standaloneEditorReplyContainerStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.200',
    paddingRight: 'space.0',
    paddingTop: 'space.0'
});
const $2d789a7ecebf6a19$var$editorParentWrapperStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.negative.100',
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`,
    paddingBottom: 'space.100'
});
const $2d789a7ecebf6a19$var$standaloneEditorReplyWrapperStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingBottom: 'space.200',
    marginLeft: 'space.negative.300',
    marginBottom: 'space.negative.150'
});
const $2d789a7ecebf6a19$var$leftBorderStyle = (0, $ecnYn.xcss)({
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $2d789a7ecebf6a19$var$EditCommentComponent = ({ pageId: pageId, pageType: pageType, annotationId: annotationId, commentId: commentId, spaceId: spaceId, content: content, displayCommentInViewMode: displayCommentInViewMode, isReply: isReply, isEdited: isEdited, avatarUrl: avatarUrl, date: date, dateUrl: dateUrl, createdAtNonLocalized: createdAtNonLocalized, versionByDisplayName: versionByDisplayName, versionDate: versionDate, resolveProperties: resolveProperties, displayName: displayName, mode: mode, hasMediaUploadPermissions: hasMediaUploadPermissions, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, adjustForFooterReplies: adjustForFooterReplies = false, isLastNestedFooterReply: isLastNestedFooterReply = false, onCancelEdit: onCancelEdit, getInlineNodeTypes: getInlineNodeTypes, commentType: commentType, flags: flags, isStandaloneComment: isStandaloneComment, isOffline: isOffline, isCurrentUserAnonymous: isCurrentUserAnonymous, isLastUnnestableReply: isLastUnnestableReply = false })=>{
    const { userId: userId, displayName: sessionDisplayName } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { updateCommentBody: updateCommentBody } = (0, $8i27m.useCommentsDataActions)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [updateCommentFn] = (0, $1KmJq.useMutation)($2d789a7ecebf6a19$var$EditCommentUpdateInlineCommentMutation);
    // Get the update function for the comments data manager
    const { updateCommentInCache: updateCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const handleOnEditorReady = ()=>{
        if (commentType === (0, $8i27m.CommentType).GENERAL) experienceTracker.succeed({
            name: (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE)
        });
        else experienceTracker.succeed({
            name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
    };
    const handleOnCancel = ()=>{
        displayCommentInViewMode();
        resetContentChanged();
        onCancelEdit && onCancelEdit();
    };
    const handleEditMutationFailure = (0, $42omo.useCallback)((editMutationError)=>{
        experienceTracker.stopOnError({
            name: commentType === (0, $8i27m.CommentType).GENERAL ? (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: editMutationError
        });
    }, [
        commentType,
        experienceTracker
    ]);
    const editCommentUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $jbF1h.updateCommentBodyInCacheCallback),
            onError: handleEditMutationFailure
        }), [
        commentId,
        handleEditMutationFailure,
        updateCommentInCache
    ]);
    const handleUpdateComment = (adf, onSuccess)=>{
        if (commentType === (0, $8i27m.CommentType).GENERAL) (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
            attributes: {
                mode: pageMode
            }
        });
        else (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
            attributes: {
                mode: pageMode
            }
        });
        // (Setting includeVersionFields in an if block is so Lint doesn't think we're saving or
        //  wrapping the experiment value)
        let includeVersionFields = false;
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) includeVersionFields = true;
        const adfString = JSON.stringify(adf);
        const variables = {
            input: {
                commentId: commentId,
                commentBody: {
                    value: adfString,
                    representationFormat: (0, $d6487e78194ebc92$export$f4016897b165b6d5).ATLAS_DOC_FORMAT
                }
            },
            includeVersionFields: includeVersionFields
        };
        const getQuery = ()=>{
            if (isCommentsPanel || isFooterComment) return 0, $jkPJy.CommentsPanelQuery;
            else if (isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return 0, $1C8XP.ActiveInlineCommentsQuery;
            else return 0, $3B9cR.InlineCommentQuery;
        };
        const getQueryVariable = ()=>{
            if (isCommentsPanel || isFooterComment) return {
                pageId: pageId
            };
            else if (isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return {
                inlineMarkerRefList: [
                    annotationId
                ],
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            };
            else return {
                annotationId: annotationId,
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            };
        };
        return updateCommentFn({
            variables: variables,
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? editCommentUpdateFn : (cache)=>{
                // readQuery can still return null which complicates TS lint errors with optional chaining
                // once we move to v3 of the apollo client we can move to cache.modify
                try {
                    const dataProxy = cache.readQuery({
                        query: getQuery(),
                        variables: getQueryVariable()
                    });
                    const data = Object.assign({}, dataProxy);
                    let oldComment;
                    // Standalone only has 1 comment so use index 0
                    const idxToUpdate = isCommentsPanel || isFooterComment ? data?.comments?.nodes?.findIndex((n)=>n?.id === commentId) || -1 : 0;
                    if (idxToUpdate === -1) return;
                    // find the comment to update for a reply or the parent comment
                    if (isReply) {
                        // @ts-ignore
                        const replies = data?.comments?.nodes[idxToUpdate].replies ?? [];
                        replies.forEach((reply)=>{
                            // @ts-ignore
                            if (reply?.id === commentId) oldComment = reply;
                        });
                    } else // @ts-ignore
                    oldComment = data?.comments?.nodes[idxToUpdate];
                    if (oldComment) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'body.value', adfString);
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'version.number', (oldComment.version?.number ?? 0) + 1);
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'version.when', new Date().toISOString());
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(oldComment, 'version.by.displayName', sessionDisplayName);
                    }
                    cache.writeQuery({
                        query: getQuery(),
                        variables: getQueryVariable(),
                        data: data
                    });
                } catch (error) {
                    $2d789a7ecebf6a19$var$logger.error`An Error occurred when updating cache for edit reply in panel or inline - ${error}`;
                }
                if (commentType === (0, $8i27m.CommentType).GENERAL) (0, $87CZC.updateFooterApolloCacheOnEdit)(commentId, adfString, pageId, isReactionsEnabled, cache, sessionDisplayName);
            }
        }).then(()=>{
            if (commentType === (0, $8i27m.CommentType).GENERAL) experienceTracker.succeed({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                attributes: {
                    mode: pageMode,
                    type: isReply ? 'reply' : 'topLevel'
                }
            });
            else experienceTracker.succeed({
                name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                attributes: {
                    mode: pageMode,
                    type: isReply ? 'reply' : 'topLevel'
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'updated',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: pageType,
                    objectId: pageId,
                    source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                    attributes: {
                        commentType: commentType,
                        pageType: pageType,
                        source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : isFooterComment ? (0, $en1dX.AnalyticsSource).PAGE_FOOTER : (0, $en1dX.AnalyticsSource).STANDALONE,
                        pageMode: pageMode,
                        isReply: isReply,
                        navdexPointType: (0, $56QzY.END),
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        inlineNodeTypes: getInlineNodeTypes && annotationId ? getInlineNodeTypes(annotationId) : undefined
                    }
                }
            }).fire();
            annotationId && updateCommentBody(commentId, annotationId, adfString, commentType, sessionDisplayName);
            if (annotationId) // Update content types comment service if we are editing a comment
            commentService.onUpdateComment?.(annotationId);
            // Update stored comment data with the new body value
            if (setStoredCommentData && storedCommentData) {
                if (isReply) {
                    // For replies, update the specific reply within the stored comment data
                    const replies_0 = storedCommentData.replies;
                    if (replies_0 && replies_0.length > 0) {
                        const replyIndex = replies_0.findIndex((reply_0)=>reply_0.id === commentId);
                        if (replyIndex !== -1) {
                            // Create new replies array with updated reply at specific index
                            const updatedReplies = [
                                ...replies_0
                            ];
                            const reply_1 = updatedReplies[replyIndex];
                            if (reply_1 && reply_1.version) updatedReplies[replyIndex] = {
                                ...reply_1,
                                body: {
                                    value: adfString
                                },
                                version: {
                                    ...reply_1.version,
                                    by: {
                                        ...reply_1.version.by,
                                        displayName: sessionDisplayName || reply_1.version.by?.displayName || null
                                    },
                                    number: (reply_1.version.number ?? 0) + 1,
                                    when: new Date().toISOString()
                                }
                            };
                            setStoredCommentData({
                                ...storedCommentData,
                                replies: updatedReplies
                            });
                        }
                    }
                } else // For parent comments, update the main comment data
                if (storedCommentData.version) {
                    const updatedCommentData = {
                        ...storedCommentData,
                        body: {
                            value: adfString
                        },
                        version: {
                            ...storedCommentData.version,
                            by: {
                                ...storedCommentData.version.by,
                                displayName: sessionDisplayName || storedCommentData.version.by?.displayName || null
                            },
                            number: (storedCommentData.version.number ?? 0) + 1,
                            when: new Date().toISOString()
                        }
                    };
                    setStoredCommentData(updatedCommentData);
                }
            }
            // reset the editor
            onSuccess();
            resetContentChanged();
            displayCommentInViewMode();
        }).catch((error_0)=>{
            const { message: message } = (0, $isdzP.parseError)(error_0);
            const translatedError = (0, $isdzP.getTranslatedError)(message, commentId);
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $2d789a7ecebf6a19$var$i18n.cannotEditTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError)
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                        reason: 'Comment already deleted'
                    });
                }
            }
            if ((0, $isdzP.isUnexpectedError)(translatedError)) handleEditMutationFailure(error_0);
            else // These errors will not be reported to splunk/signalfx through experience tracking as they are expected
            (0, $7Sm4c.markErrorAsHandled)(error_0);
            return Promise.reject({
                error: translatedError
            });
        });
    };
    let parsedContent = undefined;
    try {
        parsedContent = JSON.parse(content);
    } catch (e) {
        $2d789a7ecebf6a19$var$logger.error`Unable to parse content ADF, ${e}`;
    }
    const showBranchingStyle = isFooterComment && isReply || (isStandaloneComment || isCommentsPanel) && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    // Create a wrapper for the editor component. If we have a branching style, the wrapper needs to use withBranchingStyle, otherwise just return as normal
    const BranchingStyleWrapper = (0, $42omo.useCallback)(({ children: children })=>{
        let customHeight = adjustForFooterReplies ? '25px' : '90px';
        let customLeft = isLastNestedFooterReply ? '-24px' : '-25px';
        if ((isStandaloneComment || isCommentsPanel) && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            customHeight = '65px';
            customLeft = isStandaloneComment ? '-24px' : '-25px';
        } else if (isFooterComment && (0, $9wGTI.fg)('confluence-fe-footer-comment-left-border')) customLeft = '-24px';
        return showBranchingStyle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: {
                // If we don't have children, line up with the author
                // If we do have children, line up with the bottom of the editor toolbar
                height: customHeight,
                left: customLeft
            }
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    }, [
        adjustForFooterReplies,
        isCommentsPanel,
        isFooterComment,
        isLastNestedFooterReply,
        isStandaloneComment,
        showBranchingStyle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BranchingStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $2d789a7ecebf6a19$var$editorContainerStyle,
            isFooterComment && $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyle,
            isStandaloneComment && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $2d789a7ecebf6a19$var$standaloneEditorReplyContainerStyle,
            isCommentsPanel && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $2d789a7ecebf6a19$var$panelEditorParentContainerStyle,
            (isCommentsPanel || isStandaloneComment) && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $2d789a7ecebf6a19$var$panelEditorReplyContainerStyle,
            isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $2d789a7ecebf6a19$var$adjustForBorderStyle
        ],
        "data-cy": "editor-edit-container",
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "edit",
        userId: userId,
        date: date,
        createdAtNonLocalized: createdAtNonLocalized,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        displayName: displayName,
        avatarUrl: avatarUrl,
        commentDateUrl: dateUrl,
        resolveProperties: resolveProperties,
        commentId: isCurrentUserAnonymous ? commentId : null,
        isCommentsPanel: isCommentsPanel,
        isGeneralComments: commentType === (0, $8i27m.CommentType).GENERAL,
        isReply: isReply,
        isEdited: isEdited,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            isFooterComment && $2d789a7ecebf6a19$var$editorBottomPaddingStyle,
            isFooterComment && adjustForFooterReplies && $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyle,
            isStandaloneComment && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $2d789a7ecebf6a19$var$standaloneEditorReplyWrapperStyle,
            isStandaloneComment && isReply && !isLastUnnestableReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $2d789a7ecebf6a19$var$leftBorderStyle,
            isCommentsPanel && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $2d789a7ecebf6a19$var$editorParentWrapperStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: isFooterComment ? 'comment' : 'chromeless',
        EditorComponent: isFooterComment ? (0, $lesF8.CommentEditor) : (0, $7EEGh.ChromelessEditor),
        commentId: commentId,
        commentMode: "edit",
        commentType: mode === 'view' ? 'inline' : 'edit-inline',
        onSaveComment: handleUpdateComment,
        content: parsedContent,
        onCancelComment: handleOnCancel,
        onContentChange: onChange,
        showCancelButton: true,
        useNewWarningModal: true,
        onEditorReady: handleOnEditorReady,
        hideWatchCheckbox: true,
        pageMode: mode,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isCommentsPanel: isCommentsPanel,
        isOffline: isOffline
    }))));
};
const $2d789a7ecebf6a19$export$55ec0e499a2afded = (0, $7aRa9.withFlags)($2d789a7ecebf6a19$var$EditCommentComponent);
module.exports["EditComment"] = $2d789a7ecebf6a19$export$55ec0e499a2afded;

});

parcelRegister("jkPJy", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $eea05c4e9d0eb879$export$9e679b96e845bbef = (0, $eSUdr.default)`query CommentsPanelQuery($pageId:ID!){comments(pageId:$pageId type:UNRESOLVED depth:ROOT first:50){nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized}}totalCount}}`;
module.exports["CommentsPanelQuery"] = $eea05c4e9d0eb879$export$9e679b96e845bbef;

});

parcelRegister("kEmgx", function(module, exports) {
/* CommentBody.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable confluence-feature-gating/no-preconditioning */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $2XqLN = parcelRequire("2XqLN");


var $8C5kA = parcelRequire("8C5kA");


var $21K7m = parcelRequire("21K7m");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $6mKj3 = parcelRequire("6mKj3");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $c6FO3 = parcelRequire("c6FO3");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $cAdj8 = parcelRequire("cAdj8");


var $c1UWH = parcelRequire("c1UWH");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");


var $9CnRS = parcelRequire("9CnRS");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<5e7437b40c394571a9c2bf7df510c7d7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $725c75c783c6239a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CommentActionsWriteReactionsSummaryFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "containerAri"
        },
        {
            "kind": "ScalarField",
            "name": "reactionsCount"
        },
        {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                }
            ]
        }
    ],
    "type": "ReactionsSummaryResponse"
};
$725c75c783c6239a$var$node.hash = "ac7b970423a77e8bceb853bf1fae7a69";
var $725c75c783c6239a$export$2e2bcd8739ae039 = $725c75c783c6239a$var$node;


/**
 * @generated SignedSource<<24382438ca2bb503d90f1c6f17380c02>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1b4836a71566dc4d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CommentActionsReadReactionsSummaryFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "containerAri"
        },
        {
            "kind": "ScalarField",
            "name": "reactionsCount"
        },
        {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                }
            ]
        }
    ],
    "type": "ReactionsSummaryResponse"
};
$1b4836a71566dc4d$var$node.hash = "e36b984d531a5ed453a45170e33f0598";
var $1b4836a71566dc4d$export$2e2bcd8739ae039 = $1b4836a71566dc4d$var$node;









var $eSUdr = parcelRequire("eSUdr");


var $jTxSS = parcelRequire("jTxSS");


var $gtD4K = parcelRequire("gtD4K");




var $xQxzY = parcelRequire("xQxzY");


var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $cvXh8 = parcelRequire("cvXh8");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");




var $2W0qg = parcelRequire("2W0qg");






var $3sFtD = parcelRequire("3sFtD");


var $c6fYi = parcelRequire("c6fYi");


var $1pSma = parcelRequire("1pSma");


var $diR4K = parcelRequire("diR4K");








var $8Ss4E = parcelRequire("8Ss4E");


var $2eC70 = parcelRequire("2eC70");

/* DisabledCommentAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $lsxnT = parcelRequire("lsxnT");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46066c9f9a854335$var$PopupPaddingContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _bfhk1aqn _syaz15cr",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$DisabledActionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReply: isReply, isInOverflowMenu: isInOverflowMenu, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _80omtlke _uiztglyw",
            __cmplp.isReply ? "_syazazsu" : "_syaz1rpy",
            __cmplp.isInOverflowMenu ? "_1yt4zc28" : "_ca0q1wug _u5f31wug _n3td1wug _19bv1wug",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _1bsbuuw1 _uiztglyw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$StyledLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1oa5 _1e0c1nu9 _80omtlke _9oik1r31 _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$export$fa26121f031ea499 = ({ action: action, isReply: isReply, isInOverflowMenu: isInOverflowMenu })=>{
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [showDialog, setShowDialog] = (0, $42omo.useState)(false);
    // make the dialog visible over the dropdown menu portal
    const dropdownMenu = document.querySelector(`[data-testid="comment-overflow-menu--content"]`);
    if (dropdownMenu && dropdownMenu.style) dropdownMenu.style.overflow = 'visible';
    const toggleDialog = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        setShowDialog(!showDialog);
    }, [
        showDialog
    ]);
    const triggerReplyEditor = ()=>{
        const textArea = document.querySelector(`[placeholder="Reply"]`);
        if (textArea) {
            textArea.focus();
            setShowDialog(false);
        }
    };
    const DialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$Container, {
        "data-testid": "disabled-explanation-dialog"
    }, action === 'edit' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$StyledLink, {
        "data-testid": "disabled-edit-action-link",
        onClick: triggerReplyEditor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment.no.edit.action.text",
        defaultMessage: "Add a new comment"
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment.no.edit.reason.text",
        defaultMessage: "since this one cannot be edited; it contains content created in a legacy version of Confluence."
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "comment.no.delete.reason.text",
        defaultMessage: "You can\u2019t delete this comment because it has replies."
    }));
    const renderActionText = ()=>{
        if (action === 'edit') return isReply ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "comment.no.edit.inline.label",
            defaultMessage: "Edit is not available"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "comment.no.edit.overflow.menu.label",
            defaultMessage: "Edit"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "comment.no.delete.overflow.menu.label",
            defaultMessage: "Delete"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        messageType: "transactional",
        messageId: "disabled-comment-action",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$PopupPaddingContainer, null, DialogContent),
        isOpen: showDialog,
        placement: isReply ? 'bottom' : 'bottom-end',
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46066c9f9a854335$var$DisabledActionContainer, {
                "data-testid": "disabled-action-container",
                onClick: toggleDialog,
                isReply: isReply,
                isInOverflowMenu: isInOverflowMenu,
                ...triggerProps
            }, renderActionText())
    });
};






var $cMvMc = parcelRequire("cMvMc");


var $2ttXz = parcelRequire("2ttXz");


var $1NF8X = parcelRequire("1NF8X");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $3jwuS = parcelRequire("3jwuS");


var $9sGCn = parcelRequire("9sGCn");





var $8aF6s = parcelRequire("8aF6s");








var $en1dX = parcelRequire("en1dX");








var $6hmtW = parcelRequire("6hmtW");





var $dYU3e = parcelRequire("dYU3e");


var $d9uxk = parcelRequire("d9uxk");

const $38c035d26bf2ba1b$export$d9882c6824bd8ea0 = async ({ cloudId: cloudId })=>{
    if (!cloudId || !(0, $9wGTI.fg)('dlp-dlm-data-retention-policy')) return;
    return (0, $dYU3e.query)({
        query: (0, $d9uxk.default),
        variables: {
            cloudId: cloudId
        },
        errorPolicy: 'all'
    });
};



var $3ejfs = parcelRequire("3ejfs");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $ad6ZE = parcelRequire("ad6ZE");


var $kmHPt = parcelRequire("kmHPt");


var $666Tc = parcelRequire("666Tc");





var $g0DaR = parcelRequire("g0DaR");

const $21f8bd546279fd06$var$CommentActionsReactionsCommentsQuery = (0, $eSUdr.default)`query CommentActionsReactionsCommentsQuery($contentId:ID!$containerId:ID!){comments(commentId:$contentId contentStatus:[DRAFT CURRENT]){nodes{id reactionsSummary(pageId:$containerId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
const $21f8bd546279fd06$var$reactionBelowCommentBodyStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $21f8bd546279fd06$var$itemStyles = null;
const $21f8bd546279fd06$var$reactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    marginLeft: 'space.200',
    paddingLeft: 'space.300',
    paddingBottom: 'space.100'
});
const $21f8bd546279fd06$var$reactionInCommentPanelStyleV2 = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.100'
});
const $21f8bd546279fd06$var$replyReactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.0',
    paddingLeft: 'space.0',
    paddingTop: 'space.150',
    paddingBottom: 'space.0'
});
const $21f8bd546279fd06$var$standaloneNewDesign = (0, $ecnYn.xcss)({
    marginLeft: 'space.0'
});
const $21f8bd546279fd06$var$withLeftBorderStyle = (0, $ecnYn.xcss)({
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $21f8bd546279fd06$var$customPaddingStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0'
}); // As footer does not have isDangling
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21f8bd546279fd06$var$OverflowDisabledDropdownItem = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dAYOx.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $dAYOx.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21f8bd546279fd06$var$DropdownMenuContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { isCommentsPanel: isCommentsPanel, enableDropdownForEditMode: enableDropdownForEditMode, showClose: showClose, isUnread: isUnread, isCommentActive: isCommentActive, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zs121y44 _l58r1y44 _14hp1tcg _1kmv1tcg _jq8g1tcg _k6rd1tcg _u5wqgktf _zbjigktf _boltgktf _5fdigktf",
            __cmplp.isCommentsPanel ? "_kqswh2mm" : "_kqswstnw",
            __cmplp.isCommentsPanel ? "_154iidpf" : __cmplp.mode === "view" ? "_154i1fm0" : __cmplp.enableDropdownForEditMode ? "_154iukr8" : __cmplp.showClose ? "_154ir5cr" : "_154i1i6y",
            __cmplp.isCommentsPanel ? "_1xi2n7od" : __cmplp.mode !== "view" ? __cmplp.enableDropdownForEditMode ? "_1xi21ejb" : __cmplp.showClose ? "_1xi21ejb" : "_1xi21b66" : __cmplp.isCommentsPanel ? !__cmplp.isUnread ? "_1xi2ze3t" : "_1xi21ejb" : "_1xi21jfw",
            !__cmplp.isCommentActive && __cmplp.mode === "view-all" ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, enableDropdownForEditMode: enableDropdownForEditMode, showClose: showClose, isUnread: isUnread, isCommentActive: isCommentActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zs121y44 _l58r1y44 _14hp1tcg _1kmv1tcg _jq8g1tcg _k6rd1tcg _u5wqgktf _zbjigktf _boltgktf _5fdigktf",
            __cmplp.isCommentsPanel ? "_kqswh2mm" : "_kqswstnw",
            __cmplp.isCommentsPanel ? "_154iidpf" : __cmplp.mode === 'view' ? "_154i1fm0" : __cmplp.enableDropdownForEditMode ? "_154iukr8" : __cmplp.showClose ? "_154ir5cr" : "_154i1i6y",
            __cmplp.isCommentsPanel ? "_1xi2n7od" : __cmplp.mode !== 'view' ? __cmplp.enableDropdownForEditMode ? "_1xi21ejb" : __cmplp.showClose ? "_1xi21ejb" : "_1xi21b66" : __cmplp.isCommentsPanel ? !__cmplp.isUnread ? "_1xi2ze3t" : "_1xi21ejb" : "_1xi21jfw",
            !__cmplp.isCommentActive && __cmplp.mode === 'view-all' ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
});
const $21f8bd546279fd06$var$clickableItemStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $21f8bd546279fd06$var$ReplyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ae4v1h6o _80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ae4v1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $21f8bd546279fd06$var$ReactionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { hasReactions: hasReactions, isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            __cmplp.hasReactions ? "_1e0c1ule" : "_1e0c116y",
            __cmplp.hasReactions ? "_i0dl1osq" : "_i0dl1wug",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_19pk1b66" : "_19pkze3t",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasReactions: hasReactions, isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.hasReactions ? "_1e0c1ule" : "_1e0c116y",
            __cmplp.hasReactions ? "_i0dl1osq" : "_i0dl1wug",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_19pk1b66" : "_19pkze3t",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ])
    });
});
const $21f8bd546279fd06$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syazazsu _1tke1tcg _4cvr1h6o _xrwlcs5v _144bkb7n _14p1f1ug _ekv61o8v _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _5lhmtlke _1tzjf4df _8bo21mp2 _nqnuazsu _d32vazsu _nlwjglyw _49cd7g83",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syazazsu _1tke1tcg _4cvr1h6o _xrwlcs5v _144bkb7n _14p1f1ug _ekv61o8v _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _5lhmtlke _1tzjf4df _8bo21mp2 _nqnuazsu _d32vazsu _nlwjglyw _49cd7g83",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $21f8bd546279fd06$var$ActionButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke _1as91r31 _j4qy8stv _1wwgnqa1 _y2mv7g83 _1bg4yh40",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke _1as91r31 _j4qy8stv _1wwgnqa1 _y2mv7g83 _1bg4yh40",
            __cmplp.className
        ])
    });
});
const $21f8bd546279fd06$var$pressableStyles = (0, $ecnYn.xcss)({
    ':hover': {
        textDecoration: 'underline'
    }
});
const $21f8bd546279fd06$var$rightAlignedActionItemsStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.0',
    display: 'flex',
    gap: 'space.075',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.150'
});
const $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle = (0, $ecnYn.xcss)({
    top: 'space.0'
});
const $21f8bd546279fd06$var$rightAlignedItemsStandaloneStyle = (0, $ecnYn.xcss)({
    top: 'space.150',
    right: 'space.200'
});
const $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle = (0, $ecnYn.xcss)({
    top: 'space.100'
});
const $21f8bd546279fd06$var$hoveredBackgroundInSidePanel = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-raised, #FFFFFF)"
});
const $21f8bd546279fd06$var$hoveredBackgroundCommentSurface = (0, $ecnYn.xcss)({
    background: "var(--ds-surface, #FFFFFF)"
}); // TODO: remove oldHoveredBackground when cleaning up `confluence_frontend_content_wrapper`
const $21f8bd546279fd06$var$oldHoveredBackground = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)"
});
const $21f8bd546279fd06$var$selectedBackground = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $21f8bd546279fd06$var$resolvedTextStyle = null;
const $21f8bd546279fd06$var$softBorderBase = null;
const $21f8bd546279fd06$var$softBorderPaddingOverride = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $21f8bd546279fd06$export$e75a036919cd8d68 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(283);
    const { pageId: pageId, pageType: pageType, commentId: commentId, permissions: permissions, isReply: isReply, parentCommentId: parentCommentId, restrictEdit: restrictEdit, restrictDelete: restrictDelete, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, isCommentActive: isCommentActive, mode: mode, onClose: onClose, overflowMenuPortal: overflowMenuPortal, supportedActions: t1, isCommentsPanel: t2, isHovered: isHovered, annotationId: annotationId, resolveProperties: resolveProperties, reopenComment: reopenComment, replyToComment: replyToComment, isUnread: t3, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, commentDateUrl: commentDateUrl, isResolvedByAnotherUser: isResolvedByAnotherUser, commentType: commentType, hideBranchingStyle: t4, canAddComments: t5, isDeletedByAnotherUser: t6, isSelected: t7, isParentCommentOpen: isParentCommentOpen, isFooterComment: t8, isStandaloneComment: t9, isOffline: t10, numReplies: numReplies, isFabricPage: t11, authorName: authorName, isArchived: isArchived } = t0;
    let t12;
    if ($[0] !== t1) {
        t12 = t1 === undefined ? [
            "edit",
            "delete",
            "resolve"
        ] : t1;
        $[0] = t1;
        $[1] = t12;
    } else t12 = $[1];
    const supportedActions = t12;
    const isCommentsPanel = t2 === undefined ? false : t2;
    const isUnread = t3 === undefined ? false : t3;
    const hideBranchingStyle = t4 === undefined ? false : t4;
    const canAddComments = t5 === undefined ? true : t5;
    const isDeletedByAnotherUser = t6 === undefined ? false : t6;
    const isSelected = t7 === undefined ? false : t7;
    const isFooterComment = t8 === undefined ? false : t8;
    const isStandaloneComment = t9 === undefined ? false : t9;
    const isOffline = t10 === undefined ? false : t10;
    const isFabricPage = t11 === undefined ? true : t11;
    const deletePressTracing = (0, $1pSma.default)("delete-comment-action");
    const editPressTracing = (0, $1pSma.default)("start-edit-comment-action");
    const replyPressTracing = (0, $1pSma.default)("start-reply-comment-action");
    const resolvePressTracing = (0, $1pSma.default)("resolve-comment-action");
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const [showCommentActionItems, setShowCommentActionItems] = (0, $42omo.useState)(false);
    const [isEditable, setIsEditable] = (0, $42omo.useState)(false);
    const [isRemovable, setIsRemovable] = (0, $42omo.useState)(false);
    const [isResolvable, setIsResolvable] = (0, $42omo.useState)(false);
    const [canBeReopened, setCanBeReopened] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const [reactionsCount, setReactionsCount] = (0, $42omo.useState)(inheritedReactionsData?.reactionsCount || 0);
    let t13;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = {};
        $[2] = t13;
    } else t13 = $[2];
    const [reactionParticleEffectByEmoji, setReactionParticleEffectByEmoji] = (0, $42omo.useState)(t13);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { updateReactionsSummary: updateReactionsSummary } = (0, $8i27m.useCommentsDataActions)();
    let t14;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = {
            fragmentSpec: (0, $1b4836a71566dc4d$export$2e2bcd8739ae039)
        };
        $[3] = t14;
    } else t14 = $[3];
    const readReactionsSummaryFragment = (0, $fFmJj.useReadFragmentInterop)(t14);
    let t15;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = {
            fragmentSpec: (0, $725c75c783c6239a$export$2e2bcd8739ae039)
        };
        $[4] = t15;
    } else t15 = $[4];
    const writeReactionsSummaryFragment = (0, $ij4CE.useWriteFragmentInterop)(t15);
    const { edition: edition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t16;
    if ($[5] !== contentId) {
        t16 = (0, $9sGCn.getCachedPageData)(contentId);
        $[5] = contentId;
        $[6] = t16;
    } else t16 = $[6];
    const { subType: subType } = t16;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t17;
    if ($[7] !== experienceTracker) {
        t17 = (error)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE),
                error: error
            });
        };
        $[7] = experienceTracker;
        $[8] = t17;
    } else t17 = $[8];
    const handleGqlError = t17;
    let t18;
    if ($[9] !== commentId || $[10] !== pageId) {
        t18 = {
            contentId: commentId,
            containerId: pageId
        };
        $[9] = commentId;
        $[10] = pageId;
        $[11] = t18;
    } else t18 = $[11];
    const t19 = Boolean(inheritedReactionsData);
    let t20;
    if ($[12] !== handleGqlError || $[13] !== t18 || $[14] !== t19) {
        t20 = {
            variables: t18,
            onError: handleGqlError,
            fetchPolicy: "cache-and-network",
            skip: t19
        };
        $[12] = handleGqlError;
        $[13] = t18;
        $[14] = t19;
        $[15] = t20;
    } else t20 = $[15];
    const { data: reactionsData, loading: reactionsLoading } = (0, $xQxzY.useQuery)($21f8bd546279fd06$var$CommentActionsReactionsCommentsQuery, t20);
    let t21;
    if ($[16] !== inheritedReactionsData || $[17] !== reactionsData?.comments?.nodes?.[0]?.reactionsSummary?.reactionsCount) {
        t21 = ()=>{
            const count = (inheritedReactionsData === undefined ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary?.reactionsCount : inheritedReactionsData?.reactionsCount) || 0;
            setReactionsCount(count);
        };
        $[16] = inheritedReactionsData;
        $[17] = reactionsData?.comments?.nodes?.[0]?.reactionsSummary?.reactionsCount;
        $[18] = t21;
    } else t21 = $[18];
    let t22;
    if ($[19] !== inheritedReactionsData || $[20] !== reactionsData) {
        t22 = [
            reactionsData,
            inheritedReactionsData
        ];
        $[19] = inheritedReactionsData;
        $[20] = reactionsData;
        $[21] = t22;
    } else t22 = $[21];
    (0, $42omo.useEffect)(t21, t22);
    let t23;
    if ($[22] !== annotationId || $[23] !== commentType || $[24] !== deleteComment || $[25] !== editComment || $[26] !== isCommentsPanel || $[27] !== isFabricPage || $[28] !== isHovered || $[29] !== isOffline || $[30] !== isReply || $[31] !== isResolvedByAnotherUser || $[32] !== mode || $[33] !== permissions?.isEditable || $[34] !== permissions?.isRemovable || $[35] !== permissions?.isResolvable || $[36] !== reopenComment || $[37] !== resolveComment || $[38] !== resolveProperties?.isDangling || $[39] !== resolveProperties?.resolved || $[40] !== supportedActions) {
        t23 = ()=>{
            const disabledByOfflineMode = isOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false);
            const canEdit = Boolean(permissions?.isEditable && editComment && supportedActions.includes("edit") && !disabledByOfflineMode);
            const canDelete = Boolean(permissions?.isRemovable && deleteComment && supportedActions.includes("delete") && !disabledByOfflineMode);
            const canResolve = Boolean(permissions?.isResolvable && resolveComment && supportedActions.includes("resolve") && !disabledByOfflineMode);
            const hasPermissionToReopen = reopenComment && supportedActions.includes("reopen") && permissions?.isResolvable;
            const canReopen = Boolean(hasPermissionToReopen && !isReply) && !disabledByOfflineMode;
            if (resolveProperties?.resolved && resolveProperties?.isDangling) {
                if (!(0, $9wGTI.fg)("confluence_frontend_content_wrapper")) setCanBeReopened(false);
                else setCanBeReopened(canReopen);
            } else setCanBeReopened(Boolean(canReopen && (resolveProperties?.resolved || isResolvedByAnotherUser) && (annotationId && (0, $g0DaR.inlineCommentExists)(annotationId) || commentType === (0, $8i27m.CommentType).GENERAL)));
            if (mode === "view" || mode === "edit") {
                if (!isReply) setIsResolvable(canResolve);
                else setIsResolvable(false);
                if (isCommentsPanel || isFabricPage && (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) {
                    const hasPermissions = canEdit || canDelete || canResolve;
                    const shouldShowDropdownMenu = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? true : !!isHovered && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && hasPermissions;
                    setShowCommentActionItems(shouldShowDropdownMenu);
                } else if (!isReply && (canEdit || canDelete || canResolve)) setShowCommentActionItems(true);
                setIsRemovable(canDelete);
                setIsEditable(canEdit);
            } else {
                setIsRemovable(canDelete);
                setIsEditable(canEdit);
                setIsResolvable(canResolve && !isReply);
            }
        };
        $[22] = annotationId;
        $[23] = commentType;
        $[24] = deleteComment;
        $[25] = editComment;
        $[26] = isCommentsPanel;
        $[27] = isFabricPage;
        $[28] = isHovered;
        $[29] = isOffline;
        $[30] = isReply;
        $[31] = isResolvedByAnotherUser;
        $[32] = mode;
        $[33] = permissions?.isEditable;
        $[34] = permissions?.isRemovable;
        $[35] = permissions?.isResolvable;
        $[36] = reopenComment;
        $[37] = resolveComment;
        $[38] = resolveProperties?.isDangling;
        $[39] = resolveProperties?.resolved;
        $[40] = supportedActions;
        $[41] = t23;
    } else t23 = $[41];
    const t24 = resolveProperties?.isDangling;
    const t25 = resolveProperties?.resolved;
    let t26;
    if ($[42] !== annotationId || $[43] !== commentType || $[44] !== deleteComment || $[45] !== editComment || $[46] !== isCommentsPanel || $[47] !== isFabricPage || $[48] !== isHovered || $[49] !== isOffline || $[50] !== isReply || $[51] !== isResolvedByAnotherUser || $[52] !== mode || $[53] !== permissions || $[54] !== reopenComment || $[55] !== resolveComment || $[56] !== supportedActions || $[57] !== t24 || $[58] !== t25) {
        t26 = [
            mode,
            permissions,
            isHovered,
            isReply,
            isCommentsPanel,
            supportedActions,
            deleteComment,
            editComment,
            resolveComment,
            reopenComment,
            t24,
            annotationId,
            t25,
            isResolvedByAnotherUser,
            commentType,
            isOffline,
            isFabricPage
        ];
        $[42] = annotationId;
        $[43] = commentType;
        $[44] = deleteComment;
        $[45] = editComment;
        $[46] = isCommentsPanel;
        $[47] = isFabricPage;
        $[48] = isHovered;
        $[49] = isOffline;
        $[50] = isReply;
        $[51] = isResolvedByAnotherUser;
        $[52] = mode;
        $[53] = permissions;
        $[54] = reopenComment;
        $[55] = resolveComment;
        $[56] = supportedActions;
        $[57] = t24;
        $[58] = t25;
        $[59] = t26;
    } else t26 = $[59];
    (0, $42omo.useEffect)(t23, t26);
    let t27;
    let t28;
    if ($[60] !== isCommentsPanel || $[61] !== isDropdownOpen || $[62] !== isHovered) {
        t27 = ()=>{
            if (isCommentsPanel && isDropdownOpen && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && !isHovered) setIsDropdownOpen(false);
        };
        t28 = [
            isCommentsPanel,
            isDropdownOpen,
            isHovered,
            setIsDropdownOpen
        ];
        $[60] = isCommentsPanel;
        $[61] = isDropdownOpen;
        $[62] = isHovered;
        $[63] = t27;
        $[64] = t28;
    } else {
        t27 = $[63];
        t28 = $[64];
    }
    (0, $42omo.useEffect)(t27, t28);
    let t29;
    if ($[65] !== isLivePage || $[66] !== mode) {
        t29 = ()=>{
            switch(mode){
                case "view":
                    return (0, $ad6ZE.InlineCommentMode).VIEW;
                case "edit":
                    if (isLivePage) return (0, $ad6ZE.InlineCommentMode).LIVE;
                    return (0, $ad6ZE.InlineCommentMode).EDIT;
            }
        };
        $[65] = isLivePage;
        $[66] = mode;
        $[67] = t29;
    } else t29 = $[67];
    const getInlineCommentModeConstant = t29;
    let handleDelete;
    if ($[68] !== annotationId || $[69] !== commentType || $[70] !== deleteComment || $[71] !== deletePressTracing || $[72] !== experienceTracker || $[73] !== getInlineCommentModeConstant || $[74] !== isCommentsPanel || $[75] !== isReply || $[76] !== showModal) {
        handleDelete = ()=>{
            if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    mode: getInlineCommentModeConstant(),
                    framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                    isReply: isReply,
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    annotationId: annotationId
                }
            });
            else experienceTracker.start({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    isReply: isReply
                }
            });
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    deleteCommentWithPressTracing();
                },
                isDelete: true,
                onCancel: ()=>{
                    experienceTracker.abort({
                        name: commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                        reason: "delete dialog closed"
                    });
                }
            });
        };
        const deleteCommentWithPressTracing = ()=>{
            if (!!deleteComment) {
                deletePressTracing();
                deleteComment();
            }
        };
        $[68] = annotationId;
        $[69] = commentType;
        $[70] = deleteComment;
        $[71] = deletePressTracing;
        $[72] = experienceTracker;
        $[73] = getInlineCommentModeConstant;
        $[74] = isCommentsPanel;
        $[75] = isReply;
        $[76] = showModal;
        $[77] = handleDelete;
    } else handleDelete = $[77];
    let t30;
    if ($[78] !== annotationId || $[79] !== commentType || $[80] !== editComment || $[81] !== edition || $[82] !== getInlineCommentModeConstant || $[83] !== isFooterComment || $[84] !== isReply) {
        t30 = ()=>{
            if (commentType === (0, $8i27m.CommentType).INLINE) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    mode: getInlineCommentModeConstant(),
                    framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                    isReply: isReply,
                    type: isReply ? "reply" : "topLevel",
                    annotationId: annotationId
                }
            }, {
                name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE)
            });
            else (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    type: isReply ? "reply" : "topLevel",
                    source: isFooterComment ? (0, $en1dX.AnalyticsSource).PAGE_FOOTER : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                }
            }, {
                name: (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            editComment && editComment();
        };
        $[78] = annotationId;
        $[79] = commentType;
        $[80] = editComment;
        $[81] = edition;
        $[82] = getInlineCommentModeConstant;
        $[83] = isFooterComment;
        $[84] = isReply;
        $[85] = t30;
    } else t30 = $[85];
    const handleEditComment = t30;
    let t31;
    if ($[86] !== editPressTracing || $[87] !== handleEditComment) {
        t31 = ()=>{
            editPressTracing();
            handleEditComment();
        };
        $[86] = editPressTracing;
        $[87] = handleEditComment;
        $[88] = t31;
    } else t31 = $[88];
    const handleEditCommentWithPressTracing = t31;
    let handleReply;
    if ($[89] !== commentId || $[90] !== hasContentChanged || $[91] !== isFooterComment || $[92] !== parentCommentId || $[93] !== replyPressTracing || $[94] !== replyToComment || $[95] !== resetContentChanged || $[96] !== showModal) {
        handleReply = ()=>{
            const replyToCommentId = isFooterComment ? commentId : parentCommentId || commentId;
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    replyToCommentWithPressTracing(replyToCommentId);
                }
            });
            else replyToCommentWithPressTracing(replyToCommentId);
        };
        const replyToCommentWithPressTracing = (replyToCommentId_0)=>{
            if (!!replyToComment) {
                replyPressTracing();
                replyToComment(replyToCommentId_0);
            }
        };
        $[89] = commentId;
        $[90] = hasContentChanged;
        $[91] = isFooterComment;
        $[92] = parentCommentId;
        $[93] = replyPressTracing;
        $[94] = replyToComment;
        $[95] = resetContentChanged;
        $[96] = showModal;
        $[97] = handleReply;
    } else handleReply = $[97];
    let t32;
    if ($[98] !== commentDateUrl) {
        t32 = async ()=>{
            const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
            if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(linkToComment);
            else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(linkToComment);
        };
        $[98] = commentDateUrl;
        $[99] = t32;
    } else t32 = $[99];
    const handleCopyLink = t32;
    let handleResolveComment;
    if ($[100] !== annotationId || $[101] !== commentId || $[102] !== commentType || $[103] !== experienceTracker || $[104] !== getInlineCommentModeConstant || $[105] !== hasContentChanged || $[106] !== resetContentChanged || $[107] !== resolveComment || $[108] !== resolvePressTracing || $[109] !== showModal) {
        handleResolveComment = ()=>{
            const doResolve = ()=>{
                if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
                    name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
                    id: commentId,
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        mode: getInlineCommentModeConstant(),
                        framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                        annotationId: annotationId
                    }
                });
                else experienceTracker.start({
                    name: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE),
                    id: commentId,
                    attributes: {
                        ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                        annotationId: annotationId
                    }
                });
                resolveCommentWithPressTracing();
            };
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    doResolve();
                }
            });
            else doResolve();
        };
        const resolveCommentWithPressTracing = ()=>{
            if (!!resolveComment) {
                resolvePressTracing();
                resolveComment();
            }
        };
        $[100] = annotationId;
        $[101] = commentId;
        $[102] = commentType;
        $[103] = experienceTracker;
        $[104] = getInlineCommentModeConstant;
        $[105] = hasContentChanged;
        $[106] = resetContentChanged;
        $[107] = resolveComment;
        $[108] = resolvePressTracing;
        $[109] = showModal;
        $[110] = handleResolveComment;
    } else handleResolveComment = $[110];
    let t33;
    if ($[111] !== reopenComment) {
        t33 = ()=>{
            reopenComment && reopenComment();
        };
        $[111] = reopenComment;
        $[112] = t33;
    } else t33 = $[112];
    const handleReopenComment = t33;
    let t34;
    if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = (emojiId, show)=>{
            setReactionParticleEffectByEmoji((prev)=>({
                    ...prev,
                    [emojiId]: show
                }));
        };
        $[113] = t34;
    } else t34 = $[113];
    const handleParticleEffectChange = t34;
    let t35;
    if ($[114] !== handleEditComment || $[115] !== handleEditCommentWithPressTracing || $[116] !== isReply) {
        t35 = (isRestricted, isDropdownMenu)=>{
            if (isDropdownMenu) return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$OverflowDisabledDropdownItem, {
                testId: "disabled-edit-comment-dropdown-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
                action: "edit",
                isReply: isReply,
                isInOverflowMenu: true
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                testId: "edit-comment-dropdown-action",
                "data-cy": "edit-comment-action",
                onClick: handleEditComment,
                interactionName: "start-edit-comment-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit));
            return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
                action: "edit",
                isReply: isReply,
                isInOverflowMenu: true
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
                "data-testid": "edit-comment-action",
                "data-cy": "edit-comment-action",
                onClick: handleEditCommentWithPressTracing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit));
        };
        $[114] = handleEditComment;
        $[115] = handleEditCommentWithPressTracing;
        $[116] = isReply;
        $[117] = t35;
    } else t35 = $[117];
    const renderEditAction = t35;
    let t36;
    if ($[118] !== cloudId || $[119] !== handleDelete || $[120] !== isReply) {
        t36 = (isRestricted_0, isDropdownMenu_0)=>{
            if (isDropdownMenu_0) return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$OverflowDisabledDropdownItem, {
                testId: "disabled-delete-comment-dropdown-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
                action: "delete",
                isReply: isReply,
                isInOverflowMenu: true
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                testId: "delete-comment-dropdown-action",
                onClick: handleDelete
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete));
            return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
                action: "delete",
                isReply: isReply
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
                "data-testid": "delete-comment-action",
                onClick: handleDelete,
                onMouseEnter: ()=>(0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                        cloudId: cloudId
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete));
        };
        $[118] = cloudId;
        $[119] = handleDelete;
        $[120] = isReply;
        $[121] = t36;
    } else t36 = $[121];
    const renderDeleteAction = t36;
    let t37;
    if ($[122] !== canBeReopened || $[123] !== formatMessage || $[124] !== handleReopenComment || $[125] !== isCommentsPanel || $[126] !== isResolvedByAnotherUser || $[127] !== resolveProperties?.isDangling) {
        t37 = ()=>canBeReopened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o"
                ])
            }, isResolvedByAnotherUser && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c81vhk _syazazsu"
                ])
            }, formatMessage((0, $9CnRS.i18n).resolved)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                        ...iconProps,
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #6A9A23)",
                        label: formatMessage((0, $9CnRS.i18n).reopen)
                    }),
                label: formatMessage((0, $9CnRS.i18n).reopen),
                isTooltipDisabled: false,
                onClick: handleReopenComment,
                appearance: "subtle",
                testId: "reopen-comment-action",
                analyticsContext: {
                    attributes: {
                        name: (0, $en1dX.ActionName).REOPEN_COMMENT,
                        source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                        isDanglingComment: resolveProperties?.isDangling
                    }
                }
            }));
        $[122] = canBeReopened;
        $[123] = formatMessage;
        $[124] = handleReopenComment;
        $[125] = isCommentsPanel;
        $[126] = isResolvedByAnotherUser;
        $[127] = resolveProperties?.isDangling;
        $[128] = t37;
    } else t37 = $[128];
    const renderReopenComment = t37;
    let t38;
    if ($[129] !== handleReply || $[130] !== isCommentsPanel) {
        t38 = ()=>{
            if (!isCommentsPanel && !(0, $9wGTI.fg)("confluence_frontend_comments_panel_v2")) return;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ReplyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
                "data-testid": "reply-comment-action",
                "data-cy": "reply-comment-action",
                onClick: handleReply
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).replyPlaceholder)));
        };
        $[129] = handleReply;
        $[130] = isCommentsPanel;
        $[131] = t38;
    } else t38 = $[131];
    const renderReplyAction = t38;
    let t39;
    if ($[132] !== handleCopyLink) {
        t39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                testId: "copy-link-dropdown-action",
                onClick: handleCopyLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).copyLink));
        $[132] = handleCopyLink;
        $[133] = t39;
    } else t39 = $[133];
    const renderCopyButton = t39;
    let t40;
    if ($[134] !== handleResolveComment || $[135] !== isCommentsPanel || $[136] !== isReply) {
        t40 = ()=>{
            if (isCommentsPanel && isReply && (0, $9wGTI.fg)("confluence-frontend-comments-panel")) return;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                testId: "resolve-comment-dropdown-action",
                onClick: handleResolveComment
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve));
        };
        $[134] = handleResolveComment;
        $[135] = isCommentsPanel;
        $[136] = isReply;
        $[137] = t40;
    } else t40 = $[137];
    const renderResolveOption = t40;
    let t41;
    if ($[138] !== cloudId || $[139] !== commentType || $[140] !== formatMessage || $[141] !== isCommentActive || $[142] !== isCommentsPanel || $[143] !== isDropdownOpen || $[144] !== isEditable || $[145] !== isFabricPage || $[146] !== isFooterComment || $[147] !== isRemovable || $[148] !== isReply || $[149] !== isResolvable || $[150] !== isUnread || $[151] !== mode || $[152] !== onClose || $[153] !== overflowMenuPortal || $[154] !== renderCopyButton || $[155] !== renderDeleteAction || $[156] !== renderEditAction || $[157] !== renderResolveOption || $[158] !== showCommentActionItems) {
        t41 = (editRestricted, deleteRestricted)=>{
            const hasNoCommmentPermissions = !isEditable && !isRemovable && (isReply || !isResolvable);
            const shouldHideDropdownForStandalone = !isCommentsPanel && hasNoCommmentPermissions;
            const shouldHideDropdownForCommentsPanel = isCommentsPanel && hasNoCommmentPermissions && !(0, $9wGTI.fg)("confluence_frontend_comments_panel_v2");
            if (shouldHideDropdownForStandalone || shouldHideDropdownForCommentsPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            const dropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$DropdownMenuContainer, {
                "data-cy": "comment-overflow-actions-menu",
                "data-testid": "comment-overflow-actions-menu",
                isCommentActive: isCommentActive,
                mode: mode,
                showClose: Boolean(onClose),
                enableDropdownForEditMode: (0, $9wGTI.fg)("confluence-frontend-comments-panel") || mode === "edit",
                isCommentsPanel: (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage,
                isUnread: isUnread
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
                testId: "comment-overflow-menu",
                isOpen: isDropdownOpen,
                placement: "bottom-end",
                onOpenChange: (t42)=>{
                    const { isOpen: isOpen, event: event } = t42;
                    event?.stopPropagation();
                    setIsDropdownOpen(isOpen);
                    if (isRemovable) (0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                        cloudId: cloudId
                    });
                },
                trigger: (t43)=>{
                    const { triggerRef: triggerRef, ...props } = t43;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                        ...props,
                        testId: "comment-overflow-menu-trigger",
                        ref: triggerRef,
                        label: formatMessage((0, $9CnRS.i18n).commentActionsMenuLabel),
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                        isTooltipDisabled: false,
                        isSelected: isDropdownOpen,
                        analyticsContext: {
                            attributes: {
                                name: "moreActionsButton",
                                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                                commentType: commentType
                            }
                        }
                    });
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, isFabricPage && (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && (0, $9wGTI.fg)("confluence_frontend_comments_panel_v2") && renderCopyButton(), (!isCommentsPanel && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") || !isFabricPage && !isFooterComment) && isResolvable && renderResolveOption(), isEditable && renderEditAction(editRestricted, showCommentActionItems), isRemovable && renderDeleteAction(deleteRestricted, showCommentActionItems))));
            return overflowMenuPortal && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? /*#__PURE__*/ (0, $jTxSS.createPortal)(dropdownMenu, overflowMenuPortal) : dropdownMenu;
        };
        $[138] = cloudId;
        $[139] = commentType;
        $[140] = formatMessage;
        $[141] = isCommentActive;
        $[142] = isCommentsPanel;
        $[143] = isDropdownOpen;
        $[144] = isEditable;
        $[145] = isFabricPage;
        $[146] = isFooterComment;
        $[147] = isRemovable;
        $[148] = isReply;
        $[149] = isResolvable;
        $[150] = isUnread;
        $[151] = mode;
        $[152] = onClose;
        $[153] = overflowMenuPortal;
        $[154] = renderCopyButton;
        $[155] = renderDeleteAction;
        $[156] = renderEditAction;
        $[157] = renderResolveOption;
        $[158] = showCommentActionItems;
        $[159] = t41;
    } else t41 = $[159];
    const renderDropdownMenu = t41;
    let t42;
    bb0: {
        if (reactionsCacheUpdateFn) {
            t42 = reactionsCacheUpdateFn;
            break bb0;
        }
        let t43;
        if ($[160] !== annotationId || $[161] !== commentService || $[162] !== commentType || $[163] !== inheritedReactionsData || $[164] !== isCommentsPanel || $[165] !== readReactionsSummaryFragment || $[166] !== updateReactionsSummary || $[167] !== writeReactionsSummaryFragment) {
            t43 = inheritedReactionsData !== undefined && isCommentsPanel ? (emojiId_0, actionType, objectId, containerId, cache)=>{
                setReactionParticleEffectByEmoji((prev_0)=>({
                        ...prev_0,
                        [emojiId_0]: actionType === "add"
                    }));
                if (annotationId && emojiId_0 && actionType) commentService?.onUpdateReaction(annotationId, emojiId_0, actionType);
                return updateReactionsSummary(emojiId_0, actionType, objectId, commentType, readReactionsSummaryFragment, writeReactionsSummaryFragment, containerId, annotationId, cache);
            } : undefined;
            $[160] = annotationId;
            $[161] = commentService;
            $[162] = commentType;
            $[163] = inheritedReactionsData;
            $[164] = isCommentsPanel;
            $[165] = readReactionsSummaryFragment;
            $[166] = updateReactionsSummary;
            $[167] = writeReactionsSummaryFragment;
            $[168] = t43;
        } else t43 = $[168];
        t42 = t43;
    }
    const reactionsUpdateFn = t42;
    let t43;
    if ($[169] !== authorName || $[170] !== formatMessage || $[171] !== handleReply) {
        t43 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                testId: "comment-reply-button",
                label: (0, $6mKj3.expVal)("confluence_frontend_comments_a11y_kb_exp", "isEnabled", false) ? formatMessage((0, $9CnRS.i18n).replyPlaceholderWithName, {
                    name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
                }) : formatMessage((0, $9CnRS.i18n).replyPlaceholder),
                appearance: "subtle",
                spacing: "compact",
                icon: (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($diR4K))) : (0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))),
                onClick: handleReply,
                isTooltipDisabled: false
            });
        $[169] = authorName;
        $[170] = formatMessage;
        $[171] = handleReply;
        $[172] = t43;
    } else t43 = $[172];
    const renderReplyButton = t43;
    let t44;
    if ($[173] !== commentType || $[174] !== formatMessage || $[175] !== handleResolveComment || $[176] !== isCommentsPanel) {
        t44 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                testId: "comment-resolve-action-item",
                label: (0, $6mKj3.expVal)("confluence_frontend_comments_a11y_kb_exp", "isEnabled", false) ? formatMessage((0, $9CnRS.i18n).resolveThread) : formatMessage((0, $9CnRS.i18n).resolve),
                appearance: "subtle",
                spacing: "compact",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
                onClick: handleResolveComment,
                isTooltipDisabled: false,
                analyticsContext: {
                    attributes: {
                        name: "resolveActionsButton",
                        source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: commentType
                    }
                },
                className: (0, $gMc0m.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ])
            });
        $[173] = commentType;
        $[174] = formatMessage;
        $[175] = handleResolveComment;
        $[176] = isCommentsPanel;
        $[177] = t44;
    } else t44 = $[177];
    const renderResolveActionButton = t44;
    let t45;
    if ($[178] !== authorName || $[179] !== commentId || $[180] !== formatMessage || $[181] !== inheritedReactionsData || $[182] !== isCommentsPanel || $[183] !== isFabricPage || $[184] !== isReply || $[185] !== mode || $[186] !== pageId || $[187] !== pageType || $[188] !== reactionParticleEffectByEmoji || $[189] !== reactionsCount || $[190] !== reactionsData?.comments?.nodes?.[0]?.reactionsSummary || $[191] !== reactionsUpdateFn || $[192] !== subType) {
        t45 = (t46)=>{
            const { onlyRenderPicker: t47, readOnly: t48 } = t46 === undefined ? {} : t46;
            const onlyRenderPicker = t47 === undefined ? false : t47;
            const readOnly = t48 === undefined ? false : t48;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ReactionsContainer, {
                hasReactions: reactionsCount > 0,
                isCommentsPanel: (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage,
                onClick: $21f8bd546279fd06$var$_temp,
                ...(0, $6mKj3.expVal)("confluence_frontend_comments_a11y_kb_exp", "isEnabled", false) ? {
                    "aria-label": formatMessage((0, $9CnRS.i18n).reactionAriaLabelWithName, {
                        name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
                    })
                } : {}
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
                readOnly: readOnly,
                contentId: commentId,
                containerId: pageId,
                containerType: pageType,
                location: mode === "edit" ? (0, $2ttXz.ReactionLocation).EDITOR_INLINE_COMMENT : (0, $2ttXz.ReactionLocation).INLINE_COMMENT,
                hidePlaceholder: reactionsCount === 0 || inheritedReactionsData !== undefined || inheritedReactionsData !== null,
                reactionsData: inheritedReactionsData === undefined || inheritedReactionsData === null ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary : inheritedReactionsData,
                updateCache: reactionsUpdateFn,
                onlyRenderPicker: onlyRenderPicker,
                isSubtle: isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper"),
                showAddReactionText: false,
                customAnalyticsAttributes: {
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    isReply: isReply,
                    mode: mode
                },
                contentSubType: subType,
                isListItem: false,
                key: `reactions-${commentId}-${onlyRenderPicker}`,
                particleEffectByEmoji: reactionParticleEffectByEmoji,
                onParticleEffectChange: handleParticleEffectChange
            }));
        };
        $[178] = authorName;
        $[179] = commentId;
        $[180] = formatMessage;
        $[181] = inheritedReactionsData;
        $[182] = isCommentsPanel;
        $[183] = isFabricPage;
        $[184] = isReply;
        $[185] = mode;
        $[186] = pageId;
        $[187] = pageType;
        $[188] = reactionParticleEffectByEmoji;
        $[189] = reactionsCount;
        $[190] = reactionsData?.comments?.nodes?.[0]?.reactionsSummary;
        $[191] = reactionsUpdateFn;
        $[192] = subType;
        $[193] = t45;
    } else t45 = $[193];
    const renderReactions = t45;
    let t46;
    if ($[194] !== handleReopenComment) {
        t46 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                testId: "old-reopen-comment-action",
                onClick: handleReopenComment,
                padding: "space.0",
                backgroundColor: "color.background.neutral.subtle",
                xcss: $21f8bd546279fd06$var$pressableStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text.subtlest",
                size: "small"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).reopen)));
        $[194] = handleReopenComment;
        $[195] = t46;
    } else t46 = $[195];
    const renderV1ReopenComment = t46;
    let t47;
    if ($[196] !== isCommentsPanel || $[197] !== isHovered || $[198] !== isSelected) {
        t47 = ()=>{
            if (isCommentsPanel) {
                if (isSelected) return "var(--ds-background-input-hovered, #F8F8F8)";
                else {
                    if (isHovered) return "var(--ds-surface-raised, #FFFFFF)";
                }
            }
            return "var(--ds-surface, #FFFFFF)";
        };
        $[196] = isCommentsPanel;
        $[197] = isHovered;
        $[198] = isSelected;
        $[199] = t47;
    } else t47 = $[199];
    const getActionItemsBackgroundColor = t47;
    let t48;
    if ($[200] !== canAddComments || $[201] !== getActionItemsBackgroundColor || $[202] !== isArchived || $[203] !== isCommentsPanel || $[204] !== isFabricPage || $[205] !== isFooterComment || $[206] !== isHovered || $[207] !== isOffline || $[208] !== isReactionsEnabled || $[209] !== isReply || $[210] !== isResolvable || $[211] !== isResolvedByAnotherUser || $[212] !== isSelected || $[213] !== isStandaloneComment || $[214] !== reactionsLoading || $[215] !== renderDropdownMenu || $[216] !== renderReactions || $[217] !== renderReplyButton || $[218] !== renderResolveActionButton || $[219] !== resolveProperties?.resolved || $[220] !== restrictDelete || $[221] !== restrictEdit) {
        t48 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                "data-testId": "comment-action-items",
                xcss: [
                    $21f8bd546279fd06$var$rightAlignedActionItemsStyle,
                    $21f8bd546279fd06$var$clickableItemStyle,
                    isStandaloneComment && $21f8bd546279fd06$var$hoveredBackgroundCommentSurface,
                    isHovered && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $21f8bd546279fd06$var$oldHoveredBackground,
                    isHovered && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && (isFooterComment || isStandaloneComment || !isCommentsPanel ? $21f8bd546279fd06$var$hoveredBackgroundCommentSurface : $21f8bd546279fd06$var$hoveredBackgroundInSidePanel),
                    isSelected && !isStandaloneComment && $21f8bd546279fd06$var$selectedBackground,
                    isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle,
                    (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage && !isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle,
                    !isCommentsPanel && !isFooterComment && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && isFabricPage && $21f8bd546279fd06$var$rightAlignedItemsStandaloneStyle,
                    isCommentsPanel && isReply && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle,
                    (0, $6mKj3.expValEquals)("confluence_cohiti_comment_hover_actions", "isEnabled", true) && $21f8bd546279fd06$var$softBorderPaddingOverride
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: {
                    boxShadow: (0, $6mKj3.expValEquals)("confluence_cohiti_comment_hover_actions", "isEnabled", true) ? `-10px 0 10px 0px ${getActionItemsBackgroundColor()}` : ""
                },
                "data-testId": "comment-hover-actions-container",
                className: (0, $gMc0m.default)([
                    "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o",
                    (0, $6mKj3.expValEquals)("confluence_cohiti_comment_hover_actions", "isEnabled", true) && "_1reo15vq _18m915vq _2rko12b0 _kqswh2mm _c71l1kw7"
                ])
            }, !resolveProperties?.resolved && !isResolvedByAnotherUser && (!isReply || isFooterComment || isCommentsPanel && (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && !isArchived && canAddComments && renderReplyButton(), isReactionsEnabled && !reactionsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderReactions({
                onlyRenderPicker: true,
                readOnly: isOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            })), !isReply && !resolveProperties?.resolved && !isResolvedByAnotherUser && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderResolveActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderDropdownMenu(restrictEdit, restrictDelete))));
        $[200] = canAddComments;
        $[201] = getActionItemsBackgroundColor;
        $[202] = isArchived;
        $[203] = isCommentsPanel;
        $[204] = isFabricPage;
        $[205] = isFooterComment;
        $[206] = isHovered;
        $[207] = isOffline;
        $[208] = isReactionsEnabled;
        $[209] = isReply;
        $[210] = isResolvable;
        $[211] = isResolvedByAnotherUser;
        $[212] = isSelected;
        $[213] = isStandaloneComment;
        $[214] = reactionsLoading;
        $[215] = renderDropdownMenu;
        $[216] = renderReactions;
        $[217] = renderReplyButton;
        $[218] = renderResolveActionButton;
        $[219] = resolveProperties?.resolved;
        $[220] = restrictDelete;
        $[221] = restrictEdit;
        $[222] = t48;
    } else t48 = $[222];
    const renderActionItemsOnHover = t48;
    let t49;
    if ($[223] !== isCommentsPanel || $[224] !== isFabricPage || $[225] !== isFooterComment || $[226] !== isResolvedByAnotherUser || $[227] !== renderReopenComment || $[228] !== renderV1ReopenComment || $[229] !== resolveProperties?.resolved) {
        t49 = ()=>{
            const isResolved = resolveProperties?.resolved || isResolvedByAnotherUser;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: (0, $9wGTI.fg)("confluence_frontend_comments_panel_v2") && [
                    $21f8bd546279fd06$var$rightAlignedActionItemsStyle,
                    (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage && !isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle,
                    isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle
                ],
                testId: "static-actions-items"
            }, (0, $9wGTI.fg)("confluence_frontend_comments_panel_v2") ? renderReopenComment() : renderV1ReopenComment()));
        };
        $[223] = isCommentsPanel;
        $[224] = isFabricPage;
        $[225] = isFooterComment;
        $[226] = isResolvedByAnotherUser;
        $[227] = renderReopenComment;
        $[228] = renderV1ReopenComment;
        $[229] = resolveProperties?.resolved;
        $[230] = t49;
    } else t49 = $[230];
    const renderStaticActionsItemsForCommentsPanel = t49;
    let t50;
    if ($[231] !== canAddComments || $[232] !== hideBranchingStyle || $[233] !== isCommentsPanel || $[234] !== isDeletedByAnotherUser || $[235] !== isDropdownOpen || $[236] !== isFabricPage || $[237] !== isFooterComment || $[238] !== isHovered || $[239] !== isOffline || $[240] !== isParentCommentOpen || $[241] !== isReactionsEnabled || $[242] !== isReply || $[243] !== isResolvedByAnotherUser || $[244] !== numReplies || $[245] !== reactionsCount || $[246] !== reactionsLoading || $[247] !== renderActionItemsOnHover || $[248] !== renderReactions || $[249] !== renderReplyAction || $[250] !== renderStaticActionsItemsForCommentsPanel || $[251] !== resolveProperties?.resolved) {
        t50 = ()=>{
            const shouldRenderReplyAction = !resolveProperties?.resolved && !isResolvedByAnotherUser && !(0, $9wGTI.fg)("confluence_frontend_comments_panel_v2");
            const isReadOnlyForResolved = resolveProperties?.resolved || isReply && !isParentCommentOpen;
            const isDisabledByOfflineMode = ()=>isOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false);
            const commonElements = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderReplyAction && renderReplyAction(), isReactionsEnabled && !reactionsLoading && reactionsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $21f8bd546279fd06$var$reactionBelowCommentBodyStyle,
                    (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage && $21f8bd546279fd06$var$reactionInCommentPanelStyle,
                    (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage && (0, $9wGTI.fg)("confluence_frontend_comments_panel_v2") && $21f8bd546279fd06$var$reactionInCommentPanelStyleV2,
                    (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage && isReply && (0, $9wGTI.fg)("confluence_frontend_comments_panel_v2") && $21f8bd546279fd06$var$replyReactionInCommentPanelStyle,
                    (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage && !isReply && (!hideBranchingStyle && canAddComments || isReadOnlyForResolved && numReplies !== 0) && (0, $9wGTI.fg)("confluence_frontend_comments_panel_v2") && $21f8bd546279fd06$var$withLeftBorderStyle,
                    !isCommentsPanel && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && isFabricPage && $21f8bd546279fd06$var$standaloneNewDesign,
                    !isCommentsPanel && !isFooterComment && hideBranchingStyle && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && isFabricPage && $21f8bd546279fd06$var$customPaddingStyle
                ]
            }, renderReactions({
                readOnly: isReadOnlyForResolved || isDisabledByOfflineMode()
            })));
            const shouldRenderHoverState = ()=>{
                if (isReply && !isParentCommentOpen) return false;
                else return (isHovered || isDropdownOpen && (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && !resolveProperties?.resolved && !isDeletedByAnotherUser;
            };
            const stateSpecificElements = shouldRenderHoverState() ? renderActionItemsOnHover() : renderStaticActionsItemsForCommentsPanel();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, stateSpecificElements, commonElements);
        };
        $[231] = canAddComments;
        $[232] = hideBranchingStyle;
        $[233] = isCommentsPanel;
        $[234] = isDeletedByAnotherUser;
        $[235] = isDropdownOpen;
        $[236] = isFabricPage;
        $[237] = isFooterComment;
        $[238] = isHovered;
        $[239] = isOffline;
        $[240] = isParentCommentOpen;
        $[241] = isReactionsEnabled;
        $[242] = isReply;
        $[243] = isResolvedByAnotherUser;
        $[244] = numReplies;
        $[245] = reactionsCount;
        $[246] = reactionsLoading;
        $[247] = renderActionItemsOnHover;
        $[248] = renderReactions;
        $[249] = renderReplyAction;
        $[250] = renderStaticActionsItemsForCommentsPanel;
        $[251] = resolveProperties?.resolved;
        $[252] = t50;
    } else t50 = $[252];
    const renderCommentsPanelActionItems = t50;
    let t51;
    if ($[253] !== handleResolveComment || $[254] !== isCommentsPanel || $[255] !== isEditable || $[256] !== isOffline || $[257] !== isReactionsEnabled || $[258] !== isRemovable || $[259] !== isReply || $[260] !== isResolvable || $[261] !== mode || $[262] !== reactionsLoading || $[263] !== renderDeleteAction || $[264] !== renderEditAction || $[265] !== renderReactions || $[266] !== renderReplyAction || $[267] !== resolveProperties?.resolved || $[268] !== restrictDelete || $[269] !== restrictEdit || $[270] !== showCommentActionItems) {
        t51 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ActionsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
                "aria-hidden": "true"
            }), !isReply && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
                mode: mode,
                isReply: isReply
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
                "data-testid": "resolve-comment-action",
                "data-cy": "resolve-comment-action",
                onClick: handleResolveComment
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve))), !showCommentActionItems && isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
                mode: mode,
                isReply: isReply
            }, renderEditAction(restrictEdit, showCommentActionItems)), !showCommentActionItems && isRemovable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
                mode: mode,
                isReply: isReply
            }, renderDeleteAction(restrictDelete, showCommentActionItems)), isReactionsEnabled && !reactionsLoading && !resolveProperties?.resolved && renderReactions({
                readOnly: isOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
            }), !resolveProperties?.resolved || isCommentsPanel && (0, $9wGTI.fg)("confluence-frontend-comments-panel") && renderReplyAction());
        $[253] = handleResolveComment;
        $[254] = isCommentsPanel;
        $[255] = isEditable;
        $[256] = isOffline;
        $[257] = isReactionsEnabled;
        $[258] = isRemovable;
        $[259] = isReply;
        $[260] = isResolvable;
        $[261] = mode;
        $[262] = reactionsLoading;
        $[263] = renderDeleteAction;
        $[264] = renderEditAction;
        $[265] = renderReactions;
        $[266] = renderReplyAction;
        $[267] = resolveProperties?.resolved;
        $[268] = restrictDelete;
        $[269] = restrictEdit;
        $[270] = showCommentActionItems;
        $[271] = t51;
    } else t51 = $[271];
    const renderStandaloneCommentActions = t51;
    let t52;
    if ($[272] !== isReply || $[273] !== renderDropdownMenu || $[274] !== renderStandaloneCommentActions || $[275] !== restrictDelete || $[276] !== restrictEdit) {
        t52 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isReply && renderDropdownMenu(restrictEdit, restrictDelete), renderStandaloneCommentActions());
        $[272] = isReply;
        $[273] = renderDropdownMenu;
        $[274] = renderStandaloneCommentActions;
        $[275] = restrictDelete;
        $[276] = restrictEdit;
        $[277] = t52;
    } else t52 = $[277];
    const renderStandaloneCommentActionItems = t52;
    let t53;
    if ($[278] !== isCommentsPanel || $[279] !== isFabricPage || $[280] !== renderCommentsPanelActionItems || $[281] !== renderStandaloneCommentActionItems) {
        t53 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (isCommentsPanel || (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) && isFabricPage ? renderCommentsPanelActionItems() : renderStandaloneCommentActionItems());
        $[278] = isCommentsPanel;
        $[279] = isFabricPage;
        $[280] = renderCommentsPanelActionItems;
        $[281] = renderStandaloneCommentActionItems;
        $[282] = t53;
    } else t53 = $[282];
    return t53;
} : ({ pageId: pageId, pageType: pageType, commentId: commentId, permissions: permissions, isReply: isReply, parentCommentId: parentCommentId, restrictEdit: restrictEdit, restrictDelete: restrictDelete, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, isCommentActive: isCommentActive, mode: mode, onClose: onClose, overflowMenuPortal: overflowMenuPortal, supportedActions: supportedActions = [
    'edit',
    'delete',
    'resolve'
], isCommentsPanel: isCommentsPanel = false, isHovered: isHovered, annotationId: annotationId, resolveProperties: resolveProperties, reopenComment: reopenComment, replyToComment: replyToComment, isUnread: isUnread = false, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, commentDateUrl: commentDateUrl, isResolvedByAnotherUser: isResolvedByAnotherUser, commentType: commentType, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isDeletedByAnotherUser: isDeletedByAnotherUser = false, isSelected: isSelected = false, isParentCommentOpen: isParentCommentOpen, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false, isOffline: isOffline = false, numReplies: numReplies, isFabricPage: isFabricPage = true, authorName: authorName, isArchived: isArchived })=>{
    const deletePressTracing = (0, $1pSma.default)('delete-comment-action');
    const editPressTracing = (0, $1pSma.default)('start-edit-comment-action');
    const replyPressTracing = (0, $1pSma.default)('start-reply-comment-action');
    const resolvePressTracing = (0, $1pSma.default)('resolve-comment-action');
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const [showCommentActionItems, setShowCommentActionItems] = (0, $42omo.useState)(false);
    const [isEditable, setIsEditable] = (0, $42omo.useState)(false);
    const [isRemovable, setIsRemovable] = (0, $42omo.useState)(false);
    const [isResolvable, setIsResolvable] = (0, $42omo.useState)(false);
    const [canBeReopened, setCanBeReopened] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const [reactionsCount, setReactionsCount] = (0, $42omo.useState)(inheritedReactionsData?.reactionsCount || 0);
    const [reactionParticleEffectByEmoji, setReactionParticleEffectByEmoji] = (0, $42omo.useState)({});
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { updateReactionsSummary: updateReactionsSummary } = (0, $8i27m.useCommentsDataActions)();
    const readReactionsSummaryFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1b4836a71566dc4d$export$2e2bcd8739ae039)
    });
    const writeReactionsSummaryFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $725c75c783c6239a$export$2e2bcd8739ae039)
    });
    const { edition: edition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { subType: subType } = (0, $9sGCn.getCachedPageData)(contentId);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleGqlError = (error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE),
            error: error
        });
    };
    const { data: reactionsData, loading: reactionsLoading } = (0, $xQxzY.useQuery)($21f8bd546279fd06$var$CommentActionsReactionsCommentsQuery, {
        variables: {
            contentId: commentId,
            containerId: pageId
        },
        onError: handleGqlError,
        fetchPolicy: 'cache-and-network',
        // If we have the reactions from a higher component, skip the query
        skip: Boolean(inheritedReactionsData)
    });
    (0, $42omo.useEffect)(()=>{
        // If we have the reactions from a higher component, use that count
        const count = (inheritedReactionsData === undefined ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary?.reactionsCount : inheritedReactionsData?.reactionsCount) || 0;
        setReactionsCount(count);
    }, [
        reactionsData,
        inheritedReactionsData
    ]);
    (0, $42omo.useEffect)(()=>{
        const disabledByOfflineMode = isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false); // Actions are decided by the mode we're displaying
        // and the permissions available for the user
        const canEdit = Boolean(permissions?.isEditable && editComment && supportedActions.includes('edit') && !disabledByOfflineMode);
        const canDelete = Boolean(permissions?.isRemovable && deleteComment && supportedActions.includes('delete') && !disabledByOfflineMode);
        const canResolve = Boolean(permissions?.isResolvable && resolveComment && supportedActions.includes('resolve') && !disabledByOfflineMode); // if user doesn't have resolve comment permission then they shouldn't have reopen permission too
        const hasPermissionToReopen = reopenComment && supportedActions.includes('reopen') && permissions?.isResolvable;
        const canReopen = Boolean(hasPermissionToReopen && !isReply) && !disabledByOfflineMode; // handle reopening dangling comments
        if (resolveProperties?.resolved && resolveProperties?.isDangling) {
            if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) setCanBeReopened(false);
            else setCanBeReopened(canReopen);
             // handle reopening non-dangling comments
        } else setCanBeReopened(Boolean(canReopen && (resolveProperties?.resolved || isResolvedByAnotherUser) && (annotationId && (0, $g0DaR.inlineCommentExists)(annotationId) || commentType === (0, $8i27m.CommentType).GENERAL)));
        if (mode === 'view' || mode === 'edit') {
            if (!isReply) setIsResolvable(canResolve); // Parent comments are resolvable if allowed
            else setIsResolvable(false); // Replies cannot be resolved
             // Comments panel is only rendered for fabric pages not on the legacy
            if (isCommentsPanel || isFabricPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                const hasPermissions = canEdit || canDelete || canResolve;
                const shouldShowDropdownMenu = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? true : !!isHovered && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && hasPermissions; // Set the state for using the dropdown menu
                setShowCommentActionItems(shouldShowDropdownMenu);
            } else if (!isReply && (canEdit || canDelete || canResolve)) setShowCommentActionItems(true); // Parent comments or replies outside panel can show menu
             // Users can delete the replies they created
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
        } else {
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
            setIsResolvable(canResolve && !isReply);
        }
    }, [
        mode,
        permissions,
        isHovered,
        isReply,
        isCommentsPanel,
        supportedActions,
        deleteComment,
        editComment,
        resolveComment,
        reopenComment,
        resolveProperties?.isDangling,
        annotationId,
        resolveProperties?.resolved,
        isResolvedByAnotherUser,
        commentType,
        isOffline,
        isFabricPage
    ]);
    (0, $42omo.useEffect)(()=>{
        // If the user is on the comments panel and leaves this comment and the dropdown menu is open,
        // close the dropdown menu so they don't see it when they return
        if (isCommentsPanel && isDropdownOpen && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && !isHovered) setIsDropdownOpen(false);
    }, [
        isCommentsPanel,
        isDropdownOpen,
        isHovered,
        setIsDropdownOpen
    ]);
    const getInlineCommentModeConstant = ()=>{
        switch(mode){
            case 'view':
                return (0, $ad6ZE.InlineCommentMode).VIEW;
            case 'edit':
                if (isLivePage) return (0, $ad6ZE.InlineCommentMode).LIVE;
                return (0, $ad6ZE.InlineCommentMode).EDIT;
        }
    };
    const handleDelete = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
            name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                annotationId: annotationId
            }
        });
        else experienceTracker.start({
            name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                isReply: isReply
            }
        });
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                deleteCommentWithPressTracing();
            },
            isDelete: true,
            onCancel: ()=>{
                // abort delete experience if dialog is closed
                experienceTracker.abort({
                    name: commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                    reason: 'delete dialog closed'
                });
            }
        });
    };
    const deleteCommentWithPressTracing = ()=>{
        if (!!deleteComment) {
            deletePressTracing();
            deleteComment();
        }
    };
    const handleEditComment = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                type: isReply ? 'reply' : 'topLevel',
                annotationId: annotationId
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        else (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                editor: 'FABRIC',
                isSingleExperience: true,
                edition: edition,
                type: isReply ? 'reply' : 'topLevel',
                source: isFooterComment ? (0, $en1dX.AnalyticsSource).PAGE_FOOTER : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE)
        });
        editComment && editComment();
    };
    const handleEditCommentWithPressTracing = ()=>{
        editPressTracing();
        handleEditComment();
    };
    const handleReply = ()=>{
        const replyToCommentId = isFooterComment ? commentId : parentCommentId || commentId;
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                replyToCommentWithPressTracing(replyToCommentId);
            }
        });
        else replyToCommentWithPressTracing(replyToCommentId);
    };
    const replyToCommentWithPressTracing = (replyToCommentId_0)=>{
        if (!!replyToComment) {
            replyPressTracing();
            replyToComment(replyToCommentId_0);
        }
    };
    const handleCopyLink = async ()=>{
        const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
        if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(linkToComment);
        else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(linkToComment);
    };
    const handleResolveComment = ()=>{
        const doResolve = ()=>{
            if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
                id: commentId,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    mode: getInlineCommentModeConstant(),
                    framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                    annotationId: annotationId
                }
            });
            else experienceTracker.start({
                name: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE),
                id: commentId,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    annotationId: annotationId
                }
            });
            resolveCommentWithPressTracing();
        };
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                doResolve();
            }
        });
        else doResolve();
    };
    const resolveCommentWithPressTracing = ()=>{
        if (!!resolveComment) {
            resolvePressTracing();
            resolveComment();
        }
    };
    const handleReopenComment = ()=>{
        reopenComment && reopenComment();
    };
    const handleParticleEffectChange = (0, $42omo.useCallback)((emojiId, show)=>{
        setReactionParticleEffectByEmoji((prev)=>({
                ...prev,
                [emojiId]: show
            }));
    }, []);
    const renderEditAction = (isRestricted, isDropdownMenu)=>{
        if (isDropdownMenu) return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$OverflowDisabledDropdownItem, {
            testId: "disabled-edit-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "edit-comment-dropdown-action",
            "data-cy": "edit-comment-action",
            onClick: handleEditComment,
            interactionName: "start-edit-comment-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit));
        return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "edit-comment-action",
            "data-cy": "edit-comment-action",
            onClick: handleEditCommentWithPressTracing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit));
    };
    const renderDeleteAction = (isRestricted_0, isDropdownMenu_0)=>{
        if (isDropdownMenu_0) return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$OverflowDisabledDropdownItem, {
            testId: "disabled-delete-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "delete",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "delete-comment-dropdown-action",
            onClick: handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete));
        return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "delete",
            isReply: isReply
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "delete-comment-action",
            onClick: handleDelete,
            onMouseEnter: ()=>(0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                    cloudId: cloudId
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete));
    };
    const renderReopenComment = ()=>{
        return canBeReopened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, isResolvedByAnotherUser && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_11c81vhk _syazazsu"
            ])
        }, formatMessage((0, $9CnRS.i18n).resolved)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    ...iconProps,
                    spacing: "spacious",
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: formatMessage((0, $9CnRS.i18n).reopen)
                }),
            label: formatMessage((0, $9CnRS.i18n).reopen),
            isTooltipDisabled: false,
            onClick: handleReopenComment,
            appearance: "subtle",
            testId: "reopen-comment-action",
            analyticsContext: {
                attributes: {
                    name: (0, $en1dX.ActionName).REOPEN_COMMENT,
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    isDanglingComment: resolveProperties?.isDangling // all dangling comments are inline comments
                }
            }
        }));
    };
    const renderReplyAction = ()=>{
        if (!isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ReplyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "reply-comment-action",
            "data-cy": "reply-comment-action",
            onClick: handleReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).replyPlaceholder)));
    };
    const renderCopyButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "copy-link-dropdown-action",
            onClick: handleCopyLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).copyLink));
    };
    const renderResolveOption = ()=>{
        if (isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "resolve-comment-dropdown-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve));
    };
    const renderDropdownMenu = (editRestricted, deleteRestricted)=>{
        // hide the dropdown if not the comments panel and does not have permissions to edit/delete/resolve
        const hasNoCommmentPermissions = !isEditable && !isRemovable && (isReply || !isResolvable); // For old UI, use the existing logic
        const shouldHideDropdownForStandalone = !isCommentsPanel && hasNoCommmentPermissions;
        const shouldHideDropdownForCommentsPanel = isCommentsPanel && hasNoCommmentPermissions && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2');
        if (shouldHideDropdownForStandalone || shouldHideDropdownForCommentsPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        const dropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$DropdownMenuContainer, {
            "data-cy": "comment-overflow-actions-menu",
            "data-testid": "comment-overflow-actions-menu",
            isCommentActive: isCommentActive,
            mode: mode,
            showClose: Boolean(onClose),
            enableDropdownForEditMode: (0, $9wGTI.fg)('confluence-frontend-comments-panel') || mode === 'edit',
            isCommentsPanel: (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage,
            isUnread: isUnread
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            testId: "comment-overflow-menu",
            isOpen: isDropdownOpen,
            placement: "bottom-end",
            onOpenChange: ({ isOpen: isOpen, event: event })=>{
                event?.stopPropagation();
                setIsDropdownOpen(isOpen);
                if (isRemovable) (0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                    cloudId: cloudId
                });
            },
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                    ...props,
                    testId: "comment-overflow-menu-trigger",
                    ref: triggerRef,
                    label: formatMessage((0, $9CnRS.i18n).commentActionsMenuLabel),
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false,
                    isSelected: isDropdownOpen,
                    analyticsContext: {
                        attributes: {
                            name: 'moreActionsButton',
                            source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                            commentType: commentType
                        }
                    }
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, isFabricPage && (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && renderCopyButton(), (!isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') || !isFabricPage && !isFooterComment) && isResolvable && renderResolveOption(), isEditable && renderEditAction(editRestricted, showCommentActionItems), isRemovable && renderDeleteAction(deleteRestricted, showCommentActionItems))));
        return overflowMenuPortal && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, $jTxSS.createPortal)(dropdownMenu, overflowMenuPortal) : dropdownMenu;
    };
    const reactionsUpdateFn = (0, $42omo.useMemo)(()=>{
        if (reactionsCacheUpdateFn) return reactionsCacheUpdateFn;
        return inheritedReactionsData !== undefined && isCommentsPanel ? (emojiId_0, actionType, objectId, containerId, cache)=>{
            // Update particle effect state when adding/removing reactions
            setReactionParticleEffectByEmoji((prev_0)=>({
                    ...prev_0,
                    [emojiId_0]: actionType === 'add'
                }));
            if (annotationId && emojiId_0 && actionType) // Update the reaction in the content types bridge
            commentService?.onUpdateReaction(annotationId, emojiId_0, actionType);
            return updateReactionsSummary(emojiId_0, actionType, objectId, commentType, readReactionsSummaryFragment, writeReactionsSummaryFragment, containerId, annotationId, cache);
        } : undefined;
    }, [
        inheritedReactionsData,
        reactionsCacheUpdateFn,
        isCommentsPanel,
        annotationId,
        commentType,
        updateReactionsSummary,
        commentService,
        readReactionsSummaryFragment,
        writeReactionsSummaryFragment
    ]);
    const renderReplyButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "comment-reply-button",
            label: (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? formatMessage((0, $9CnRS.i18n).replyPlaceholderWithName, {
                name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            }) : formatMessage((0, $9CnRS.i18n).replyPlaceholder),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($diR4K))) : (0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))),
            onClick: handleReply,
            isTooltipDisabled: false
        });
    };
    const renderResolveActionButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "comment-resolve-action-item",
            label: (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? formatMessage((0, $9CnRS.i18n).resolveThread) : formatMessage((0, $9CnRS.i18n).resolve),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
            onClick: handleResolveComment,
            isTooltipDisabled: false,
            analyticsContext: {
                attributes: {
                    name: 'resolveActionsButton',
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    commentType: commentType
                }
            },
            className: (0, $gMc0m.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
            ])
        });
    };
    const renderReactions = ({ onlyRenderPicker: onlyRenderPicker = false, readOnly: readOnly = false } = {})=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ReactionsContainer, {
            hasReactions: reactionsCount > 0,
            isCommentsPanel: (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage,
            onClick: (e)=>// Stop the click event from propagating to the outer comments container to prevent triggering the scroll-to-comment function
                e.stopPropagation(),
            ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
                'aria-label': formatMessage((0, $9CnRS.i18n).reactionAriaLabelWithName, {
                    name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
                })
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
            readOnly: readOnly,
            contentId: commentId,
            containerId: pageId,
            containerType: pageType,
            location: mode === 'edit' ? (0, $2ttXz.ReactionLocation).EDITOR_INLINE_COMMENT : (0, $2ttXz.ReactionLocation).INLINE_COMMENT,
            hidePlaceholder: reactionsCount === 0 || inheritedReactionsData !== undefined || inheritedReactionsData !== null,
            reactionsData: inheritedReactionsData === undefined || inheritedReactionsData === null ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary : inheritedReactionsData,
            updateCache: reactionsUpdateFn,
            onlyRenderPicker: onlyRenderPicker,
            isSubtle: isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            showAddReactionText: false,
            customAnalyticsAttributes: {
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                isReply: isReply,
                mode: mode
            },
            contentSubType: subType,
            isListItem: false,
            key: `reactions-${commentId}-${onlyRenderPicker}`,
            particleEffectByEmoji: reactionParticleEffectByEmoji,
            onParticleEffectChange: handleParticleEffectChange
        }));
    };
    const renderV1ReopenComment = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            testId: "old-reopen-comment-action",
            onClick: handleReopenComment,
            padding: "space.0",
            backgroundColor: "color.background.neutral.subtle",
            xcss: $21f8bd546279fd06$var$pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).reopen)));
    }; // An abstraction made by tracing through the custom xcss returned in renderActionItemsOnHover to return the correct
    // background color. When migrating to compiled, the conditional styling needs to be simplified to reduce duplication
    const getActionItemsBackgroundColor = ()=>{
        if (isCommentsPanel) {
            if (isSelected) return "var(--ds-background-input-hovered, #F8F8F8)";
            else if (isHovered) return "var(--ds-surface-raised, #FFFFFF)";
        }
        return "var(--ds-surface, #FFFFFF)";
    };
    const renderActionItemsOnHover = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            "data-testId": "comment-action-items",
            xcss: [
                $21f8bd546279fd06$var$rightAlignedActionItemsStyle,
                $21f8bd546279fd06$var$clickableItemStyle,
                isStandaloneComment && $21f8bd546279fd06$var$hoveredBackgroundCommentSurface,
                // for standalone it will always be
                isHovered && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $21f8bd546279fd06$var$oldHoveredBackground,
                isHovered && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (isFooterComment || isStandaloneComment || !isCommentsPanel ? $21f8bd546279fd06$var$hoveredBackgroundCommentSurface : $21f8bd546279fd06$var$hoveredBackgroundInSidePanel),
                isSelected && !isStandaloneComment && $21f8bd546279fd06$var$selectedBackground,
                isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && !isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                !isCommentsPanel && !isFooterComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && isFabricPage && $21f8bd546279fd06$var$rightAlignedItemsStandaloneStyle,
                isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle,
                (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) && $21f8bd546279fd06$var$softBorderPaddingOverride
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                boxShadow: (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) ? `-10px 0 10px 0px ${getActionItemsBackgroundColor()}` : ''
            },
            "data-testId": "comment-hover-actions-container",
            className: (0, $gMc0m.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o",
                (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) && "_1reo15vq _18m915vq _2rko12b0 _kqswh2mm _c71l1kw7"
            ])
        }, !resolveProperties?.resolved && !isResolvedByAnotherUser && (!isReply || isFooterComment || isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && // Footer replies can be replied to
        !isArchived && canAddComments && renderReplyButton(), isReactionsEnabled && !reactionsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderReactions({
            onlyRenderPicker: true,
            readOnly: isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        })), !isReply && !resolveProperties?.resolved && !isResolvedByAnotherUser && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderResolveActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderDropdownMenu(restrictEdit, restrictDelete))));
    const renderStaticActionsItemsForCommentsPanel = ()=>{
        const isResolved = resolveProperties?.resolved || isResolvedByAnotherUser;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && [
                $21f8bd546279fd06$var$rightAlignedActionItemsStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && !isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle,
                isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle
            ],
            testId: "static-actions-items"
        }, (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? renderReopenComment() : renderV1ReopenComment()));
    };
    const renderCommentsPanelActionItems = ()=>{
        const shouldRenderReplyAction = !resolveProperties?.resolved && !isResolvedByAnotherUser && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2');
        const isReadOnlyForResolved = resolveProperties?.resolved || isReply && !isParentCommentOpen; // Using a function here to make sure experiment exposure is only captured when this isn't already read only by the resolved state
        const isDisabledByOfflineMode = ()=>isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false);
        const commonElements = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderReplyAction && renderReplyAction(), isReactionsEnabled && !reactionsLoading && reactionsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $21f8bd546279fd06$var$reactionBelowCommentBodyStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && $21f8bd546279fd06$var$reactionInCommentPanelStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $21f8bd546279fd06$var$reactionInCommentPanelStyleV2,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && isReply && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $21f8bd546279fd06$var$replyReactionInCommentPanelStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && !isReply && (!hideBranchingStyle && canAddComments || isReadOnlyForResolved && numReplies !== 0) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $21f8bd546279fd06$var$withLeftBorderStyle,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                !isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && isFabricPage && $21f8bd546279fd06$var$standaloneNewDesign,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                !isCommentsPanel && !isFooterComment && hideBranchingStyle && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && isFabricPage && $21f8bd546279fd06$var$customPaddingStyle
            ]
        }, renderReactions({
            readOnly: isReadOnlyForResolved || isDisabledByOfflineMode()
        }))); // no hover state for resolved comments
        const shouldRenderHoverState = ()=>{
            if (isReply && !isParentCommentOpen) return false;
            else return (isHovered || isDropdownOpen && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && !resolveProperties?.resolved && !isDeletedByAnotherUser;
        };
        const stateSpecificElements = shouldRenderHoverState() ? renderActionItemsOnHover() : renderStaticActionsItemsForCommentsPanel();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, stateSpecificElements, commonElements);
    };
    const renderStandaloneCommentActions = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ActionsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
            "aria-hidden": "true"
        }), !isReply && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "resolve-comment-action",
            "data-cy": "resolve-comment-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve))), !showCommentActionItems && isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderEditAction(restrictEdit, showCommentActionItems)), !showCommentActionItems && isRemovable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21f8bd546279fd06$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderDeleteAction(restrictDelete, showCommentActionItems)), isReactionsEnabled && !reactionsLoading && !resolveProperties?.resolved && renderReactions({
            readOnly: isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        }), !resolveProperties?.resolved || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isCommentsPanel && (0, $9wGTI.fg)('confluence-frontend-comments-panel') && renderReplyAction());
    };
    const renderStandaloneCommentActionItems = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isReply && renderDropdownMenu(restrictEdit, restrictDelete), renderStandaloneCommentActions());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage ? renderCommentsPanelActionItems() : renderStandaloneCommentActionItems());
};
function $21f8bd546279fd06$var$_temp(e) {
    return e.stopPropagation();
}

















var $bUlM5 = parcelRequire("bUlM5");









var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $gKvd9 = parcelRequire("gKvd9");


var $3gadb = parcelRequire("3gadb");







const $5d918c8bb7f43d99$var$expandedContentStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $5d918c8bb7f43d99$export$a47b1fe1225a164 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { annotatedText: annotatedText } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isDanglingContentExpanded, setIsDanglingContentExpanded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== formatMessage) {
        t1 = ()=>{
            if ((0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux")) return formatMessage((0, $9CnRS.i18n).thisContentWasDeleted);
            return formatMessage((0, $9CnRS.i18n).contentDeleted);
        };
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const getContentMessage = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = !(0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            label: "",
            color: "var(--ds-icon-subtlest, #6B6E76)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== getContentMessage) {
        t3 = getContentMessage();
        $[3] = getContentMessage;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.100",
            alignItems: "center"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            maxLines: 3,
            color: (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") ? "color.text" : "color.text.subtle",
            weight: (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") ? "bold" : "regular"
        }, t3));
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== formatMessage || $[8] !== isDanglingContentExpanded) {
        t5 = (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: isDanglingContentExpanded ? formatMessage((0, $9CnRS.i18n).collapseDeletedContent) : formatMessage((0, $9CnRS.i18n).viewDeletedContent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: isDanglingContentExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
            label: isDanglingContentExpanded ? formatMessage((0, $9CnRS.i18n).collapseDeletedContent) : formatMessage((0, $9CnRS.i18n).viewDeletedContent),
            onClick: ()=>setIsDanglingContentExpanded(!isDanglingContentExpanded),
            testId: isDanglingContentExpanded ? "dangling-content-toggle-collapse" : "dangling-content-toggle-expand",
            spacing: "compact"
        }));
        $[7] = formatMessage;
        $[8] = isDanglingContentExpanded;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.100",
            alignItems: "center",
            justifyContent: "space-between"
        }, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== annotatedText || $[14] !== isDanglingContentExpanded) {
        t7 = isDanglingContentExpanded && (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $5d918c8bb7f43d99$var$expandedContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            color: "color.text.subtlest",
            maxLines: 3
        }, annotatedText));
        $[13] = annotatedText;
        $[14] = isDanglingContentExpanded;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t6 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, t6, t7);
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
} : ({ annotatedText: annotatedText })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isDanglingContentExpanded, setIsDanglingContentExpanded] = (0, $42omo.useState)(false);
    const getContentMessage = ()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) return formatMessage((0, $9CnRS.i18n).thisContentWasDeleted);
        return formatMessage((0, $9CnRS.i18n).contentDeleted);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        gap: "space.100",
        alignItems: "center"
    }, !(0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        maxLines: 3,
        color: (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? 'color.text' : 'color.text.subtle',
        weight: (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? 'bold' : 'regular'
    }, getContentMessage())), (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isDanglingContentExpanded ? formatMessage((0, $9CnRS.i18n).collapseDeletedContent) : formatMessage((0, $9CnRS.i18n).viewDeletedContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: isDanglingContentExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
        label: isDanglingContentExpanded ? formatMessage((0, $9CnRS.i18n).collapseDeletedContent) : formatMessage((0, $9CnRS.i18n).viewDeletedContent),
        onClick: ()=>setIsDanglingContentExpanded(!isDanglingContentExpanded),
        testId: isDanglingContentExpanded ? 'dangling-content-toggle-collapse' : 'dangling-content-toggle-expand',
        spacing: "compact"
    }))), isDanglingContentExpanded && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5d918c8bb7f43d99$var$expandedContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 3
    }, annotatedText)));
};



var $daq5m = parcelRequire("daq5m");










const $2f634d0f466224e4$export$77a2990571eb5aa2 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "2",
            height: "22",
            viewBox: "0 0 2 22",
            fill: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M1 1L1 21",
            stroke: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            strokeWidth: "2",
            strokeLinecap: "round"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "2",
        height: "22",
        viewBox: "0 0 2 22",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1 1L1 21",
        stroke: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        strokeWidth: "2",
        strokeLinecap: "round"
    }));
};



var $1Sjzs = parcelRequire("1Sjzs");







/**
 * @generated SignedSource<<d1ea5ca676e19de010d5b2378f122fc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8d419c1f5019bed5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCommentActionsWriteReactionsSummaryFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "containerAri"
        },
        {
            "kind": "ScalarField",
            "name": "reactionsCount"
        },
        {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                }
            ]
        }
    ],
    "type": "ReactionsSummaryResponse"
};
$8d419c1f5019bed5$var$node.hash = "f6aafe0b5386657eb31d9d2871489adf";
var $8d419c1f5019bed5$export$2e2bcd8739ae039 = $8d419c1f5019bed5$var$node;


/**
 * @generated SignedSource<<fb7ddacc0e90fdf740e3461142f4f368>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45f1cc32cc5f3b88$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCommentActionsReadReactionsSummaryFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "containerAri"
        },
        {
            "kind": "ScalarField",
            "name": "reactionsCount"
        },
        {
            "concreteType": "ReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                }
            ]
        }
    ],
    "type": "ReactionsSummaryResponse"
};
$45f1cc32cc5f3b88$var$node.hash = "9642a68f9c63ffd5916eb7291af87c98";
var $45f1cc32cc5f3b88$export$2e2bcd8739ae039 = $45f1cc32cc5f3b88$var$node;

















































































































































const $68b72e61aafb20d2$var$useCommentActionsReactionsCommentsQuery = (0, $eSUdr.default)`query useCommentActionsReactionsCommentsQuery($contentId:ID!$containerId:ID!){comments(commentId:$contentId contentStatus:[DRAFT CURRENT]){nodes{id reactionsSummary(pageId:$containerId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
const $68b72e61aafb20d2$var$reactionBelowCommentBodyStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $68b72e61aafb20d2$var$itemStyles = null;
const $68b72e61aafb20d2$var$reactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    marginLeft: 'space.200',
    paddingLeft: 'space.300',
    paddingBottom: 'space.100'
});
const $68b72e61aafb20d2$var$reactionInCommentPanelStyleV2 = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.100'
});
const $68b72e61aafb20d2$var$replyReactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.0',
    paddingLeft: 'space.0',
    paddingTop: 'space.150',
    paddingBottom: 'space.0'
});
const $68b72e61aafb20d2$var$standaloneNewDesign = (0, $ecnYn.xcss)({
    marginLeft: 'space.0'
});
const $68b72e61aafb20d2$var$withLeftBorderStyle = (0, $ecnYn.xcss)({
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"}`
});
const $68b72e61aafb20d2$var$customPaddingStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0'
}); // As footer does not have isDangling
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68b72e61aafb20d2$var$OverflowDisabledDropdownItem = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dAYOx.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $dAYOx.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3",
            __cmplp.className
        ])
    });
});
const $68b72e61aafb20d2$var$clickableItemStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $68b72e61aafb20d2$var$ReplyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ae4v1h6o _80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ae4v1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $68b72e61aafb20d2$var$ReactionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { hasReactions: hasReactions, isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            __cmplp.hasReactions ? "_1e0c1ule" : "_1e0c116y",
            __cmplp.hasReactions ? "_i0dl1osq" : "_i0dl1wug",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_19pk1b66" : "_19pkze3t",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasReactions: hasReactions, isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.hasReactions ? "_1e0c1ule" : "_1e0c116y",
            __cmplp.hasReactions ? "_i0dl1osq" : "_i0dl1wug",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_19pk1b66" : "_19pkze3t",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ])
    });
});
const $68b72e61aafb20d2$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syazazsu _1tke1tcg _4cvr1h6o _xrwlcs5v _144bkb7n _14p1f1ug _ekv61o8v _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _5lhmtlke _1tzjf4df _8bo21mp2 _nqnuazsu _d32vazsu _nlwjglyw _49cd7g83",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syazazsu _1tke1tcg _4cvr1h6o _xrwlcs5v _144bkb7n _14p1f1ug _ekv61o8v _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _5lhmtlke _1tzjf4df _8bo21mp2 _nqnuazsu _d32vazsu _nlwjglyw _49cd7g83",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $68b72e61aafb20d2$var$ActionButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke _1as91r31 _j4qy8stv _1wwgnqa1 _y2mv7g83 _1bg4yh40",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke _1as91r31 _j4qy8stv _1wwgnqa1 _y2mv7g83 _1bg4yh40",
            __cmplp.className
        ])
    });
});
const $68b72e61aafb20d2$var$pressableStyles = (0, $ecnYn.xcss)({
    ':hover': {
        textDecoration: 'underline'
    }
});
const $68b72e61aafb20d2$var$rightAlignedActionItemsStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.0',
    display: 'flex',
    gap: 'space.075',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.150'
});
const $68b72e61aafb20d2$var$rightAlignedActionItemsCommentsPanelStyle = (0, $ecnYn.xcss)({
    top: 'space.0'
});
const $68b72e61aafb20d2$var$rightAlignedItemsStandaloneStyle = (0, $ecnYn.xcss)({
    top: 'space.150',
    right: 'space.200'
});
const $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle = (0, $ecnYn.xcss)({
    top: 'space.100'
});
const $68b72e61aafb20d2$var$hoveredBackgroundInSidePanel = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-raised, #FFFFFF)"
});
const $68b72e61aafb20d2$var$hoveredBackgroundOutOfSidePanel = (0, $ecnYn.xcss)({
    background: "var(--ds-surface, #FFFFFF)"
}); // TODO: remove oldHoveredBackground when cleaning up `confluence_frontend_content_wrapper`
const $68b72e61aafb20d2$var$oldHoveredBackground = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)"
});
const $68b72e61aafb20d2$var$selectedBackground = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $68b72e61aafb20d2$var$resolvedTextStyle = null;
const $68b72e61aafb20d2$var$softBorderBase = null;
const $68b72e61aafb20d2$var$softBorderPaddingOverride = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $68b72e61aafb20d2$export$fd00fdc8de7d175d = ({ pageId: pageId, pageType: pageType, commentId: commentId, permissions: permissions, isReply: isReply, parentCommentId: parentCommentId, restrictEdit: restrictEdit, restrictDelete: restrictDelete, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, mode: mode, overflowMenuPortal: overflowMenuPortal, supportedActions: supportedActions, isCommentsPanel: isCommentsPanel = false, isHovered: isHovered, annotationId: annotationId, resolveProperties: resolveProperties, reopenComment: reopenComment, replyToComment: replyToComment, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, commentDateUrl: commentDateUrl, isResolvedByAnotherUser: isResolvedByAnotherUser, commentType: commentType, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isDeletedByAnotherUser: isDeletedByAnotherUser = false, isSelected: isSelected = false, isParentCommentOpen: isParentCommentOpen, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false, isOffline: isOffline = false, numReplies: numReplies, isFabricPage: isFabricPage = true, authorName: authorName, isArchived: isArchived })=>{
    const deletePressTracing = (0, $1pSma.default)('delete-comment-action');
    const editPressTracing = (0, $1pSma.default)('start-edit-comment-action');
    const replyPressTracing = (0, $1pSma.default)('start-reply-comment-action');
    const resolvePressTracing = (0, $1pSma.default)('resolve-comment-action');
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const [showCommentActionItems, setShowCommentActionItems] = (0, $42omo.useState)(false);
    const [isEditable, setIsEditable] = (0, $42omo.useState)(false);
    const [isRemovable, setIsRemovable] = (0, $42omo.useState)(false);
    const [isResolvable, setIsResolvable] = (0, $42omo.useState)(false);
    const [canBeReopened, setCanBeReopened] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const [reactionsCount, setReactionsCount] = (0, $42omo.useState)(inheritedReactionsData?.reactionsCount || 0);
    const [reactionParticleEffectByEmoji, setReactionParticleEffectByEmoji] = (0, $42omo.useState)({});
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { updateReactionsSummary: updateReactionsSummary } = (0, $8i27m.useCommentsDataActions)();
    const readReactionsSummaryFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $45f1cc32cc5f3b88$export$2e2bcd8739ae039)
    });
    const writeReactionsSummaryFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $8d419c1f5019bed5$export$2e2bcd8739ae039)
    });
    const { edition: edition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { subType: subType } = (0, $9sGCn.getCachedPageData)(contentId);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleGqlError = (error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE),
            error: error
        });
    };
    const { data: reactionsData, loading: reactionsLoading } = (0, $xQxzY.useQuery)($68b72e61aafb20d2$var$useCommentActionsReactionsCommentsQuery, {
        variables: {
            contentId: commentId,
            containerId: pageId
        },
        onError: handleGqlError,
        fetchPolicy: 'cache-and-network',
        // If we have the reactions from a higher component, skip the query
        skip: Boolean(inheritedReactionsData)
    });
    (0, $42omo.useEffect)(()=>{
        // If we have the reactions from a higher component, use that count
        const count = (inheritedReactionsData === undefined || inheritedReactionsData === null ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary?.reactionsCount : inheritedReactionsData?.reactionsCount) || 0;
        setReactionsCount(count);
    }, [
        reactionsData,
        inheritedReactionsData
    ]);
    (0, $42omo.useEffect)(()=>{
        const disabledByOfflineMode = isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false); // Actions are decided by the mode we're displaying
        // and the permissions available for the user
        const canEdit = Boolean(permissions?.isEditable && editComment && supportedActions.includes('edit') && !disabledByOfflineMode);
        const canDelete = Boolean(permissions?.isRemovable && deleteComment && supportedActions.includes('delete') && !disabledByOfflineMode);
        const canResolve = Boolean(permissions?.isResolvable && resolveComment && supportedActions.includes('resolve') && !disabledByOfflineMode); // if user doesn't have resolve comment permission then they shouldn't have reopen permission too
        const hasPermissionToReopen = reopenComment && supportedActions.includes('reopen') && permissions?.isResolvable;
        const canReopen = Boolean(hasPermissionToReopen && !isReply) && !disabledByOfflineMode; // handle reopening dangling comments
        if (resolveProperties?.resolved && resolveProperties?.isDangling) {
            if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) setCanBeReopened(false);
            else setCanBeReopened(canReopen);
             // handle reopening non-dangling comments
        } else setCanBeReopened(Boolean(canReopen && (resolveProperties?.resolved || isResolvedByAnotherUser) && (annotationId && (0, $g0DaR.inlineCommentExists)(annotationId) || commentType === (0, $8i27m.CommentType).GENERAL)));
        if (mode === 'view' || mode === 'edit') {
            if (!isReply) setIsResolvable(canResolve); // Parent comments are resolvable if allowed
            else setIsResolvable(false); // Replies cannot be resolved
             // Comments panel is only rendered for fabric pages not on the legacy
            if (isCommentsPanel || isFabricPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                const hasPermissions = canEdit || canDelete || canResolve;
                const shouldShowDropdownMenu = !!isHovered && hasPermissions; // Set the state for using the dropdown menu
                setShowCommentActionItems(shouldShowDropdownMenu);
            } else if (!isReply && (canEdit || canDelete || canResolve)) setShowCommentActionItems(true); // Parent comments or replies outside panel can show menu
             // Users can delete the replies they created
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
        } else {
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
            setIsResolvable(canResolve && !isReply);
        }
    }, [
        mode,
        permissions,
        isHovered,
        isReply,
        isCommentsPanel,
        supportedActions,
        deleteComment,
        editComment,
        resolveComment,
        reopenComment,
        resolveProperties?.isDangling,
        annotationId,
        resolveProperties?.resolved,
        isResolvedByAnotherUser,
        commentType,
        isOffline,
        isFabricPage
    ]);
    (0, $42omo.useEffect)(()=>{
        // If the user leaves this comment and the dropdown menu is open, close the dropdown menu so
        // they don't see it when they return
        if (isDropdownOpen && !isHovered) setIsDropdownOpen(false);
    }, [
        isCommentsPanel,
        isDropdownOpen,
        isHovered,
        setIsDropdownOpen
    ]);
    const getInlineCommentModeConstant = ()=>{
        switch(mode){
            case 'view':
                return (0, $ad6ZE.InlineCommentMode).VIEW;
            case 'edit':
                if (isLivePage) return (0, $ad6ZE.InlineCommentMode).LIVE;
                return (0, $ad6ZE.InlineCommentMode).EDIT;
        }
    };
    const handleDelete = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
            name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                annotationId: annotationId
            }
        });
        else experienceTracker.start({
            name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                isReply: isReply
            }
        });
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                deleteCommentWithPressTracing();
            },
            isDelete: true,
            onCancel: ()=>{
                // abort delete experience if dialog is closed
                experienceTracker.abort({
                    name: commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                    reason: 'delete dialog closed'
                });
            }
        });
    };
    const deleteCommentWithPressTracing = ()=>{
        if (!!deleteComment) {
            deletePressTracing();
            deleteComment();
        }
    };
    const handleEditComment = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                type: isReply ? 'reply' : 'topLevel',
                annotationId: annotationId
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        else (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                editor: 'FABRIC',
                isSingleExperience: true,
                edition: edition,
                type: isReply ? 'reply' : 'topLevel',
                source: isFooterComment ? (0, $en1dX.AnalyticsSource).PAGE_FOOTER : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE)
        });
        editComment && editComment();
    };
    const handleEditCommentWithPressTracing = ()=>{
        editPressTracing();
        handleEditComment();
    };
    const handleReply = ()=>{
        const replyToCommentId = isFooterComment ? commentId : parentCommentId || commentId;
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                replyToCommentWithPressTracing(replyToCommentId);
            }
        });
        else replyToCommentWithPressTracing(replyToCommentId);
    };
    const replyToCommentWithPressTracing = (replyToCommentId_0)=>{
        if (!!replyToComment) {
            replyPressTracing();
            replyToComment(replyToCommentId_0);
        }
    };
    const handleCopyLink = async ()=>{
        const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
        if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(linkToComment);
        else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(linkToComment);
    };
    const handleResolveComment = ()=>{
        const doResolve = ()=>{
            if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
                id: commentId,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    mode: getInlineCommentModeConstant(),
                    framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                    annotationId: annotationId
                }
            });
            else experienceTracker.start({
                name: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE),
                id: commentId,
                attributes: {
                    ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                    annotationId: annotationId
                }
            });
            resolveCommentWithPressTracing();
        };
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                doResolve();
            }
        });
        else doResolve();
    };
    const resolveCommentWithPressTracing = ()=>{
        if (!!resolveComment) {
            resolvePressTracing();
            resolveComment();
        }
    };
    const handleReopenComment = ()=>{
        reopenComment && reopenComment();
    };
    const handleParticleEffectChange = (0, $42omo.useCallback)((emojiId, show)=>{
        setReactionParticleEffectByEmoji((prev)=>({
                ...prev,
                [emojiId]: show
            }));
    }, []);
    const renderEditAction = (isRestricted, isDropdownMenu)=>{
        if (isDropdownMenu) return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$OverflowDisabledDropdownItem, {
            testId: "disabled-edit-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "edit-comment-dropdown-action",
            "data-cy": "edit-comment-action",
            onClick: handleEditComment,
            interactionName: "start-edit-comment-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit));
        return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "edit-comment-action",
            "data-cy": "edit-comment-action",
            onClick: handleEditCommentWithPressTracing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit));
    };
    const renderDeleteAction = (isRestricted_0, isDropdownMenu_0)=>{
        if (isDropdownMenu_0) return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$OverflowDisabledDropdownItem, {
            testId: "disabled-delete-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "delete",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "delete-comment-dropdown-action",
            onClick: handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete));
        return isRestricted_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46066c9f9a854335$export$fa26121f031ea499), {
            action: "delete",
            isReply: isReply
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "delete-comment-action",
            onClick: handleDelete,
            onMouseEnter: ()=>(0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                    cloudId: cloudId
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete));
    };
    const renderReopenComment = ()=>{
        return canBeReopened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, isResolvedByAnotherUser && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_11c81vhk _syazazsu"
            ])
        }, formatMessage((0, $9CnRS.i18n).resolved)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    ...iconProps,
                    spacing: "spacious",
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: formatMessage((0, $9CnRS.i18n).reopen)
                }),
            label: formatMessage((0, $9CnRS.i18n).reopen),
            isTooltipDisabled: false,
            onClick: handleReopenComment,
            appearance: "subtle",
            testId: "reopen-comment-action",
            analyticsContext: {
                attributes: {
                    name: (0, $en1dX.ActionName).REOPEN_COMMENT,
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    isDanglingComment: resolveProperties?.isDangling // all dangling comments are inline comments
                }
            }
        }));
    };
    const renderReplyAction = ()=>{
        if (!isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ReplyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "reply-comment-action",
            "data-cy": "reply-comment-action",
            onClick: handleReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).replyPlaceholder)));
    };
    const renderCopyButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "copy-link-dropdown-action",
            onClick: handleCopyLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).copyLink));
    };
    const renderResolveOption = ()=>{
        if (isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            testId: "resolve-comment-dropdown-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve));
    };
    const renderDropdownMenu = (editRestricted, deleteRestricted)=>{
        // hide the dropdown if not the comments panel and does not have permissions to edit/delete/resolve
        const hasNoCommmentPermissions = !isEditable && !isRemovable && (isReply || !isResolvable); // For old UI, use the existing logic
        const shouldHideDropdownForStandalone = !isCommentsPanel && hasNoCommmentPermissions;
        const shouldHideDropdownForCommentsPanel = isCommentsPanel && hasNoCommmentPermissions && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2');
        if (shouldHideDropdownForStandalone || shouldHideDropdownForCommentsPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        const dropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-cy": "comment-overflow-actions-menu",
            "data-testid": "comment-overflow-actions-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            strategy: "absolute",
            shouldRenderToParent: true,
            testId: "comment-overflow-menu",
            isOpen: isDropdownOpen,
            zIndex: 501,
            onOpenChange: ({ isOpen: isOpen, event: event })=>{
                event?.stopPropagation();
                setIsDropdownOpen(isOpen);
                if (isRemovable) (0, $38c035d26bf2ba1b$export$d9882c6824bd8ea0)({
                    cloudId: cloudId
                });
            },
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                    ...props,
                    ref: triggerRef,
                    testId: "comment-overflow-menu-trigger",
                    label: formatMessage((0, $9CnRS.i18n).commentActionsMenuLabel),
                    appearance: "subtle",
                    spacing: "compact",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false,
                    isSelected: isDropdownOpen,
                    analyticsContext: {
                        attributes: {
                            name: 'moreActionsButton',
                            source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                            commentType: commentType
                        }
                    }
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, isFabricPage && (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && renderCopyButton(), (!isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') || !isFabricPage && !isFooterComment) && isResolvable && renderResolveOption(), isEditable && renderEditAction(editRestricted, showCommentActionItems), isRemovable && renderDeleteAction(deleteRestricted, showCommentActionItems))));
        return overflowMenuPortal && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, $jTxSS.createPortal)(dropdownMenu, overflowMenuPortal) : dropdownMenu;
    };
    const reactionsUpdateFn = (0, $42omo.useMemo)(()=>{
        if (reactionsCacheUpdateFn) return reactionsCacheUpdateFn;
        return inheritedReactionsData !== undefined && isCommentsPanel ? (emojiId_0, actionType, objectId, containerId, cache)=>{
            // Update particle effect state when adding/removing reactions
            setReactionParticleEffectByEmoji((prev_0)=>({
                    ...prev_0,
                    [emojiId_0]: actionType === 'add'
                }));
            if (annotationId && emojiId_0 && actionType) // Update the reaction in the content types bridge
            commentService?.onUpdateReaction(annotationId, emojiId_0, actionType);
            return updateReactionsSummary(emojiId_0, actionType, objectId, commentType, readReactionsSummaryFragment, writeReactionsSummaryFragment, containerId, annotationId, cache);
        } : undefined;
    }, [
        inheritedReactionsData,
        reactionsCacheUpdateFn,
        isCommentsPanel,
        annotationId,
        commentType,
        updateReactionsSummary,
        commentService,
        readReactionsSummaryFragment,
        writeReactionsSummaryFragment
    ]);
    const renderReplyButton = ()=>{
        const labelText = formatMessage((0, $9CnRS.i18n).replyPlaceholderWithName, {
            name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "comment-reply-button-container" // TODO - COMMENTS-4934: clean up 'confluence_frontend_comments_a11y_kb_exp' FG
            ,
            ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
                'aria-label': labelText
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "comment-reply-button",
            label: (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? formatMessage((0, $9CnRS.i18n).replyPlaceholderWithName, {
                name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            }) : formatMessage((0, $9CnRS.i18n).replyPlaceholder),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($diR4K))) : (0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))),
            onClick: handleReply,
            isTooltipDisabled: false
        }));
    };
    const renderResolveActionButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "comment-resolve-action-item",
            label: (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? formatMessage((0, $9CnRS.i18n).resolveThread) : formatMessage((0, $9CnRS.i18n).resolve),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
            onClick: handleResolveComment,
            isTooltipDisabled: false,
            analyticsContext: {
                attributes: {
                    name: 'resolveActionsButton',
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    commentType: commentType
                }
            },
            className: (0, $gMc0m.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
            ])
        });
    };
    const renderReactions = ({ onlyRenderPicker: onlyRenderPicker = false, readOnly: readOnly = false } = {})=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ReactionsContainer, {
            hasReactions: reactionsCount > 0,
            isCommentsPanel: (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage,
            onClick: (e)=>// Stop the click event from propagating to the outer comments container to prevent triggering the scroll-to-comment function
                e.stopPropagation(),
            ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
                'aria-label': formatMessage((0, $9CnRS.i18n).reactionAriaLabelWithName, {
                    name: authorName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
                })
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
            readOnly: readOnly,
            contentId: commentId,
            containerId: pageId,
            containerType: pageType,
            location: mode === 'edit' ? (0, $2ttXz.ReactionLocation).EDITOR_INLINE_COMMENT : (0, $2ttXz.ReactionLocation).INLINE_COMMENT,
            hidePlaceholder: reactionsCount === 0 || inheritedReactionsData !== undefined,
            reactionsData: inheritedReactionsData === undefined || inheritedReactionsData === null ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary : inheritedReactionsData,
            updateCache: reactionsUpdateFn,
            onlyRenderPicker: onlyRenderPicker,
            isSubtle: isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            showAddReactionText: false,
            customAnalyticsAttributes: {
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                isReply: isReply,
                mode: mode
            },
            contentSubType: subType,
            isListItem: false,
            key: `reactions-${commentId}-${onlyRenderPicker}`,
            particleEffectByEmoji: reactionParticleEffectByEmoji,
            onParticleEffectChange: handleParticleEffectChange
        }));
    };
    const renderV1ReopenComment = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            testId: "old-reopen-comment-action",
            onClick: handleReopenComment,
            padding: "space.0",
            backgroundColor: "color.background.neutral.subtle",
            xcss: $68b72e61aafb20d2$var$pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).reopen)));
    }; // An abstraction made by tracing through the custom xcss returned in renderActionItemsOnHover to return the correct
    // background color. When migrating to compiled, the conditional styling needs to be simplified to reduce duplication
    const getActionItemsBackgroundColor = ()=>{
        if (isCommentsPanel) {
            if (isSelected) return "var(--ds-background-input-hovered, #F8F8F8)";
            else if (isHovered) return "var(--ds-surface-raised, #FFFFFF)";
        }
        return "var(--ds-surface, #FFFFFF)";
    };
    const renderActionItemsOnHover = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            "data-testId": "comment-action-items",
            xcss: [
                $68b72e61aafb20d2$var$rightAlignedActionItemsStyle,
                $68b72e61aafb20d2$var$clickableItemStyle,
                isHovered && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $68b72e61aafb20d2$var$oldHoveredBackground,
                isHovered && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (isFooterComment || isStandaloneComment || !isCommentsPanel ? $68b72e61aafb20d2$var$hoveredBackgroundOutOfSidePanel : $68b72e61aafb20d2$var$hoveredBackgroundInSidePanel),
                isSelected && isCommentsPanel && $68b72e61aafb20d2$var$selectedBackground,
                isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && !isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsCommentsPanelStyle,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                !isCommentsPanel && !isFooterComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && isFabricPage && $68b72e61aafb20d2$var$rightAlignedItemsStandaloneStyle,
                isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle,
                (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) && $68b72e61aafb20d2$var$softBorderPaddingOverride
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                boxShadow: (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) ? `-10px 0 10px 0px ${getActionItemsBackgroundColor()}` : ''
            },
            "data-testId": "comment-hover-actions-container",
            className: (0, $gMc0m.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o",
                (0, $6mKj3.expValEquals)('confluence_cohiti_comment_hover_actions', 'isEnabled', true) && "_2rko12b0 _kqswh2mm _c71l1kw7"
            ])
        }, !resolveProperties?.resolved && !isResolvedByAnotherUser && (!isReply || isFooterComment || isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && // Footer replies can be replied to
        !isArchived && canAddComments && renderReplyButton(), isReactionsEnabled && !reactionsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderReactions({
            onlyRenderPicker: true,
            readOnly: isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        })), !isReply && !resolveProperties?.resolved && !isResolvedByAnotherUser && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderResolveActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, renderDropdownMenu(restrictEdit, restrictDelete))));
    const renderStaticActionsItemsForCommentsPanel = ()=>{
        const isResolved = resolveProperties?.resolved || isResolvedByAnotherUser;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && [
                $68b72e61aafb20d2$var$rightAlignedActionItemsStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && !isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsCommentsPanelStyle,
                isFooterComment && $68b72e61aafb20d2$var$rightAlignedActionItemsFooterCommentStyle
            ],
            testId: "static-actions-items"
        }, (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? renderReopenComment() : renderV1ReopenComment()));
    };
    const getCommentsPanelActionItems = ()=>{
        const shouldRenderReplyAction = !resolveProperties?.resolved && !isResolvedByAnotherUser && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2');
        const isReadOnlyForResolved = resolveProperties?.resolved || isReply && !isParentCommentOpen; // Using a function here to make sure experiment exposure is only captured when this isn't already read only by the resolved state
        const isDisabledByOfflineMode = ()=>isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false);
        const commonElements = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderReplyAction && renderReplyAction(), isReactionsEnabled && !reactionsLoading && reactionsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $68b72e61aafb20d2$var$reactionBelowCommentBodyStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && $68b72e61aafb20d2$var$reactionInCommentPanelStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $68b72e61aafb20d2$var$reactionInCommentPanelStyleV2,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && isReply && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $68b72e61aafb20d2$var$replyReactionInCommentPanelStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage && !isReply && (!hideBranchingStyle && canAddComments || isReadOnlyForResolved && numReplies !== 0) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $68b72e61aafb20d2$var$withLeftBorderStyle,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                !isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && isFabricPage && $68b72e61aafb20d2$var$standaloneNewDesign,
                // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                !isCommentsPanel && !isFooterComment && hideBranchingStyle && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && isFabricPage && $68b72e61aafb20d2$var$customPaddingStyle
            ]
        }, renderReactions({
            readOnly: isReadOnlyForResolved || isDisabledByOfflineMode()
        }))); // no hover state for resolved comments
        const shouldRenderHoverState = ()=>{
            if (isReply && !isParentCommentOpen) return false;
            else return isHovered && !resolveProperties?.resolved && !isDeletedByAnotherUser;
        };
        const stateSpecificElements = shouldRenderHoverState() ? renderActionItemsOnHover() : renderStaticActionsItemsForCommentsPanel();
        return {
            mainCommentActions: commonElements,
            hoveredActionItems: stateSpecificElements
        };
    };
    const renderStandaloneCommentActions = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ActionsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            "aria-hidden": "true"
        }), !isReply && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionButton, {
            "data-testid": "resolve-comment-action",
            "data-cy": "resolve-comment-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve))), !showCommentActionItems && isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderEditAction(restrictEdit, showCommentActionItems)), !showCommentActionItems && isRemovable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($68b72e61aafb20d2$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderDeleteAction(restrictDelete, showCommentActionItems)), isReactionsEnabled && !reactionsLoading && !resolveProperties?.resolved && renderReactions({
            readOnly: isOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
        }), !resolveProperties?.resolved || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isCommentsPanel && (0, $9wGTI.fg)('confluence-frontend-comments-panel') && renderReplyAction());
    };
    const renderStandaloneCommentActionItems = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isReply && renderDropdownMenu(restrictEdit, restrictDelete), renderStandaloneCommentActions());
    };
    return (isCommentsPanel || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && isFabricPage ? getCommentsPanelActionItems() : {
        mainCommentActions: renderStandaloneCommentActionItems(),
        hoveredActionItems: null
    };
};











const $ce87683ee211df83$export$683480f191c0e3ea = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const observeTarget = ref.current;
            const resizeObserver = new ResizeObserver((entries)=>{
                entries.forEach((entry)=>{
                    setHeight(entry.contentRect.height);
                });
            });
            if (observeTarget) {
                resizeObserver.observe(observeTarget);
                return ()=>{
                    resizeObserver.unobserve(observeTarget);
                };
            }
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useLayoutEffect)(t0, t1);
    let t2;
    if ($[2] !== height) {
        t2 = [
            ref,
            height
        ];
        $[2] = height;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const [height, setHeight] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        const observeTarget = ref.current;
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                setHeight(entry.contentRect.height);
            });
        });
        if (observeTarget) {
            resizeObserver.observe(observeTarget);
            return ()=>{
                resizeObserver.unobserve(observeTarget);
            };
        }
    }, []);
    return [
        ref,
        height
    ];
};


'use no memo';
const $c5a7cd205687b023$var$fadeOut = null;
const $c5a7cd205687b023$var$unreadIconStyle = null;
const $c5a7cd205687b023$var$unreadStyleInCommentsPanel = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5a7cd205687b023$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, isRemoving: isRemoving, isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6drwq1": (0, $7sObp.default)((()=>{
                return __cmplp.mode === 'view-all' ? "var(--ds-space-400, 32px)" : __cmplp.isCommentsPanel === true ? 'inherit' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                __cmplp.isFabricPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-200, 16px)"}` : `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4431d _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _5sag1bs3 _1o51q7pw _tip812c5 _1pglp3kn _1ragidpf _ha8h1rpy",
            Boolean(__cmplp.isRemoving) ? "_80om13gf" : "_80om1kw7",
            Boolean(__cmplp.isFocused && !__cmplp.isCommentsPanel) && "_11q715s3",
            Boolean(__cmplp.isRemoving) && "",
            Boolean(__cmplp.isRemoving) && "_y44vy8h8",
            __cmplp.className
        ])
    });
});
const $c5a7cd205687b023$var$withLeftBorderStyle = null;
const $c5a7cd205687b023$var$commentBodyStyles = null;
const $c5a7cd205687b023$var$commentReplyStyles = null;
const $c5a7cd205687b023$var$commentBodyReplyStyles = null;
const $c5a7cd205687b023$var$commentBodyNestedReplyStyle = null;
const $c5a7cd205687b023$var$warningMessageStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    fontStyle: 'italic',
    padding: 'space.150'
});
const $c5a7cd205687b023$var$xcssTranslucentStyle = (0, $ecnYn.xcss)({
    opacity: '50%'
});
const $c5a7cd205687b023$var$cssTranslucentStyle = null;
const $c5a7cd205687b023$var$annotatedTextBodyStyle = (0, $ecnYn.xcss)({
    borderWidth: '1.5px',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    padding: 'space.200',
    width: '100%',
    backgroundColor: 'elevation.surface',
    marginBottom: 'space.150'
});
const $c5a7cd205687b023$var$danglingAnnotatedTextBodyStyle = (0, $ecnYn.xcss)({
    borderWidth: '1.5px',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    width: '100%',
    backgroundColor: 'elevation.surface',
    marginBottom: 'space.150'
});
const $c5a7cd205687b023$var$annotatedTextBodyHoverStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $c5a7cd205687b023$var$annotatedTextBodyWithPressedStyle = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-pressed, #DDDEE1)"
}); // This snippet is being used in RepliesOpener.tsx
const $c5a7cd205687b023$var$dotStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-100, 8px)",
    width: "var(--ds-space-100, 8px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'radius.full',
    margin: 'space.050'
});
const $c5a7cd205687b023$var$dotBaseStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-100, 8px)",
    width: "var(--ds-space-100, 8px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'radius.full',
    margin: 'space.050',
    transition: 'opacity 300ms ease-in-out'
});
const $c5a7cd205687b023$var$dotVisibleStyles = (0, $ecnYn.xcss)({
    opacity: 1
});
const $c5a7cd205687b023$var$dotHiddenStyles = (0, $ecnYn.xcss)({
    opacity: 0
});
const $c5a7cd205687b023$var$replyBranchStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5a7cd205687b023$var$RelativeContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _4t3it94y _19pk1n1a",
            __cmplp.className
        ])
    });
});
const $c5a7cd205687b023$var$highlightSvgBoxStyles = (0, $ecnYn.xcss)({
    height: '22px',
    width: '2px'
});
const $c5a7cd205687b023$var$footerCommentAuthorStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $c5a7cd205687b023$var$parseContent = (0, $2XqLN.default)((content, experienceTracker)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch (error) {
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error,
            attributes: {
                stopPoint: 'inline-comments-common/CommentBody'
            }
        });
        return null;
    }
});
const $c5a7cd205687b023$var$STABLE_SUPPORTED_ACTIONS_DEFAULT = [
    'edit',
    'delete',
    'resolve'
];
const $c5a7cd205687b023$export$286a50103f692ed6 = ({ pageId: pageId, pageType: pageType, avatarUrl: avatarUrl, commentId: commentId, content: content, date: date, createdAt: createdAt, createdAtNonLocalized: createdAtNonLocalized, versionByDisplayName: versionByDisplayName, versionDate: versionDate, displayName: displayName, permissions: permissions, dateUrl: dateUrl, userId: userId, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, isReply: isReply, isEdited: isEdited, parentCommentId: parentCommentId, isFocused: isFocused, shouldScrollIntoView: shouldScrollIntoView, isRemoving: isRemoving, numReplies: numReplies, isFabricPage: isFabricPage, isCommentActive: isCommentActive, isCurrentUserAnonymous: isCurrentUserAnonymous, mode: mode, onRendered: onRendered, onClose: onClose, shouldAutofocus: shouldAutofocus, onAutoFocused: onAutoFocused, permissionType: permissionType, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, onComplete: onComplete, supportedActions: supportedActions = $c5a7cd205687b023$var$STABLE_SUPPORTED_ACTIONS_DEFAULT, isUnread: isUnread = false, unreadCommentRef: unreadCommentRef, isCommentsPanel: isCommentsPanel = false, isHovered: isHovered, isResolvedByAnotherUser: isResolvedByAnotherUser = false, resolveProperties: resolveProperties, annotationId: annotationId, annotatedText: annotatedText, reopenComment: reopenComment, replyToComment: replyToComment, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, isDeletedByAnotherUser: isDeletedByAnotherUser, currentlySelectedThreadKey: currentlySelectedThreadKey, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, isAnnotatedTextPressed: isAnnotatedTextPressed, setAnnotatedTextPressed: setAnnotatedTextPressed, commentType: commentType = (0, $8i27m.CommentType).INLINE, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, isStandalonehovered: isStandalonehovered, isFooterComment: isFooterComment = false, adjustForFooterNestedReplies: adjustForFooterNestedReplies = false, isStandaloneComment: isStandaloneComment = false, isOffline: isOffline = false, showRepliesWithCurvedBorders: showRepliesWithCurvedBorders, replyHasNestedObjects: replyHasNestedObjects = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [showingCopyLinkButton, setShowingCopyLink] = (0, $42omo.useState)(false);
    const [hasFallbackContent, setHasFallbackContent] = (0, $42omo.useState)(false);
    const [overflowPortal, setOverflowPortal] = (0, $42omo.useState)(undefined);
    const [isAnnotatedTextHovered, setIsAnnotatedTextHovered] = (0, $42omo.useState)(false);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE ? (0, $gfqXk.getEditorAnnotationEventEmitter)() : (0, $gczDe.getRendererAnnotationEventEmitter)();
    const isSelected = currentlySelectedThreadKey === annotationId && !isStandalonehovered;
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [containerRef, replyBranchHeight] = (0, $ce87683ee211df83$export$683480f191c0e3ea)(); // Track the currently observed element for cleanup
    const [observedElement, setObservedElement] = (0, $42omo.useState)(null);
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)(); // Create a ref callback to set the ref and observe when the DOM element is available
    const handleUnreadCommentRef = (0, $42omo.useCallback)((node)=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
         // isUnread comes from unreadCommentIDSet and doesn't contain dangling and resolved, we're only using that for the unread indicators
        // for observing unread comments, we'll rely on the viewedComments set as the source of truth
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        const viewedComments = viewedCommentsResult.success && viewedCommentsResult.data ? viewedCommentsResult.data : new Set();
        const commentForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
            commentId: commentId,
            userId: userId,
            createdAt: createdAt,
            commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
            resolveProperties: {
                resolved: false
            } // overriding resolveProperties since we still want to observe resolved comments for unread
        });
        const isValidUnread = (0, $e4kZB.isValidUnreadComment)({
            comment: commentForValidation,
            currentUserId: currentUserId || '',
            viewedComments: viewedComments
        });
        const shouldObserve = node && isValidUnread;
        if (shouldObserve) {
            const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
            observer.observeComment(node);
            setObservedElement(node);
        } else // If we shouldn't observe this node, clear the observed element
        setObservedElement(null);
    }, [
        commentId,
        userId,
        createdAt,
        commentType,
        getViewedCommentsCacheOnly,
        currentUserId
    ]);
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const isArchived = pageInfo?.status === 'archived';
    const { mainCommentActions: mainCommentActions, hoveredActionItems: hoveredActionItems } = (0, $68b72e61aafb20d2$export$fd00fdc8de7d175d)({
        pageId: pageId,
        pageType: pageType,
        commentId: commentId,
        permissions: permissions,
        isReply: isReply,
        parentCommentId: parentCommentId,
        deleteComment: deleteComment,
        editComment: editComment,
        resolveComment: resolveComment,
        restrictEdit: hasFallbackContent,
        restrictDelete: Boolean(numReplies),
        numReplies: numReplies,
        mode: mode,
        commentDateUrl: dateUrl,
        overflowMenuPortal: overflowPortal,
        supportedActions: supportedActions,
        isCommentsPanel: isCommentsPanel,
        isHovered: isHovered,
        annotationId: annotationId,
        resolveProperties: resolveProperties,
        reopenComment: reopenComment,
        replyToComment: replyToComment,
        inheritedReactionsData: inheritedReactionsData,
        reactionsCacheUpdateFn: reactionsCacheUpdateFn,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        commentType: commentType,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        isSelected: isSelected,
        isParentCommentOpen: isParentCommentOpen,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment,
        isOffline: isOffline,
        isFabricPage: isFabricPage,
        isArchived: isArchived,
        authorName: displayName
    });
    (0, $42omo.useEffect)(()=>{
        /* We only need to scroll for focused replies as parent comments will have scrolled when selected */ if (shouldScrollIntoView && isFocused && containerRef && containerRef.current && !(0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $aHcFH.scrollCommentIntoView)({
            commentElement: containerRef.current,
            isFabricPage: isFabricPage
        });
    }, [
        containerRef,
        isFocused,
        shouldScrollIntoView,
        isFabricPage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldAutofocus) {
            containerRef.current && containerRef.current.focus({
                preventScroll: (0, $9wGTI.fg)('confluence_comment_prevent_focus_autoscroll')
            });
            onAutoFocused && onAutoFocused();
        }
    }, [
        containerRef,
        shouldAutofocus,
        onAutoFocused
    ]); // clean up the observer when the component unmounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (observedElement && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                const observer_0 = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
                observer_0.unobserveComment(observedElement);
            }
        };
    }, [
        observedElement
    ]);
    const adf = $c5a7cd205687b023$var$parseContent(content, experienceTracker);
    const onCommentContentFallback = (0, $42omo.useCallback)(()=>setHasFallbackContent(true), []);
    const handleRef = (portalDiv)=>{
        /* do a check to prevent from re-running setPopupPortal multiple times*/ if (!overflowPortal && portalDiv) setOverflowPortal(portalDiv);
    };
    const handleMouseEventOnWrapper = (eventType)=>()=>{
            setShowingCopyLink(eventType === 'enter');
        };
    const commentRemovedByAnotherUser = isDeletedByAnotherUser || isResolvedByAnotherUser;
    const shouldShowOverflowMenu = supportedActions.length > 0;
    const showDefaultReplyStyle = showRepliesWithCurvedBorders ?? (isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2'));
    const getHighlightBackgroundColor = ()=>{
        if (isAnnotatedTextPressed) return "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)";
        if (isSelected) return "var(--ds-background-accent-yellow-subtle, #EED12B)";
        if (isAnnotatedTextHovered || isThreadHovered && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)";
        return 'inherit';
    }; // Duplicate method, we already have the same in commentThreadHelper
    // this will be removed later
    const handleMouseUp = ()=>{
        if (annotationId && setCurrentlySelectedThreadKey) {
            if (!(0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                setCurrentlySelectedThreadKey(annotationId);
                const commentElement = document.getElementById(annotationId);
                if (commentElement && isParentCommentOpen) {
                    if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) {
                        (0, $i49vP.scrollToElementInEditor)({
                            targetElement: commentElement,
                            viewingRoomOffset: -300
                        });
                        (0, $i49vP.checkElementExpandInEditor)(commentElement);
                        eventEmitter.emit('setselectedannotation', annotationId);
                    } else {
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                            annotationId: annotationId
                        });
                        (0, $aHcFH.scrollCommentIntoView)({
                            commentElement: commentElement,
                            isFabricPage: true,
                            useInstantScroll: false,
                            isAbove: false,
                            commentThreadAnnotationId: annotationId,
                            isCommentsPanel: isCommentsPanel
                        });
                    }
                }
            }
            setAnnotatedTextPressed && setAnnotatedTextPressed(false);
        }
    };
    const handleMouseEnter = ()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (annotationId) {
                if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter.emit('sethoveredannotation', annotationId);
                else eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, {
                    annotationId: annotationId
                });
                setIsAnnotatedTextHovered(true);
            }
        }
    };
    const handleMouseLeave = ()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (annotationId) {
                if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter.emit('removehoveredannotation', annotationId);
                else eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, {
                    annotationId: annotationId
                });
                setIsAnnotatedTextHovered(false);
            }
        }
    };
    const shouldShowCommentContentContext = annotatedText && isCommentsPanel && !isReply;
    const showContentUnavailableForDanglingComment = resolveProperties?.isDangling && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5a7cd205687b023$var$CommentContainer, {
        ref: containerRef,
        "data-comment-id": commentId,
        "data-testid": commentId,
        isFocused: isFocused,
        isRemoving: isRemoving,
        mode: mode,
        isCommentsPanel: isCommentsPanel,
        role: "article",
        tabIndex: -1,
        onMouseEnter: handleMouseEventOnWrapper('enter'),
        onMouseLeave: handleMouseEventOnWrapper('leave'),
        isFabricPage: isFabricPage,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? handleUnreadCommentRef : unreadCommentRef,
        "data-comment-id": commentId
    }, mode !== 'view' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5a7cd205687b023$var$RelativeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "overflow-container",
        ref: handleRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // We need to adjust the size of the border if we have a nested reply scroller below this
    , {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: !hideBranchingStyle ? {
            '--replyBranchHeight': `${replyBranchHeight + (adjustForNestedReplies ? 53 : 0)}px`
        } : {},
        className: (0, $gMc0m.default)([
            isReply && isCommentsPanel && !hideBranchingStyle && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_kqswh2mm _1n1j11qs _1kt9b3bt _1cs8stnw _qnec2bgk _1auk7vkz _kfgt1q5s _19wo1ul9 _syaypxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: showDefaultReplyStyle,
        customStyles: {
            ...isCommentsPanel ? {
                height: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? '28px' : '20px'
            } : {},
            // Have to adjust for padding on author (vs reply thread parent) with flag on
            ...isFooterComment ? {
                height: '25px'
            } : {},
            // Accounts for additional padding added to the author
            ...adjustForFooterNestedReplies ? {
                left: '-25px'
            } : {} // Accounts for the left border of the parent comment
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isFooterComment || isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? $c5a7cd205687b023$var$footerCommentAuthorStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "view",
        userId: userId,
        date: date,
        createdAtNonLocalized: createdAtNonLocalized,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        displayName: displayName,
        avatarUrl: avatarUrl,
        commentDateUrl: dateUrl,
        commentId: isCurrentUserAnonymous ? commentId : null,
        permissionType: permissionType,
        isInactiveComment: Boolean(mode === 'view-all' && !isCommentActive),
        showCopyLink: showingCopyLinkButton,
        resolveProperties: resolveProperties,
        isCommentsPanel: isCommentsPanel,
        isGeneralComments: commentType === (0, $8i27m.CommentType).GENERAL,
        isReply: isReply,
        isEdited: isEdited,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment
    }), (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `unread-comment-indicator-${commentId}`,
        // and the layout is recalculated, so we're using css to hide it instead
        style: {
            visibility: isHovered ? 'hidden' : 'visible'
        },
        "aria-hidden": isHovered || !isUnread,
        className: (0, $gMc0m.default)([
            "_ca0q1b66",
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_kqswh2mm _154iv77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $c5a7cd205687b023$var$dotBaseStyles,
            isUnread ? $c5a7cd205687b023$var$dotVisibleStyles : $c5a7cd205687b023$var$dotHiddenStyles
        ]
    })) : isUnread && !isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `unread-comment-indicator-${commentId}`,
        className: (0, $gMc0m.default)([
            "_ca0q1b66",
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_kqswh2mm _154iv77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c5a7cd205687b023$var$dotStyles
    })))))), shouldShowOverflowMenu && (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && hoveredActionItems, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_19pkutpp _18u0pxbi _19bv1ejb _u5f31b66",
            isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_18u0ze3t _19bvze3t",
            isCommentsPanel && !isReply && !hideBranchingStyle && (numReplies !== 0 || canAddComments) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_1kl711qs _n3tdu2gc",
            isFooterComment && isReply && "_19pku2gc",
            isFooterComment && isReply && replyHasNestedObjects && "_18u0u2gc",
            isStandaloneComment && isReply && "_19pku2gc",
            isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_19pku2gc"
        ])
    }, shouldShowCommentContentContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resolveProperties?.resolved && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && annotatedText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        xcss: [
            isResolvedByAnotherUser && $c5a7cd205687b023$var$xcssTranslucentStyle
        ],
        testId: "highlight-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c5a7cd205687b023$var$highlightSvgBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2f634d0f466224e4$export$77a2990571eb5aa2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle",
        size: "medium",
        maxLines: 1
    }, annotatedText)), contentType !== 'database' && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        xcss: [
            isResolvedByAnotherUser && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $c5a7cd205687b023$var$xcssTranslucentStyle
        ],
        testId: "highlight-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        "data-testId": "annotated-section-for-inlineComment",
        xcss: [
            showContentUnavailableForDanglingComment && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? $c5a7cd205687b023$var$danglingAnnotatedTextBodyStyle : $c5a7cd205687b023$var$annotatedTextBodyStyle,
            !isResolvedByAnotherUser && isAnnotatedTextHovered && !isAnnotatedTextPressed && !showContentUnavailableForDanglingComment && $c5a7cd205687b023$var$annotatedTextBodyHoverStyle,
            !isResolvedByAnotherUser && isAnnotatedTextPressed && !showContentUnavailableForDanglingComment && $c5a7cd205687b023$var$annotatedTextBodyWithPressedStyle
        ],
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseDown: ()=>{
            if (annotationId) setAnnotatedTextPressed && setAnnotatedTextPressed(true);
        },
        onMouseUp: handleMouseUp
    }, showContentUnavailableForDanglingComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d918c8bb7f43d99$export$a47b1fe1225a164), {
        annotatedText: annotatedText
    }) : annotatedText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        maxLines: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            background: getHighlightBackgroundColor(),
            borderBottom: isAnnotatedTextPressed || isSelected || isAnnotatedTextHovered || isThreadHovered && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? `2px solid ${"var(--ds-icon-accent-yellow, #B38600)"}` : ''
        }
    }, annotatedText))))), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isCommentsPanel && commentRemovedByAnotherUser && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_tzy41ssb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6FO3.CommentRenderer), {
        commentId: commentId,
        adf: adf,
        onContentFallback: onCommentContentFallback,
        isTruncatedContent: mode === 'view-all' && !isCommentActive,
        onRendered: onRendered,
        onComplete: onComplete,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        isInlineComment: true,
        isCommentsPanel: isCommentsPanel,
        isEdited: isEdited,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        commentType: commentType
    })), isDeletedByAnotherUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c5a7cd205687b023$var$warningMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "bold"
    }, formatMessage((0, $9CnRS.i18n).deletedCommentActionLabel))))), shouldShowOverflowMenu && isFabricPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && mainCommentActions, shouldShowOverflowMenu && (!isFabricPage || !((0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false))) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $21f8bd546279fd06$export$e75a036919cd8d68), {
        pageId: pageId,
        pageType: pageType,
        commentId: commentId,
        permissions: permissions,
        isReply: isReply,
        parentCommentId: parentCommentId,
        deleteComment: deleteComment,
        editComment: editComment,
        resolveComment: resolveComment,
        restrictEdit: hasFallbackContent,
        restrictDelete: Boolean(numReplies),
        numReplies: numReplies,
        isCommentActive: isCommentActive,
        mode: mode,
        commentDateUrl: dateUrl,
        onClose: onClose,
        overflowMenuPortal: overflowPortal,
        supportedActions: supportedActions,
        isCommentsPanel: isCommentsPanel,
        isHovered: isHovered,
        annotationId: annotationId,
        resolveProperties: resolveProperties,
        reopenComment: reopenComment,
        replyToComment: replyToComment,
        isUnread: isUnread,
        inheritedReactionsData: inheritedReactionsData,
        reactionsCacheUpdateFn: reactionsCacheUpdateFn,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        commentType: commentType,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        isSelected: isSelected,
        isParentCommentOpen: isParentCommentOpen,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment,
        isOffline: isOffline,
        isFabricPage: isFabricPage,
        isArchived: isArchived,
        authorName: displayName
    })));
};
module.exports["CommentBody"] = $c5a7cd205687b023$export$286a50103f692ed6;

});

parcelRegister("diR4K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2c20022de4565385e4b58b46e5a6984>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9af62080dd4cf644$var$_react = $9af62080dd4cf644$var$_interopRequireDefault((parcelRequire("42omo")));

var $9af62080dd4cf644$var$_baseNew = $9af62080dd4cf644$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9af62080dd4cf644$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowCurvedUpLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9af62080dd4cf644$var$ArrowCurvedUpLeftIcon = (props)=>/*#__PURE__*/ $9af62080dd4cf644$var$_react.default.createElement($9af62080dd4cf644$var$_baseNew.default, Object.assign({
        name: "ArrowCurvedUpLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 10a3 3 0 0 0-3-3H3.56l3.22 3.22-1.06 1.06-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5 1.06 1.06L3.56 5.5h6.94A4.5 4.5 0 0 1 15 10v5h-1.5z"/>`
    }, props));
$9af62080dd4cf644$var$ArrowCurvedUpLeftIcon.displayName = 'ArrowCurvedUpLeftIcon';
var $9af62080dd4cf644$var$_default = module.exports.default = $9af62080dd4cf644$var$ArrowCurvedUpLeftIcon;

});


//# sourceMappingURL=FullPageEditorComponent.650cee74.js.map
